$(document).ready(function () {

	$('#mbtiretr').show();
	setupTire();
	$(document).on('change', 'select:not(#mbtire), input', function () {
		// console.log('Change');
		setupTire();
	});
	$(document).on('change', 'select:not(#sm_magnets), input', function () {		
		$('#sm_magnets').trigger('change');
	});
	function setupTire() {
		var selected_to = document.getElementById("mbtire").value;
		var rim_size = $('#rim_size').val();
		var bike_model = $('#bike_model option:selected').text();
		var tire_options = [];

		// Extract only the numeric part of rim size (e.g. "18x2.15" => "2.15")
		rim_size = rim_size.split(' ')[1] || rim_size;

         // List of specific bike models that have exceptions for 110 tires
         var specific_bike_models = [
            'WR250R', 'CRF250L', 'CRF250L RALLY', 'CRF250L RALLY ABS', 'CRF250L Rally ABS',
            'CRF250L ABS', 'CRF300L', 'CRF300L ABS', 'CRF300L Rally', 'CRF300L RALLY ABS', 'CRF300L Rally ABS', 
        ];

        // List of specific bike models that have exceptions for big 17x5.00 160 tires
        var specific_largetire_bike_models = [
           '690 Enduro', '690 R', '790 Adventure', '790 Adventure R', '890 Adventure', '890 Adventure R', '1090 Adventure R', '1190 Adventure', '1290 Adventure', '1290 Super Adventure R', '1290 Super Adventure S',
           ];

        // Check conditions for rim sizes and bike models
        if (rim_size === '17x3.50') {
            if (specific_bike_models.includes(bike_model)) {
                // Specific bikes with Dunlop Sportmax GPR-300 110/70ZR17 and MICHELIN 2CT 110/70ZR17
                tire_options = [
                    'Bridgestone Battlax Hypersport S22 110/70-17',
                    'Continental ContiAttack SM2 110/70-17',
                    'Dunlop Sportmax Q5A 110/70-17', // Q5S
                    'Dunlop Sportmax GPR-300 110/70ZR17',
                    'Michelin Pilot Power 2CT 110/70ZR17'
                ];
            } else {
                // All other bikes with 17x3.50 rim size
                tire_options = [
                    'Bridgestone Battlax Hypersport S22 120/70-17',
                    'Continental ContiAttack SM2 120/70-17',
                    'Dunlop Sportmax Q5A 120/70-17', // Q5S
                    'Dunlop Sportmax GPR-300 120/70ZR17',
                    'Michelin Pilot Power 2CT 120/70R17',
                    'Michelin Power 5 120/70R17'
                ];
            }
        } else if (rim_size === '17x4.25' ) {
            // Tires for 17x4.25
            if (specific_bike_models.includes(bike_model)) {
               // Specific bikes with Dunlop Sportmax GPR-300 110/70ZR17 and MICHELIN 2CT 110/70ZR17
               tire_options = [
                   'Bridgestone Battlax Hypersport S22 150/60-17',
                   'Continental ContiAttack SM2 150/60-17',
                   'Dunlop Sportmax Q5A 150/60-17', // Q5S
                   'Dunlop Sportmax GPR-300 150/60ZR17',
                   'Michelin Pilot Power 2CT 150/60R17',
               ];
             }  else {
            tire_options = [
                'Bridgestone Battlax Hypersport S22 150/60-17',
                'Continental ContiAttack SM2 150/60-17',
                'Dunlop Sportmax Q5A 150/60-17', // Q5S
                'Dunlop Sportmax GPR-300 150/60ZR17',
                'Michelin Pilot Power 2CT 150/60R17',
                'Michelin Pilot Power 2CT 160/60R17'
            ];
           }
        }else if(rim_size === '17x5.00'){
           if (specific_largetire_bike_models.includes(bike_model)) {
               // Specific bikes that will fit a larger 160 sized tire
               tire_options = [
                   'Bridgestone Battlax Hypersport S22 150/60-17',
                   'Bridgestone Battlax Hypersport S22 160/60-17',
                   'Continental ContiAttack SM2 150/60-17',
                   'Continental ContiAttack SM2 160/60-17',
                   'Dunlop Sportmax GPR-300 150/60ZR17',
                   'Dunlop Sportmax Q5A 150/60-17', // Q5S
                   'Dunlop Sportmax Q5A 160/60-17', // Q5S
                   'Michelin Pilot Power 2CT 150/60R17',
                   'Michelin Pilot Power 2CT 160/60R17',
                   'Michelin Power 5 160/60ZR17'
               ];
           } else {
           // All other bikes with 17x5.00 rim size
            tire_options = [
                'Bridgestone Battlax Hypersport S22 150/60-17',
                'Continental ContiAttack SM2 150/60-17',
                'Dunlop Sportmax GPR-300 150/60ZR17',
                'Dunlop Sportmax Q5A 150/60-17', // Q5S
                'Michelin Pilot Power 2CT 150/60R17',
                'Michelin Pilot Power 2CT 160/60R17',
                'Michelin Power 5 160/60ZR17'
            ];
        }
        }
		// Update the select element with available tire options
		var selectElement = document.getElementById("mbtire");
		selectElement.innerHTML = '<option class="category" value="mbno">No</option>';

		tire_options.forEach(function (tireOption) {
			var option = document.createElement("option");
			option.value = tireOption;
			option.text = tireOption;
			if (tireOption == selected_to) {
				option.selected = true;
			}
			selectElement.add(option);
		});

		// console.log('Tire options:', tire_options);
	}

	function createDisclaimerMessage (message, messageContainer) {
		const p = document.createElement('p');
		const spanOuter = document.createElement('span');
		const spanInner = document.createElement('span');
		spanInner.classList.add('inner-span');
		spanInner.style.color = 'rgb(249, 7, 29)';
		spanOuter.appendChild(spanInner);
		p.appendChild(spanOuter);

		spanInner.textContent = message;
		messageContainer.appendChild(p);
	}

	// --- Brake Rotor Selector Logic ---
	$(document).on('change', 'select#bike_model', function () {
		const bikeModel = $(this).val();
		const $brakeRotor = $('#brake_rotor');
		const $brakeRotorRow = $brakeRotor.closest('tr');

		// Map of bike models and their specific rotor options
		const specificRotors = {
			// FRONT-ROTORS
			"701 Supermoto *FRONT*": [{ value: "320MM_FLOATING", label: "320mm Floating" }],
		};

		console.log('Selected bike model:', bikeModel);

		// Reset brake rotor field
		$brakeRotor.empty();
		$brakeRotorRow.hide();

		// Apply rotor options if a match exists
		if (specificRotors[bikeModel]) {
			specificRotors[bikeModel].forEach(obj => {
				const { value, label } = obj;
				console.log(`Matched rotor for ${bikeModel}:`, value);
	
				$brakeRotor.append(`<option value="${value}">${label}</option>`);
			})
			$brakeRotorRow.show();
		}
	});

	// --- Disclaimer message logic --- disclaimer-message
	$(document).on('change', 'select#bike_model', function () {
		const messageContainer = document.querySelector('.product-description');
		const bikeModel = $('select#bike_model').val();

		// Clear previous message
		const existing = messageContainer.querySelector('.inner-span');
		if (existing) existing.parentElement.parentElement.remove();

		switch (bikeModel) {
			case 'SMR 450 *FRONT*':
			case 'FS 450 *FRONT*':
				createDisclaimerMessage ('***Solid wheels only, No front rotor option***', messageContainer);
				break;
			case 'SMR 450 *REAR*':
			case 'FS 450 *REAR*':
			case 'SM700 *FRONT*':
			case 'SM700 *REAR*':
			case '701 Supermoto *FRONT*':
			case '701 Supermoto *REAR*':
				createDisclaimerMessage ('***Solid wheels only***', messageContainer);
				break;
			
			default:
				// Do nothing
				break;
		}
	});


	var role = $(".custom-variant-wrapper").attr('data-role');
	var images = "https://cdn.shopify.com/s/files/1/0676/2096/2552/files/tw-";
	var colorImages = "https://cdn.shopify.com/s/files/1/0676/2096/2552/files/";
	var new_base_price = 858;
	var base_price = 858;
	var dealerprice = 590;
	if (role == "true") {
		$('#price').text('$' + dealerprice);
	}
	//husqvarna = hq
	var hqf1 = 'CR 125 *FRONT*';
	var hqf2 = 'SM 125 *FRONT*';
	var hqf3 = 'TC125 *FRONT*';
	var hqf4 = 'TE 125 *FRONT*';
	var hqf5 = 'TX125 *FRONT*';
	var hqf6 = 'TXC 125 *FRONT*';
	var hqf7 = 'WR 125 *FRONT*';
	var hqf8 = 'TE150 *FRONT*';
	var hqf9 = 'FC 250 *FRONT*';
	var hqf10 = 'TC 250 *FRONT*';
	var hqf11 = 'FE 250 *FRONT*';
	var hqf12 = 'TE 250 *FRONT*';
	var hqf13 = 'TE250I *FRONT*';
	var hqf14 = 'SM 250 *FRONT*';
	var hqf15 = 'TXC 250 *FRONT*';
	var hqf16 = 'WR 250 *FRONT*';
	var hqf17 = 'CR 250 *FRONT*';
	var hqf18 = '2014 - 17 TE300 *FRONT*';
	var hqf19 = 'TE300I *FRONT*';
	var hqf20 = 'TX300 *FRONT*';
	var hqf21 = 'TX300i *FRONT*';
	var hqf22 = 'FC350 *FRONT*';
	var hqf23 = 'FE350 *FRONT*';
	var hqf24 = 'FX350 *FRONT*';
	var hqf25 = 'SM 449 *FRONT*';
	var hqf26 = 'TC 449 *FRONT*';
	var hqf27 = 'TE 449 *FRONT*';
	var hqf28 = 'TXC 449 *FRONT*';
	var hqf29 = 'WR 449 *FRONT*';
	var hqf30 = 'CR 449 *FRONT*';
	var hqf31 = 'CR 450 *FRONT*';
	var hqf32 = '2014 - 17 FC450 *FRONT*';
	var hqf33 = 'FC450 Rockstar Edition *FRONT*';
	var hqf34 = 'FE450 *FRONT*';
	var hqf35 = 'FX450 *FRONT*';
	var hqf36 = 'SM 450 *FRONT*';
	var hqf37 = 'TC 450 *FRONT*';
	var hqf38 = 'TE 450 *FRONT*';
	var hqf39 = 'TXC 450 *FRONT*';
	var hqf40 = 'WR 450 *FRONT*';
	var hqf41 = '2014 - 17 FE501 *FRONT*';
	var hqf42 = 'SM 510 *FRONT*';
	var hqf43 = 'TC 510 *FRONT*';
	var hqf44 = 'TE 510 *FRONT*';
	var hqf45 = 'TXC 510 *FRONT*';
	var hqf46 = 'WR 510 *FRONT*';
	var hqf47 = 'CR 510 *FRONT*';
	var hqf48 = 'SM 610 *FRONT*';
	var hqf49 = 'TC 610 *FRONT*';
	var hqf50 = 'TE 610 *FRONT*';
	var hqf51 = 'TXC 610 *FRONT*';
	var hqf52 = 'WR 610 *FRONT*';
	var hqf53 = 'CR 610 *FRONT*';
	var hqf54 = '701 Enduro ABS *FRONT*';
	var hqr1 = 'CR 125 *REAR*';
	var hqr2 = 'SM 125 *REAR*';
	var hqr3 = '2014 - 17 TC125 *REAR*';
	var hqr4 = 'TE 125 *REAR*';
	var hqr5 = 'TX125 *REAR*';
	var hqr6 = 'TXC 125 *REAR*';
	var hqr7 = 'WR 125 *REAR*';
	var hqr8 = 'TE150 *REAR*';
	var hqr9 = '2014 - 17 FC 250 *REAR*';
	var hqr10 = '2014 - 17 TC 250 *REAR*';
	var hqr11 = '2014 - 17 FE 250 *REAR*';
	var hqr12 = '2014 - 17 TE 250 *REAR*';
	var hqr13 = 'TE250I *REAR*';
	var hqr14 = 'SM 250 *REAR*';
	var hqr15 = 'TXC 250 *REAR*';
	var hqr16 = 'WR 250 *REAR*';
	var hqr17 = 'CR 250 *REAR*';
	var hqr18 = '2014 - 17 TE300 *REAR*';
	var hqr19 = 'TE300I *REAR*';
	var hqr20 = 'TX300 *REAR*';
	var hqr21 = 'TX300i *REAR*';
	var hqr22 = 'FC350 *REAR*';
	var hqr23 = 'FE350 *REAR*';
	var hqr24 = 'FX350 *REAR*';
	var hqr25 = 'SM 449 *REAR*';
	var hqr26 = 'TC 449 *REAR*';
	var hqr27 = 'TE 449 *REAR*';
	var hqr28 = 'TXC 449 *REAR*';
	var hqr29 = 'WR 449 *REAR*';
	var hqr30 = 'CR 449 *REAR*';
	var hqr31 = 'CR 450 *REAR*';
	var hqr32 = '2014 - 17 FC450 *REAR*';
	var hqr33 = 'FC450 Rockstar Edition *REAR*';
	var hqr34 = 'FE450 *REAR*';
	var hqr35 = 'FX450 *REAR*';
	var hqr36 = 'SM 450 *REAR*';
	var hqr37 = 'TC 450 *REAR*';
	var hqr38 = 'TE 450 *REAR*';
	var hqr39 = 'TXC 450 *REAR*';
	var hqr40 = 'WR 450 *REAR*';
	var hqr41 = '2014 - 17 FE501 *REAR*';
	var hqr42 = 'SM 510 *REAR*';
	var hqr43 = 'TC 510 *REAR*';
	var hqr44 = 'TE 510 *REAR*';
	var hqr45 = 'TXC 510 *REAR*';
	var hqr46 = 'WR 510 *REAR*';
	var hqr47 = 'CR 510 *REAR*';
	var hqr48 = 'SM 610 *REAR*';
	var hqr49 = 'TC 610 *REAR*';
	var hqr50 = 'TE 610 *REAR*';
	var hqr51 = 'TXC 610 *REAR*';
	var hqr52 = 'WR 610 *REAR*';
	var hqr53 = 'CR 610 *REAR*';
	var hqr54 = '701 Enduro ABS *REAR*';
	//honda = hn
	var hnf1 = '1995 - 99 CR125, CR250 *FRONT*';
	var hnf2 = '2000 - 11 CR125, CR250 *FRONT*';
	var hnf3 = '2017+ CRF250L *FRONT*';
	var hnf4 = 'CRF250L ABS *FRONT*';
	var hnf5 = '2017+ CRF250L Rally *FRONT*';
	var hnf6 = '2004 - 14 CRF250R *FRONT*';
	var hnf7 = '2004 - 2017 CRF250X *FRONT*';
	var hnf8 = 'CRF250RX *FRONT*';
	var hnf9 = '1996 - 04 XR400 *FRONT*';
	var hnf10 = '2002 - 14 CRF450R *FRONT*';
	var hnf11 = 'CRF450R Works Edition *FRONT*';
	var hnf12 = 'CRF450L *FRONT*';
	var hnf13 = '2003 - 2017 CRF450X *FRONT*';
	var hnf14 = '2017+  CRF450RX *FRONT*';
	var hnf15 = '1995 - 01 CR500 *FRONT*';
	var hnf16 = '1991 - 00 XR600 *FRONT*';
	var hnf17 = '1993 - 2017 XR650L *FRONT*';
	var hnf18 = '2000 - 08 XR650R *FRONT*';
	var hnf19 = '2016 - 2017 CRF1000L *FRONT*';
	var hnf20 = 'CRF450RL *FRONT*';
	var hnr1 = '1989 - 97 CR125, CR250 *REAR*';
	var hnr2 = '2000 - 12 CR125, CR250 *REAR*';
	var hnr3 = '2017+ CRF250L *REAR*';
	var hnr4 = 'CRF250L ABS *REAR*';
	var hnr5 = '2017+ CRF250L Rally *REAR*';
	var hnr6 = '2004 - 13 CRF250R *REAR*';
	var hnr7 = '2004 - 2017 CRF250X *REAR*';
	var hnr8 = 'CRF250RX *REAR*';
	var hnr9 = '1996 - 04 XR 400 *REAR*';
	var hnr10 = '2002 - 12 CRF450R *REAR*';
	var hnr11 = 'CRF450R Works Edition *REAR*';
	var hnr12 = 'CRF450L *REAR*';
	var hnr20 = 'CRF450RL *REAR*';
	var hnr13 = '2002 - 2017 CRF450X *REAR*';
	var hnr14 = '2017+ CRF450RX *REAR*';
	var hnr15 = '1989 - 01 CR500 *REAR*';
	var hnr16 = '1993 - 00 XR600 *REAR*';
	var hnr17 = '1993 - 2017 XR650L *REAR*';
	var hnr18 = '2000 - 08 XR650R *REAR*';
	var hnr19 = '2016 - 2017 CRF1000L *REAR*';
	//honda = hn
	var hnf1 = '1995 - 99 CR125, CR250 *FRONT*';
	var hnf2 = '2000 - 11 CR125, CR250 *FRONT*';
	var hnf3 = '2017+ CRF250L *FRONT*';
	var hnf4 = 'CRF250L ABS *FRONT*';
	var hnf5 = '2017+ CRF250L Rally *FRONT*';
	var hnf6 = '2004 - 14 CRF250R *FRONT*';
	var hnf7 = '2004 - 2017 CRF250X *FRONT*';
	var hnf8 = 'CRF250RX *FRONT*';
	var hnf9 = '1996 - 04 XR400 *FRONT*';
	var hnf10 = '2002 - 14 CRF450R *FRONT*';
	var hnf11 = 'CRF450R Works Edition *FRONT*';
	var hnf12 = 'CRF450L *FRONT*';
	var hnf13 = '2003 - 2017 CRF450X *FRONT*';
	var hnf14 = '2017+  CRF450RX *FRONT*';
	var hnf15 = '1995 - 01 CR500 *FRONT*';
	var hnf16 = '1991 - 00 XR600 *FRONT*';
	var hnf17 = '1993 - 2017 XR650L *FRONT*';
	var hnf18 = '2000 - 08 XR650R *FRONT*';
	var hnf19 = '2016 - 2017 CRF1000L *FRONT*';
	var hnf20 = 'CRF450RL *FRONT*';
	var hnr1 = '1989 - 97 CR125, CR250 *REAR*';
	var hnr2 = '2000 - 12 CR125, CR250 *REAR*';
	var hnr3 = '2017+ CRF250L *REAR*';
	var hnr4 = 'CRF250L ABS *REAR*';
	var hnr5 = '2017+ CRF250L Rally *REAR*';
	var hnr6 = '2004 - 13 CRF250R *REAR*';
	var hnr7 = '2004 - 2017 CRF250X *REAR*';
	var hnr8 = 'CRF250RX *REAR*';
	var hnr9 = '1996 - 04 XR 400 *REAR*';
	var hnr10 = '2002 - 12 CRF450R *REAR*';
	var hnr11 = 'CRF450R Works Edition *REAR*';
	var hnr12 = 'CRF450L *REAR*';
	var hnr20 = 'CRF450RL *REAR*';
	var hnr13 = '2002 - 2017 CRF450X *REAR*';
	var hnr14 = '2017+ CRF450RX *REAR*';
	var hnr15 = '1989 - 01 CR500 *REAR*';
	var hnr16 = '1993 - 00 XR600 *REAR*';
	var hnr17 = '1993 - 2017 XR650L *REAR*';
	var hnr18 = '2000 - 08 XR650R *REAR*';
	var hnr19 = '2016 - 2017 CRF1000L *REAR*';
	//ktm = ktm
	var ktmf1 = 'EXC125 *FRONT*';
	var ktmf2 = 'EXC200 *FRONT*';
	var ktmf3 = 'EXC-F250 *FRONT*';
	var ktmf4 = 'XCF-W250 *FRONT*';
	var ktmf5 = 'EXC300 *FRONT*';
	var ktmf6 = 'EXC350 *FRONT*';
	var ktmf7 = 'XC-W300 TPI *FRONT*';
	var ktmf8 = 'EXC-F350 *FRONT*';
	var ktmf9 = 'EXC380 *FRONT*';
	var ktmf10 = 'EXC400 *FRONT*';
	var ktmf11 = 'EXC450 *FRONT*';
	var ktmf12 = 'EXC-F450 *FRONT*';
	var ktmf13 = 'EXC-F500 *FRONT*';
	var ktmf14 = 'EXC520 *FRONT*';
	var ktmf15 = 'EXC525 *FRONT*';
	var ktmf16 = 'EXC530 *FRONT*';
	var ktmf17 = 'EXC-R530 *FRONT*';
	var ktmf18 = 'XC150 *FRONT*';
	var ktmf19 = 'XC-W150 *FRONT*';
	var ktmf20 = 'XC200 *FRONT*';
	var ktmf21 = 'XC-W200 *FRONT*';
	var ktmf22 = 'XC250 *FRONT*';
	var ktmf23 = 'XC250 TPI *FRONT*';
	var ktmf24 = 'XC-W250 *FRONT*';
	var ktmf25 = 'XC-W250 TPI *FRONT*';
	var ktmf26 = 'XC-F250 *FRONT*';
	var ktmf27 = 'XC300 *FRONT*';
	var ktmf28 = 'XC300 TPI *FRONT*';
	var ktmf29 = 'XC-W300 *FRONT*';
	var ktmf30 = 'XC-W300 TPI Six Days *FRONT*';
	var ktmf31 = 'XC-F350 *FRONT*';
	var ktmf32 = 'XCF-W350 *FRONT*';
	var ktmf33 = 'XC400 *FRONT*';
	var ktmf34 = 'XC-W400 *FRONT*';
	var ktmf35 = 'XC-F450 *FRONT*';
	var ktmf36 = 'XC450 *FRONT*';
	var ktmf37 = 'XC-W450 *FRONT*';
	var ktmf38 = 'XC-W500 *FRONT*';
	var ktmf39 = 'XC-F505 *FRONT*';
	var ktmf40 = 'XC525 *FRONT*';
	var ktmf41 = 'XC-W525 *FRONT*';
	var ktmf42 = 'XC530 *FRONT*';
	var ktmf43 = 'XC-W530 *FRONT*';
	var ktmf44 = 'SX125 *FRONT*';
	var ktmf45 = 'SX144 *FRONT*';
	var ktmf46 = 'SX150 *FRONT*';
	var ktmf47 = 'SX200 *FRONT*';
	var ktmf48 = 'SX250 *FRONT*';
	var ktmf49 = 'SXF250 *FRONT*';
	var ktmf50 = 'SXF350 *FRONT*';
	var ktmf51 = 'SX380 *FRONT*';
	var ktmf52 = 'SX400 *FRONT*';
	var ktmf53 = 'SXC400 *FRONT*';
	var ktmf54 = 'SX450 *FRONT*';
	var ktmf55 = 'SX-RFS450 *FRONT*';
	var ktmf56 = 'SX-F450 *FRONT*';
	var ktmf57 = 'SX-F450 Factory Edition *FRONT*';
	var ktmf58 = 'SX-F505 *FRONT*';
	var ktmf59 = 'SX520 *FRONT*';
	var ktmf60 = 'SX525 *FRONT*';
	var ktmf61 = 'SXC625 *FRONT*';
	var ktmf62 = '690 Enduro *FRONT*';
	var ktmf63 = '690 Enduro ABS *FRONT*';
	var ktmf64 = '790 Adventure *FRONT*';
	var ktmf65 = '790 Adventure R *FRONT*';
	var ktmf66 = '950 Adventure *FRONT*';
	var ktmf67 = '990 Adventure *FRONT*';
	var ktmf68 = '1090 Adventure *FRONT*';
	var ktmf69 = '1190 Adventure *FRONT*';
	var ktmf70 = '1290 Adventure ABS *FRONT*';
	var ktmf71 = '1290 Adventure R *FRONT*';
	var ktmf72 = '1290 Super Adventure S *FRONT*';
	var ktmf73 = '690 Enduro ABS *FRONT*';

	var ktmr1 = 'EXC125 *REAR*';
	var ktmr2 = 'EXC200 *REAR*';
	var ktmr3 = 'EXC-F250 *REAR*';
	var ktmr4 = 'XCF-W250 *REAR*';
	var ktmr5 = 'EXC300 *REAR*';
	var ktmr6 = 'EXC350 *REAR*';
	var ktmr7 = 'XC-W300 TPI *REAR*';
	var ktmr8 = 'EXC-F350 *REAR*';
	var ktmr9 = 'EXC380 *REAR*';
	var ktmr10 = 'EXC400 *REAR*';
	var ktmr11 = 'EXC450 *REAR*';
	var ktmr12 = 'EXC-F450 *REAR*';
	var ktmr13 = 'EXC-F500 *REAR*';
	var ktmr14 = 'EXC520 *REAR*';
	var ktmr15 = 'EXC525 *REAR*';
	var ktmr16 = 'EXC530 *REAR*';
	var ktmr17 = 'EXC530 *REAR*';
	var ktmr18 = 'EXC-R530 *REAR*';
	var ktmr19 = 'XC150 *REAR*';
	var ktmr20 = 'XC-W150 *REAR*';
	var ktmr21 = 'XC200 *REAR*';
	var ktmr22 = 'XC-W200 *REAR*';
	var ktmr23 = 'XC250 *REAR*';
	var ktmr24 = 'XC250 TPI *REAR*';
	var ktmr25 = 'XC-W250 *REAR*';
	var ktmr26 = 'XC-W250 TPI *REAR*';
	var ktmr27 = 'XC-F250 *REAR*';
	var ktmr28 = 'XC300 *REAR*';
	var ktmr29 = 'XC300 TPI *REAR*';
	var ktmr30 = 'XC-W300 *REAR*';
	var ktmr31 = 'XC-W300 TPI Six Days *REAR*';
	var ktmr32 = 'XC-F350 *REAR*';
	var ktmr33 = 'XCF-W350 *REAR*';
	var ktmr34 = 'XC400 *REAR*';
	var ktmr35 = 'XC-W400 *REAR*';
	var ktmr36 = 'XC-F450 *REAR*';
	var ktmr37 = 'XC450 *REAR*';
	var ktmr38 = 'XC-W450 *REAR*';
	var ktmr39 = 'XC-W500 *REAR*';
	var ktmr40 = 'XC-F505 *REAR*';
	var ktmr41 = 'XC525 *REAR*';
	var ktmr42 = 'XC-W525 *REAR*';
	var ktmr43 = 'XC530 *REAR*';
	var ktmr44 = 'XC-W530 *REAR*';
	var ktmr45 = 'SX125 *REAR*';
	var ktmr46 = 'SX144 *REAR*';
	var ktmr47 = 'SX150 *REAR*';
	var ktmr48 = 'SX200 *REAR*';
	var ktmr49 = 'SX250 *REAR*';
	var ktmr50 = 'SXF250 *REAR*';
	var ktmr51 = 'SXF350 *REAR*';
	var ktmr52 = 'SX380 *REAR*';
	var ktmr53 = 'SX400 *REAR*';
	var ktmr54 = 'SXC400 *REAR*';
	var ktmr55 = 'SX450 *REAR*';
	var ktmr56 = 'SX-RFS450 *REAR*';
	var ktmr57 = 'SX-F450 *REAR*';
	var ktmr58 = 'SX-F450 Factory Edition *REAR*';
	var ktmr59 = 'SX-F505 *REAR*';
	var ktmr60 = 'SX520 *REAR*';
	var ktmr61 = 'SX525 *REAR*';
	var ktmr62 = 'SXC625 *REAR*';
	var ktmr63 = '2008 – 2013 KTM 690 ENDURO * REAR *';
	var ktmr64 = '2014 – 2017 KTM 690 ENDURO ABS * REAR *';
	var ktmr65 = '790 Adventure *REAR*';
	var ktmr66 = '790 Adventure R *REAR*';
	var ktmr67 = '950 Adventure *REAR*';
	var ktmr68 = '990 Adventure *REAR*';
	var ktmr69 = '1090 Adventure *REAR*';
	var ktmr70 = '1190 Adventure *REAR*';
	var ktmr71 = '1290 Adventure ABS *REAR*';
	var ktmr72 = '1290 Adventure R *REAR*';
	var ktmr73 = '1290 Super Adventure S *REAR*';
	var ktmr74 = '2014 – 2017 KTM 690 ENDURO ABS * REAR *';

	//Change Magnet Images and Price Increase
	var magnet_change = function () {
		var magnet = $('select#sm_magnets').val();
		if (magnet != "NO") {
			$("#resultAreaID_1_7").addClass("show");
			var image_name = images + "magnet-" + $('select#sm_magnets').val() + '-' + $('select#wheel_type').val() + ".png";
			var imageArr6 = [image_name];
			var divArr6 = ["resultAreaID_1_7"];
			// imageObj6 = new BL_ImageLoader(divArr6,imageArr6);
			$('#resultAreaID_1_7 img').attr('src', image_name);
		} else if (magnet == "NO") {
			$("#resultAreaID_1_7").hide();
			$("#resultAreaID_1_7").removeClass("show");
		} else {}
	}

	//Sprocket Hide Function
	function sprockethide() {
		if ($('select#sprocket_size').val() == "no") {
			$('#resultAreaID_1_7').removeClass("show");
		} else {
			$('#resultAreaID_1_7').addClass("show");
		}
	}

	function nipplespokecolor() {
		if ($('select#bike_model').val() == "790 Adventure *FRONT*" || $('select#bike_model').val() == "790 Adventure R *FRONT*" || $('select#bike_model').val() == "890 Adventure *FRONT*" || $('select#bike_model').val() == "890 Adventure R *FRONT*" || $('select#bike_model').val() == "950 Adventure *FRONT*" || $('select#bike_model').val() == "990 Adventure *FRONT*" || $('select#bike_model').val() == "1090 Adventure *FRONT*" || $('select#bike_model').val() == "1190 Adventure *FRONT*" || $('select#bike_model').val() == "1290 Adventure ABS *FRONT*" || $('select#bike_model').val() == "1290 Adventure R *FRONT*" || $('select#bike_model').val() == "1290 Super Adventure S *FRONT*" || $('select#bike_model').val() == "790 Adventure *REAR*" || $('select#bike_model').val() == "790 Adventure R *REAR*" || $('select#bike_model').val() == "890 Adventure *REAR*" || $('select#bike_model').val() == "890 Adventure R *REAR*" || $('select#bike_model').val() == "950 Adventure *REAR*" || $('select#bike_model').val() == "990 Adventure *REAR*" || $('select#bike_model').val() == "1090 Adventure *REAR*" || $('select#bike_model').val() == "1190 Adventure *REAR*" || $('select#bike_model').val() == "1290 Adventure ABS *REAR*" || $('select#bike_model').val() == "1290 Adventure R *REAR*" || $('select#bike_model').val() == "1290 Super Adventure S *REAR*" || $('select#bike_model').val() == "2016 - 2017 CRF1000L *FRONT*" || $('select#bike_model').val() == "2016 - 2017 CRF1000L *REAR*") {
			var spoke_color_wrapper = $('.spoke_color_wrapper');
			spoke_color_wrapper.empty().append(`<div class="color-swatch active" data-value="Silver" style="background: url(${colorImages}silver.svg?v=1717478021);"></div><div class="color-swatch" data-value="Black" style="background: url(${colorImages}black.svg?v=1717478021);"></div>`);
			var image_name = images + "spokes-" + $('#spoke_color').val() + "-" + $('select#wheel_type').val() + ".png";
			$('#resultAreaID_1_2 img').attr('src', image_name);
		}
		if ($('select#rim_size').val() == "REAR 19x3.00") {
			// var select = $('#spoke_color');
			// select.empty().append('<option value="Silver">Silver</option>');
			var rim_color_wrapper = $('.rim_color_wrapper');
			rim_color_wrapper.empty().append(`<div class="color-swatch active" data-value="Silver" style="background: url(${colorImages}silver.svg?v=1717478021);">`);
			var image_name = images + "spokes-" + $('#spoke_color').val() + "-" + $('select#wheel_type').val() + ".png";
			$('#resultAreaID_1_2 img').attr('src', image_name);
		}
	}

	//Nipple Color depends upon Spoke Color
	function nipplecolorreset() {
		if (($('select#bike_model').val() == "790 Adventure *FRONT*" || $('select#bike_model').val() == "790 Adventure R *FRONT*" || $('select#bike_model').val() == "890 Adventure *FRONT*" || $('select#bike_model').val() == "890 Adventure R *FRONT*" || $('select#bike_model').val() == "950 Adventure *FRONT*" || $('select#bike_model').val() == "990 Adventure *FRONT*" || $('select#bike_model').val() == "1090 Adventure *FRONT*" || $('select#bike_model').val() == "1190 Adventure *FRONT*" || $('select#bike_model').val() == "1290 Adventure ABS *FRONT*" || $('select#bike_model').val() == "1290 Adventure R *FRONT*" || $('select#bike_model').val() == "1290 Super Adventure S *FRONT*" || $('select#bike_model').val() == "790 Adventure *REAR*" || $('select#bike_model').val() == "790 Adventure R *REAR*" || $('select#bike_model').val() == "890 Adventure *REAR*" || $('select#bike_model').val() == "890 Adventure R *REAR*" || $('select#bike_model').val() == "950 Adventure *REAR*" || $('select#bike_model').val() == "990 Adventure *REAR*" || $('select#bike_model').val() == "1090 Adventure *REAR*" || $('select#bike_model').val() == "1190 Adventure *REAR*" || $('select#bike_model').val() == "1290 Adventure ABS *REAR*" || $('select#bike_model').val() == "1290 Adventure R *REAR*" || $('select#bike_model').val() == "1290 Super Adventure S *REAR*" || $('select#bike_model').val() == "2016 - 2017 CRF1000L *FRONT*" || $('select#bike_model').val() == "2016 - 2017 CRF1000L *REAR*") || $('select#rim_size').val() == "REAR 19x3.00") {
			if ($('#spoke_color').val() == "Silver") {
				var nipple_color_wrapper = $('.nipple_color_wrapper');
				nipple_color_wrapper.empty().append(`<div class="color-swatch active" data-value="Silver" style="background: url(${colorImages}silver.svg?v=1717478021);">`);
				var image_name = images + "nipple-" + $('#nipple_color').val() + "-" + $('select#wheel_type').val() + ".png";
				$('#resultAreaID_1_3 img').attr('src', image_name);
			} else {
				var select = $('#nipple_color');
				// select.empty().append('<option class="category" value="Silver">Silver</option><option class="category" value="Black">Black</option><option class="category" value="Red">Red</option><option class="category" value="Blue">Blue</option><option class="category" value="Orange">Orange</option><option class="category" value="Green">Green</option><option class="category" value="Gold">Gold</option><option class="category" value="Purple">Purple</option><option class="category" value="Magnesium">Magnesium</option>');
			}
		}
	}


	var spoketitanium = function () {
		//Titanium Spoke Color Code
		//Bike Make 

		var bike = $('select#bike_year').val();
		var bikemodel = $('select#bike_model').val();
		if ($('select#bike_make').val() == "Husqvarna") {
			if (bikemodel == hqf1 || bikemodel == hqf2 || bikemodel == hqf3 || bikemodel == hqf4 || bikemodel == hqf5 || bikemodel == hqf6 || bikemodel == hqf7 || bikemodel == hqf8 || bikemodel == hqf9 || bikemodel == hqf10 || bikemodel == hqf11 || bikemodel == hqf12 || bikemodel == hqf13 || bikemodel == hqf14 || bikemodel == hqf15 || bikemodel == hqf16 || bikemodel == hqf17 || bikemodel == hqf18 || bikemodel == hqf19 || bikemodel == hqf20 || bikemodel == hqf21 || bikemodel == hqf22 || bikemodel == hqf23 || bikemodel == hqf24 || bikemodel == hqf25 || bikemodel == hqf26 || bikemodel == hqf27 || bikemodel == hqf28 || bikemodel == hqf29 || bikemodel == hqf30 || bikemodel == hqf31 || bikemodel == hqf32 || bikemodel == hqf33 || bikemodel == hqf34 || bikemodel == hqf35 || bikemodel == hqf36 || bikemodel == hqf37 || bikemodel == hqf38 || bikemodel == hqf39 || bikemodel == hqf40 || bikemodel == hqf41 || bikemodel == hqr1 || bikemodel == hqr2 || bikemodel == hqr3 || bikemodel == hqr4 || bikemodel == hqr5 || bikemodel == hqr6 || bikemodel == hqr7 || bikemodel == hqr8 || bikemodel == hqr9 || bikemodel == hqr10 || bikemodel == hqr11 || bikemodel == hqr12 || bikemodel == hqr13 || bikemodel == hqr14 || bikemodel == hqr15 || bikemodel == hqr16 || bikemodel == hqr17 || bikemodel == hqr18 || bikemodel == hqr19 || bikemodel == hqr20 || bikemodel == hqr21 || bikemodel == hqr22 || bikemodel == hqr23 || bikemodel == hqr24 || bikemodel == hqr25 || bikemodel == hqr26 || bikemodel == hqr27 || bikemodel == hqr28 || bikemodel == hqr29 || bikemodel == hqr30 || bikemodel == hqr31 || bikemodel == hqr32 || bikemodel == hqr33 || bikemodel == hqr34 || bikemodel == hqr35 || bikemodel == hqr36 || bikemodel == hqr37 || bikemodel == hqr38 || bikemodel == hqr39 || bikemodel == hqr40 || bikemodel == hqr41) {
				if (bike >= 2014 & bike <= 2020) {
					if ($('select#rim_size').val() == "FRONT 21x1.60" || $('select#rim_size').val() == "REAR 18x2.15" || $('select#rim_size').val() == "REAR 19x2.15" || $('select#rim_size').val() == "REAR 18x2.50" || $('select#rim_size').val() == "REAR 19x2.50" || $('select#rim_size').val() == "18X2.50 (OEM SIZE)") {
						var select = $('.spoke_color_wrapper');
						select.empty().append(`<div class="color-swatch active" data-value="Silver" style="background: url(${colorImages}silver.svg?v=1717478021);"></div><div class="color-swatch" data-value="Black" style="background: url(${colorImages}black.svg?v=1717478021);"></div><div class="color-swatch" data-value="Blue" style="background: url(${colorImages}blue.svg?v=1717478021);"></div><div class="color-swatch" data-value="Green" style="background: url(${colorImages}green.svg?v=1717478021);"></div><div class="color-swatch" data-value="Orange" style="background: url(${colorImages}orange.svg?v=1717478021);"></div><div class="color-swatch" data-value="Red" style="background: url(${colorImages}red.svg?v=1717478021);"></div><div class="color-swatch" data-value="White" style="background: url(${colorImages}white.svg?v=1717478021);"></div><div class="color-swatch" data-value="Yellow" style="background: url(${colorImages}yellow.svg?v=1717478021);"></div><div class="color-swatch" data-value="Flo-Yellow" style="background: url(${colorImages}flo-yellow.svg?v=1717478021);"></div><div class="color-swatch" data-value="Titanium" style="background: url(${colorImages}titanium.svg?v=1717478021);"></div>
`);
					} else if ($('select#rim_size').val() != "REAR 19x3.00") {
						var select = $('.spoke_color_wrapper');
						select.empty().append(`<div class="color-swatch active" data-value="Silver" style="background: url(${colorImages}silver.svg?v=1717478021);">Silver</div><div class="color-swatch" data-value="Black" style="background: url(${colorImages}black.svg?v=1717478021);">Black</div><div class="color-swatch" data-value="Blue" style="background: url(${colorImages}blue.svg?v=1717478021);">Blue</div><div class="color-swatch" data-value="Green" style="background: url(${colorImages}green.svg?v=1717478021);">Green</div><div class="color-swatch" data-value="Orange" style="background: url(${colorImages}orange.svg?v=1717478021);">Orange</div><div class="color-swatch" data-value="Red" style="background: url(${colorImages}red.svg?v=1717478021);">Red</div><div class="color-swatch" data-value="White" style="background: url(${colorImages}white.svg?v=1717478021);">White</div><div class="color-swatch" data-value="Yellow" style="background: url(${colorImages}yellow.svg?v=1717478021);">Yellow</div><div class="color-swatch" data-value="Flo-Yellow" style="background: url(${colorImages}flo-yellow.svg?v=1717478021);">Flo Yellow</div>
`);
					}
				}

			}

		} else if ($('select#bike_make').val() == "Honda" || $('select#bike_make').val() == "KTM" || $('select#bike_make').val() == "Kawasaki" || $('select#bike_make').val() == "Yamaha") {
			if (bikemodel == hnf1 || bikemodel == hnf2 || bikemodel == hnf6 || bikemodel == hnf7 || bikemodel == hnf8 || bikemodel == hnf9 || bikemodel == hnf10 || bikemodel == hnf11 || bikemodel == hnf12 || bikemodel == hnf20 || bikemodel == hnf13 || bikemodel == hnf14 || bikemodel == hnr1 || bikemodel == hnr2 || bikemodel == hnr6 || bikemodel == hnr7 || bikemodel == hnr8 || bikemodel == hnr9 || bikemodel == hnr10 || bikemodel == hnr11 || bikemodel == hnr12 || bikemodel == hnr13 || bikemodel == hnr14 || bikemodel == ktmf1 || bikemodel == ktmf2 || bikemodel == ktmf3 || bikemodel == ktmf4 || bikemodel == ktmf5 || bikemodel == ktmf6 || bikemodel == ktmf7 || bikemodel == ktmf8 || bikemodel == ktmf9 || bikemodel == ktmf10 || bikemodel == ktmf11 || bikemodel == ktmf12 || bikemodel == ktmf13 || bikemodel == ktmf14 || bikemodel == ktmf15 || bikemodel == ktmf16 || bikemodel == ktmf17 || bikemodel == ktmf18 || bikemodel == ktmf19 || bikemodel == ktmf20 || bikemodel == ktmf21 || bikemodel == ktmf22 || bikemodel == ktmf23 || bikemodel == ktmf24 || bikemodel == ktmf25 || bikemodel == ktmf26 || bikemodel == ktmf27 || bikemodel == ktmf28 || bikemodel == ktmf29 || bikemodel == ktmf30 || bikemodel == ktmf31 || bikemodel == ktmf32 || bikemodel == ktmf33 || bikemodel == ktmf34 || bikemodel == ktmf35 || bikemodel == ktmf36 || bikemodel == ktmf37 || bikemodel == ktmf38 || bikemodel == ktmf39 || bikemodel == ktmf40 || bikemodel == ktmf41 || bikemodel == ktmf42 || bikemodel == ktmf43 || bikemodel == ktmf44 || bikemodel == ktmf45 || bikemodel == ktmf46 || bikemodel == ktmf47 || bikemodel == ktmf48 || bikemodel == ktmf49 || bikemodel == ktmf50 || bikemodel == ktmf51 || bikemodel == ktmf52 || bikemodel == ktmf53 || bikemodel == ktmf54 || bikemodel == ktmf55 || bikemodel == ktmf56 || bikemodel == ktmf57 || bikemodel == ktmf58 || bikemodel == ktmf59 || bikemodel == ktmf60 || bikemodel == ktmr1 || bikemodel == ktmr2 || bikemodel == ktmr3 || bikemodel == ktmr4 || bikemodel == ktmr5 || bikemodel == ktmr6 || bikemodel == ktmr7 || bikemodel == ktmr8 || bikemodel == ktmr9 || bikemodel == ktmr10 || bikemodel == ktmr11 || bikemodel == ktmr12 || bikemodel == ktmr13 || bikemodel == ktmr14 || bikemodel == ktmr15 || bikemodel == ktmr16 || bikemodel == ktmr17 || bikemodel == ktmr18 || bikemodel == ktmr19 || bikemodel == ktmr20 || bikemodel == ktmr21 || bikemodel == ktmr22 || bikemodel == ktmr23 || bikemodel == ktmr24 || bikemodel == ktmr25 || bikemodel == ktmr26 || bikemodel == ktmr27 || bikemodel == ktmr28 || bikemodel == ktmr29 || bikemodel == ktmr30 || bikemodel == ktmr31 || bikemodel == ktmr32 || bikemodel == ktmr33 || bikemodel == ktmr34 || bikemodel == ktmr35 || bikemodel == ktmr36 || bikemodel == ktmr37 || bikemodel == ktmr38 || bikemodel == ktmr39 || bikemodel == ktmr40 || bikemodel == ktmr41 || bikemodel == ktmr42 || bikemodel == ktmr43 || bikemodel == ktmr44 || bikemodel == ktmr45 || bikemodel == ktmr46 || bikemodel == ktmr47 || bikemodel == ktmr48 || bikemodel == ktmr49 || bikemodel == ktmr50 || bikemodel == ktmr51 || bikemodel == ktmr52 || bikemodel == ktmr53 || bikemodel == ktmr54 || bikemodel == ktmr55 || bikemodel == ktmr56 || bikemodel == ktmr57 || bikemodel == ktmr58 || bikemodel == ktmr59 || bikemodel == ktmr60 || bikemodel == ktmr61 || bikemodel == "2003 - 05 KX125 *FRONT*" || bikemodel == "2003 - 13 KX250 *FRONT*" || bikemodel == "2004 - 14 KX250F  *FRONT*" || bikemodel == "KX250XC *FRONT*" || bikemodel == "2006 - 14 KX450F/KLX450R *FRONT*" || bikemodel == "KX450XC *FRONT*" || bikemodel == "KLX 300R *FRONT*" || bikemodel == "KLX450R *FRONT*" || bikemodel == "2003 - 06 KX125 *REAR*" || bikemodel == "2003 - 13 KX250 *REAR*" || bikemodel == "2004 - 17 KX250F  *REAR*" || bikemodel == "KX250XC *REAR*" || bikemodel == "2006 - 17 KX450F *REAR*" || bikemodel == "KX450XC *REAR*" || bikemodel == "KLX 300R *REAR*" || bikemodel == "2007 - 09 KLX450R *REAR*" || bikemodel == "WR250F *FRONT*" || bikemodel == "1999 - 2000 WR400 *FRONT*" || bikemodel == "WR450F *FRONT*" || bikemodel == "YZ125 *FRONT*" || bikemodel == "YZ125R *FRONT*" || bikemodel == "YZ250 *FRONT*" || bikemodel == "YZ250R *FRONT*" || bikemodel == "2001 - 13 YZ250F *FRONT*" || bikemodel == "2017+ YZ250FX *FRONT*" || bikemodel == "2017+ YZ250X *FRONT*" || bikemodel == "1999 YZ400F *FRONT*" || bikemodel == "2000 - 2013 YZ426F/YZ450F *FRONT*" || bikemodel == "2014 - 2015 YZ250F/YZ450F *FRONT*" || bikemodel == "2016 - 2017 YZ450FX *FRONT*" || bikemodel == "WR426 *FRONT*" || bikemodel == "2001 - 17 WR250F *REAR*" || bikemodel == "1999 - 02 WR400/WR426 *REAR*" || bikemodel == "1999 - 02 WR426 *REAR*" || bikemodel == "2003 - 17 WR450F *REAR*" || bikemodel == "1986 - 98 YZ125, YZ250 *REAR*" || bikemodel == "1999 - 2017 YZ125, YZ250 *REAR*" || bikemodel == "2009 - 17 YZ250F *REAR*" || bikemodel == "2015 - 2017 YZ250FX *REAR*" || bikemodel == "2016 - 2017 YZ250X *REAR*" || bikemodel == "1999 YZ400F *REAR*" || bikemodel == "2000 - 08 YZ426F *REAR*" || bikemodel == "2009 - 15 YZ450F *REAR*" || bikemodel == "2016 - 2017 YZ450FX *REAR*" || bikemodel == "WR426 *REAR*") {
				if ($('select#rim_size').val() == "FRONT 21x1.60" || $('select#rim_size').val() == "REAR 18x2.15" || $('select#rim_size').val() == "REAR 19x2.15" || $('select#rim_size').val() == "REAR 18x2.50" || $('select#rim_size').val() == "REAR 19x2.50" || $('select#rim_size').val() == "REAR 18x4.25\"") {
					var select = $('.spoke_color_wrapper');
					select.empty().append(`<div class="color-swatch active" data-value="Silver" style="background: url(${colorImages}silver.svg?v=1717478021);">Silver</div><div class="color-swatch" data-value="Black" style="background: url(${colorImages}black.svg?v=1717478021);">Black</div><div class="color-swatch" data-value="Blue" style="background: url(${colorImages}blue.svg?v=1717478021);">Blue</div><div class="color-swatch" data-value="Green" style="background: url(${colorImages}green.svg?v=1717478021);">Green</div><div class="color-swatch" data-value="Orange" style="background: url(${colorImages}orange.svg?v=1717478021);">Orange</div><div class="color-swatch" data-value="Red" style="background: url(${colorImages}red.svg?v=1717478021);">Red</div><div class="color-swatch" data-value="White" style="background: url(${colorImages}white.svg?v=1717478021);">White</div><div class="color-swatch" data-value="Yellow" style="background: url(${colorImages}yellow.svg?v=1717478021);">Yellow</div><div class="color-swatch" data-value="Flo-Yellow" style="background: url(${colorImages}flo-yellow.svg?v=1717478021);">Flo Yellow</div><div class="color-swatch" data-value="Titanium" style="background: url(${colorImages}titanium.svg?v=1717478021);">Titanium</div>`);
				}
			}

		}
		//Titanium Spoke Color Code End
	}

	function gasgasbrakeremove() {
		if ($('select#bike_make').val() === "GasGas") {
			if ($('select#bike_year').val() <= 2019) {
				var select = $('#brake_rotor');
				select.empty().append('<option class="category" value="260mm">OEM 260mm</option>');
			} else {
				var select = $('#brake_rotor');
				select.empty().append('<option class="category" value="fixed">320mm Fixed</option><option value="320MM_FLOATING">320mm Floating</option>');
			}
		}
	}

	//Hide 320mm Floating Brake Rotor Style option with Bike Year
	function hide320mm() {
		var make = $('select#bike_make').val();
		if (make == "Husqvarna") {
			var bike = $('select#bike_year').val();
			if (bike >= 2000 & bike <= 2013) {
				select = $('#brake_rotor');
				select.empty().append(' <option value="Wave">Wave</option>');
			} else if (bike >= 2014) {
				select = $('#brake_rotor');
				select.empty().append(' <option value="Wave">Wave</option><option value="320MM_FLOATING">320mm Floating</option>');
			}
		}
	}

	//Tubeless Wheel Conditions.
	function tubelesswheel() {
		//val select = $('#rim_size');
		if ($('select#rim_size').val() == 'FRONT 17x3.50' || $('select#rim_size').val() == 'FRONT 16.5x3.50' || $('select#rim_size').val() == 'REAR 17x4.25' || $('select#rim_size').val() == 'REAR 17x5.00') {
			if ($('select#mtl').val() == "No") {
				$('#resultAreaID_1_11').hide();
			} else {
				$('#resultAreaID_1_11').show();
				var image_name = images + "tubeless-" + $('select#mtl').val() + "-" + $('select#wheel_type').val() + ".png";
				var imageArr10 = [image_name];
				var divArr10 = ["resultAreaID_1_11"];
				$('#resultAreaID_1_11 img').attr('src', image_name);

			}
			$('#make_tubeless').show();
		} else {
			$('#make_tubeless').hide();
			$('#resultAreaID_1_11').hide();
		}
	}

	//Display Mounted Tire Help Text Mobile
	var mountedtirehelptextmobile = function () {
		if ($('select#rim_size').val() === "FRONT 17x3.50" && $('select#mbtire').val() === "mbyes" || $('select#mbtire').val() === "DG300") {
			var image_name = images + "Tubeless-" + $("select#wheel_type").val() + "-tire650.png";
			var imageArr9 = [image_name];
			var divArr9 = ["resultAreaID_1_10"];
			$('#resultAreaID_1_10 img').attr('src', image_name);
			//$('select#mbtire').val("mbno");	
			// $('.mbtireimg').qtip({ // Grab some elements to apply the tooltip to
			// 				content: {
			// 					text: 'Michelin Pilot Power 2 CT 120/60-17'
			// 				},
			// 					style: { classes: 'qtip-bootstrap', width: 230, },
			// 	 position: {
			// 			my: 'top right',  // Position my top left...
			// 			at: 'bottom right', // at the bottom right of...
			// 			target: $('.mbtireimg') // my target
			// 		}		
			// 			});			
		}
		if ($('select#rim_size').val() === "REAR 17x4.25") {
			var image_name = images + "Tubeless-" + $("select#wheel_type").val() + "-tire650.png";
			var imageArr9 = [image_name];
			var divArr9 = ["resultAreaID_1_10"];
			$('#resultAreaID_1_10 img').attr('src', image_name);
			// $('.mbtireimg').qtip({ // Grab some elements to apply the tooltip to
			// 				content: {
			// 					text: 'Michelin Pilot Power 2 CT 150/70-17'
			// 				},
			// 					style: { classes: 'qtip-bootstrap', width: 230, },
			// 	 position: {
			// 			my: 'top right',  // Position my top left...
			// 			at: 'bottom right', // at the bottom right of...
			// 			target: $('.mbtireimg') // my target
			// 			}		
			// 			});		
		}
		if ($('select#rim_size').val() === "REAR 17x5.00") {
			// $('.mbtireimg').qtip({ // Grab some elements to apply the tooltip to
			// 				content: {
			// 					text: 'Michelin Pilot Power 2 CT in a size 160/70-17'
			// 				},
			// 					style: { classes: 'qtip-bootstrap', width: 230, },
			// 	 position: {
			// 			my: 'top right',  // Position my top left...
			// 			at: 'bottom right', // at the bottom right of...
			// 			target: $('.mbtireimg') // my target
			// 			}		
			// 			});		
		}

	}

	//Display Mounted Tire Help Text
	var mountedtirehelptext = function () {
		if ($('select#rim_size').val() === "FRONT 17x3.50" && $('select#mbtire').val() === "mbyes" || $('select#mbtire').val() === "DG300") {
			var image_name = "sm_images/Tubeless-" + $("select#wheel_type").val() + "-tire650.png";
			var imageArr9 = [image_name];
			var divArr9 = ["resultAreaID_1_10"];
			$('#resultAreaID_1_10 img').attr('src', image_name);
			//$('select#mbtire').val("mbno");	
			// $('.mbtireimg').qtip({ // Grab some elements to apply the tooltip to
			// 				content: {
			// 					text: 'Michelin Pilot Power 2 CT 120/60-17'
			// 				},
			// 					style: { classes: 'qtip-bootstrap' }

			// 			});			
		}
		if ($('select#rim_size').val() === "REAR 17x4.25") {
			var image_name = "sm_images/Tubeless-" + $("select#wheel_type").val() + "-tire650.png";
			var imageArr9 = [image_name];
			var divArr9 = ["resultAreaID_1_10"];
			$('#resultAreaID_1_10 img').attr('src', image_name);
			// $('.mbtireimg').qtip({ // Grab some elements to apply the tooltip to
			// 				content: {
			// 					text: 'Michelin Pilot Power 2 CT 150/70-17'
			// 				},
			// 					style: { classes: 'qtip-bootstrap' }

			// 			});		
		}
		if ($('select#rim_size').val() === "REAR 17x5.00") {
			// $('.mbtireimg').qtip({ // Grab some elements to apply the tooltip to
			// 				content: {
			// 					text: 'Michelin Pilot Power 2 CT in a size 160/70-17'
			// 				},
			// 					style: { classes: 'qtip-bootstrap' }

			// 			});		
		}
	}

	function nosprocket() {
		var make = $('select#bike_make').val();
		var year = $('select#bike_year').val();
		var model = $('select#bike_model').val();
		var select = $('#sprocket_size');
		var wheel = $('select#wheel_type').val();

		if (wheel == "REAR") {
			if (model == "2013-2016 CRF250L *REAR*" || model == "CRF250L RALLY *REAR*" || model == "CRF300L *REAR*" || model == "CRF300L Rally *REAR*" || model == "1993-2015 XR650L *REAR*" || model == "2000-2008 XR650R *REAR*" || model == "2004 - 06 RMZ250 *REAR*" || model == "2000 - 15 DRZ400 S/SE/E *REAR*" || model == "DRZ400 SM *REAR*" || model == "DRZ400 E *REAR*" || model == "2000 - 07 KLX400 *REAR*" || make == "TM") {

				$("#sprocket_size option[value='no']").remove();
			} else if ((make == "Husqvarna" & year <= 2013) || (make == "GasGas" & year >= 2021)) {

				$("#sprocket_size option[value='no']").remove();
			} else {
				var optionExists = ($('#sprocket_size option[value="no"]').length > 0);

				if (!optionExists) {
					select.append(' <option value="no">No Sprocket</option>');
				}

			}
		}
	}
	//bike-make
	$('select#bike_make').change(function () {


		$('select#hidden_bike_model').empty();
		switch ($('select#bike_make').val()) {

			case 'GasGas': //GasGas
				models = {

					'ES700 *FRONT*': 'ES700',
					'SM700 *FRONT*': 'SM700',
					'ES500 *FRONT*': 'ES500',

					'ES700 *REAR*': 'ES700',
					'SM700 *REAR*': 'SM700',
					'ES500 *REAR*': 'ES500',
				};
				hub_colors = {
					'Silver': 'Silver',
					'Black': 'Black',
					'Red': 'Red',
					'Blue': 'Blue',
					'Gold': 'Gold',
					'Orange': 'Orange',
					'Purple': 'Purple',
					'Magnesium': 'Magnesium'
				};
				rim_colors = {
					'Silver': 'Silver',
					'Black': 'Black',
					'Matte-Black': 'Matte Black',
					'Red': 'Red',
					'Blue': 'Blue',
					'Gold': 'Gold',
					'Orange': 'Orange',
					'Purple': 'Purple',
					'Magnesium': 'Magnesium',
				};
				spoke_colors = {
					'Silver': 'Silver',
					'Black': 'Black',
					'Blue': 'Blue',

					'Green': 'Green',
					'Orange': 'Orange',
					'Red': 'Red',
					'White': 'White',
					'Yellow': 'Yellow'
				};
				nipple_colors = {
					'Silver': 'Silver',
					'Black': 'Black',
					'Red': 'Red',
					'Blue': 'Blue',
					'Orange': 'Orange',
					'Green': 'Green',
					'Gold': 'Gold'
				};
				rim_size = {
					'FRONT 17x3.50': '17x3.50',
					//'FRONT 16.5x3.50' : '16.5x3.50',
				};
				brake_rotor = {
					'fixed': '320mm Fixed',
					'320MM_FLOATING': '320mm Floating'
				};
				rotor_bolts = {
					'Standard': 'Standard',
					'Titanium': 'Titanium'
				};

				break;
			case 'Husqvarna': //Husqvarna
				models = {
					'TC125 *FRONT*': 'TC125',
					'TE125 *FRONT*': 'TE125',
					'TX125 *FRONT*': 'TX125',
					'TE150 *FRONT*': 'TE150',
					'FC250 *FRONT*': 'FC250',
					'FE250 *FRONT*': 'FE250',
					'TC250 *FRONT*': 'TC250',
					'TE250 *FRONT*': 'TE250',
					'TE250I *FRONT*': 'TE250i',
					'TE300 *FRONT*': 'TE300',
					'TE300I *FRONT*': 'TE300i',
					'TX300 *FRONT*': 'TX300',
					'TX300i *FRONT*': 'TX300i',
					'FC350 *FRONT*': 'FC350',
					'FE350 *FRONT*': 'FE350',
					'FX350 *FRONT*': 'FX350',
					'FC450 *FRONT*': 'FC450',
					'FC 450 ROCKSTAR EDITION *FRONT*': 'FC 450 ROCKSTAR EDITION',
					'FE450 *FRONT*': 'FE450',
					'FX450 *FRONT*': 'FX450',
					"FS 450 *FRONT*": "FS 450",
					'FE501 *FRONT*': 'FE501',
					'701 Enduro ABS *FRONT*': '701 Enduro ABS',
					"701 Supermoto *FRONT*": "701 Supermoto",

					'TC125 *REAR*': 'TC125',
					'TE125 *REAR*': 'TE125',
					'TX125 *REAR*': 'TX125',
					'TE150 *REAR*': 'TE150',
					'FC250 *REAR*': 'FC250',
					'FE250 *REAR*': 'FE250',
					'TC250 *REAR*': 'TC250',
					'TE250 *REAR*': 'TE250',
					'TE250I *REAR*': 'TE250i',
					'TE300 *REAR*': 'TE300',
					'TE300I *REAR*': 'TE300i',
					'TX300 *REAR*': 'TX300',
					'TX300i *REAR*': 'TX300i',
					'FC350 *REAR*': 'FC350',
					'FE350 *REAR*': 'FE350',
					'FX350 *REAR*': 'FX350',
					'FC450 *REAR*': 'FC450',
					'FC 450 ROCKSTAR EDITION *REAR*': 'FC 450 ROCKSTAR EDITION',
					'FE450 *REAR*': 'FE450',
					'FX450 *REAR*': 'FX450',
					"FS 450 *REAR*": "FS 450",
					'FE501 *REAR*': 'FE501',
					'701 Enduro ABS *REAR*': '701 Enduro ABS',
					"701 Supermoto *REAR*": "701 Supermoto",

				};
				hub_colors = {
					'Silver': 'Silver',
					'Black': 'Black',
					'Red': 'Red',
					'Blue': 'Blue',
					'Gold': 'Gold',
					'Orange': 'Orange',
					'Purple': 'Purple',
					'Magnesium': 'Magnesium'
				};
				rim_colors = {
					'Silver': 'Silver',
					'Matte-Black': 'Matte Black',
					'Black': 'Black',
					'Red': 'Red',
					'Blue': 'Blue',
					'Gold': 'Gold',
					'Orange': 'Orange',
					'Purple': 'Purple',
					'Magnesium': 'Magnesium'
				};
				spoke_colors = {
					'Silver': 'Silver',
					'Black': 'Black',
					'Blue': 'Blue',

					'Green': 'Green',
					'Orange': 'Orange',
					'Red': 'Red',
					'White': 'White',
					'Yellow': 'Yellow'
				};
				nipple_colors = {
					'Silver': 'Silver',
					'Black': 'Black',
					'Red': 'Red',
					'Blue': 'Blue',
					'Orange': 'Orange',
					'Green': 'Green',
					'Gold': 'Gold'
				};
				rim_size = {

					'FRONT 17x3.50': '17x3.50',
					//'FRONT 16.5x3.50' : '16.5x3.50',
				};
				brake_rotor = {
					'fixed': '320mm Fixed',
					'320MM_FLOATING': '320mm Floating'
				};
				rotor_bolts = {
					'Standard': 'Standard',
					'Titanium': 'Titanium'
				};

				break;
			case 'Honda': //Honda
				models = {
					'2004 - 12 CR125 *FRONT*': 'CR125',
					'2004 - 12 CR250 *FRONT*': 'CR250',
					'2004 - 14 CRF250R *FRONT*': 'CRF250R',
					'CRF250RX *FRONT*': 'CRF250RX',
					'2004 - 17 CRF250X *FRONT*': 'CRF250X',
					'2013 - 16  CRF250L *FRONT*': 'CRF250L',
					'2013 - 16  CRF250L ABS *FRONT*': 'CRF250L ABS',
					'2013 - 16  CRF250L Rally *FRONT*': 'CRF250L Rally',
					'CRF300L *FRONT*': 'CRF300L',
					'CRF300L ABS *FRONT*': 'CRF300L ABS',
					'CRF300L Rally *FRONT*': 'CRF300L Rally',
					'CRF300L Rally ABS *FRONT*': 'CRF300L Rally ABS',
					'2004 - 14 CRF450R *FRONT*': 'CRF450R',
					'CRF450L *FRONT*': 'CRF450L',
					'2004 - 17 CRF450X *FRONT*': 'CRF450X',
					'2017+ CRF450RX *FRONT*': 'CRF450RX',
					'CRF450R WORKS EDITION *FRONT*': 'CRF450R WORKS EDITION',
					'1993 - 17  XR650L *FRONT*': 'XR650L',
					'2000 - 08 XR650R *FRONT*': 'XR650R',

					'2004 - 12 CR125 *REAR*': 'CR125',
					'2004 - 12 CR250 *REAR*': 'CR250',
					'2004 - 13 CRF250R *REAR*': 'CRF250R',
					'CRF250RX *REAR*': 'CRF250RX',
					'2004 - 17 CRF250X *REAR*': 'CRF250X',
					'2013 - 16  CRF250L *REAR*': 'CRF250L',
					'2013 - 16  CRF250L ABS *REAR*': 'CRF250L ABS',
					'2013 - 16  CRF250L Rally *REAR*': 'CRF250L Rally',
					'CRF300L *REAR*': 'CRF300L',
					'CRF300L ABS *REAR*': 'CRF300L ABS',
					'CRF300L Rally *REAR*': 'CRF300L Rally',
					'CRF300L Rally ABS *REAR*': 'CRF300L Rally ABS',
					'2002 - 12 CRF450R *REAR*': 'CRF450R',
					'CRF450L *REAR*': 'CRF450L',
					'2002 - 17 CRF450X *REAR*': 'CRF450X',
					'2017+ CRF450RX *REAR*': 'CRF450RX',
					'CRF450R WORKS EDITION *REAR*': 'CRF450R WORKS EDITION',
					'1993 - 17  XR650L *REAR*': 'XR650L',
					'2000 - 08 XR650R *REAR*': 'XR650R',


				};
				hub_colors = {
					'Silver': 'Silver',
					'Matte-Black': 'Matte Black',
					'Black': 'Black',
					'Red': 'Red',
					'Blue': 'Blue',
					'Gold': 'Gold',
					'Orange': 'Orange',
					'Purple': 'Purple',
					'Magnesium': 'Magnesium'
				};
				rim_colors = {
					'Silver': 'Silver',
					'Black': 'Black',
					'Matte-Black': 'Matte Black',
					'Red': 'Red',
					'Blue': 'Blue',
					'Gold': 'Gold',
					'Orange': 'Orange',
					'Purple': 'Purple',
					'Magnesium': 'Magnesium'
				};
				spoke_colors = {
					'Silver': 'Silver',
					'Black': 'Black',
					'Blue': 'Blue',

					'Green': 'Green',
					'Orange': 'Orange',
					'Red': 'Red',
					'White': 'White',
					'Yellow': 'Yellow'
				};
				nipple_colors = {
					'Silver': 'Silver',
					'Black': 'Black',
					'Red': 'Red',
					'Blue': 'Blue',
					'Orange': 'Orange',
					'Green': 'Green',
					'Gold': 'Gold'
				};
				rim_size = {
					'FRONT 17x3.50': '17x3.50',
				};
				brake_rotor = {
					'fixed': '320mm Fixed',

				};
				rotor_bolts = {
					'Standard': 'Standard',
					'Titanium': 'Titanium'
				};

				break;
			case 'Yamaha': //Yamaha
				models = {
					'YZ125 *FRONT*': 'YZ125',
					'YZ250 *FRONT*': 'YZ250',
					'2001 - 07  YZ250F *FRONT*': 'YZ250F',
					'YZ250FX *FRONT*': 'YZ250FX',
					'2001 - 15  WR250F *FRONT*': 'WR250F',
					'2008 - 17  WR250R *FRONT*': 'WR250R',
					'YZ250X (2 Stroke) *FRONT*': 'YZ250X (2 Stroke)',
					'1998   YZ400F *FRONT*': 'YZ400F',
					'1999 - 2001  WR400 *FRONT*': 'WR400',
					'2000 - 01  YZ426F *FRONT*': 'YZ426F',
					'2001 - 02   WR426F *FRONT*': 'WR426F',
					'2002 - 07  YZ450F *FRONT*': 'YZ450F',
					'YZ450FX *FRONT*': 'YZ450FX',
					'WR426 *FRONT*': 'WR426',
					'2016-17  WR450F *FRONT*': 'WR450F',




					'YZ125 *REAR*': 'YZ125',
					'YZ250 *REAR*': 'YZ250',
					'1999 - 08  YZ125 *REAR*': 'YZ125',
					'1999 - 08  YZ250 *REAR*': 'YZ250',
					'2001 - 08  YZ250F *REAR*': 'YZ250F',
					'YZ250FX *REAR*': 'YZ250FX',
					'2001 - 08  WR250F *REAR*': 'WR250F',
					'2008 - 17  WR250R *REAR*': 'WR250R',
					'YZ250X (2 Stroke) *REAR*': 'YZ250X (2 Stroke)',
					'1999  YZ400F *REAR*': 'YZ400F',
					'1999 - 01  WR400 *REAR*': 'WR400',
					'2000 - 08  YZ426F *REAR*': 'YZ426F',
					'2000 - 08  YZ450F *REAR*': 'YZ450F',
					'YZ450FX *REAR*': 'YZ450FX',
					'WR426 *REAR*': 'WR426',
					'2002 - 14  WR450F *REAR*': 'WR450F',



				};
				hub_colors = {
					'Silver': 'Silver',
					'Black': 'Black',
					'Red': 'Red',
					'Blue': 'Blue',
					'Gold': 'Gold',
					'Orange': 'Orange',
					'Purple': 'Purple',
					'Magnesium': 'Magnesium'
				};
				rim_colors = {
					'Silver': 'Silver',
					'Black': 'Black',
					'Matte-Black': 'Matte Black',
					'Red': 'Red',
					'Blue': 'Blue',
					'Gold': 'Gold',
					'Orange': 'Orange',
					'Purple': 'Purple',
					'Magnesium': 'Magnesium'
				};
				spoke_colors = {
					'Silver': 'Silver',
					'Black': 'Black',
					'Blue': 'Blue',

					'Green': 'Green',
					'Orange': 'Orange',
					'Red': 'Red',
					'White': 'White',
					'Yellow': 'Yellow'
				};
				nipple_colors = {
					'Silver': 'Silver',
					'Black': 'Black',
					'Red': 'Red',
					'Blue': 'Blue',
					'Orange': 'Orange',
					'Green': 'Green',
					'Gold': 'Gold'
				};
				rim_size = {
					'FRONT 17x3.50': '17x3.50',
					//'FRONT 16.5x3.50' : '16.5x3.50',
				};
				brake_rotor = {
					'fixed': '320mm Fixed',
					'320MM_FLOATING': '320mm Floating'
				};
				rotor_bolts = {
					'Standard': 'Standard',
					'Titanium': 'Titanium'
				};
				break;
			case 'Kawasaki': //Kawasaki
				models = {
					'2004 - 15 KX250F *FRONT*': 'KX250F',
					'2006 - 15 KX450F *FRONT*': 'KX450F',

					'2004 - 15 KX250F *REAR*': 'KX250F',
					'2006 - 15 KX450F *REAR*': 'KX450F',
				};
				hub_colors = {
					'Silver': 'Silver',
					'Black': 'Black',
					'Red': 'Red',
					'Blue': 'Blue',
					'Gold': 'Gold',
					'Green': 'Green',
					'Orange': 'Orange',
					'Purple': 'Purple',
					'Magnesium': 'Magnesium'
				};
				rim_colors = {
					'Silver': 'Silver',
					'White': 'White',
					'Black': 'Black',
					'Matte-Black': 'Matte Black',
					'Red': 'Red',
					'Blue': 'Blue',
					'Orange': 'Orange',
					'Green': 'Green',
					'Gold': 'Gold',
					'Purple': 'Purple',
					'Magnesium': 'Magnesium',
					'Flo-Yellow': 'Flo Yellow'
				};
				spoke_colors = {
					'Silver': 'Silver',
					'Black': 'Black',
					'Blue': 'Blue',

					'Green': 'Green',
					'Orange': 'Orange',
					'Red': 'Red',
					'White': 'White',
					'Yellow': 'Yellow',
					'Flo-Yellow': 'Flo Yellow'
				};
				nipple_colors = {
					'Silver': 'Silver',
					'Black': 'Black',
					'Red': 'Red',
					'Blue': 'Blue',
					'Orange': 'Orange',
					'Green': 'Green',
					'Gold': 'Gold',
					'Purple': 'Purple',
					'Magnesium': 'Magnesium'
				};
				rim_size = {
					'FRONT 17x3.50': '17x3.50',
				};
				brake_rotor = {
					'fixed': '320mm Fixed',
					'320MM_FLOATING': '320mm Floating'
				};
				rotor_bolts = {
					'Standard': 'Standard',
					'Titanium': 'Titanium'
				};
				break;
			case 'KTM': //KTM
				models = {
					'EXC125 *FRONT*': '125 EXC',
					'EXC200 *FRONT*': '200 EXC',
					'EXC-F250 *FRONT*': 'EXC-F250',
					'EXC300 *FRONT*': '300 EXC',
					'EXC-F350 *FRONT*': '350 EXC-F',
					'EXC380 *FRONT*': 'EXC380',
					'EXC400 *FRONT*': '400 EXC',
					'EXC450 *FRONT*': '450 EXC',
					'EXC-F450 SIX DAYS *FRONT*': 'EXC-F450  SIX DAYS',
					'EXC-F500 *FRONT*': 'EXC-F500',
					'EXC525 *FRONT*': 'EXC525',
					'EXC530 *FRONT*': 'EXC530',
					'EXC-R530 *FRONT*': 'EXC-R530',
					'XC105 *FRONT*': 'XC105',
					'XC150 *FRONT*': '150 XC',
					'XC-W150 *FRONT*': '150 XC-W',
					'XC200 *FRONT*': '200 XC',
					'XC-W200 *FRONT*': '200 XC-W',
					'XC250 *FRONT*': '250 XC',
					'XC-W250 *FRONT*': '250 XC-W',
					'XC-W250 TPI *FRONT*': 'XC-W250 TPI',
					'XC-F250 *FRONT*': '250 XC-F',
					'XC TP250I *FRONT*': 'XC TP250I',
					'XC300 *FRONT*': '300 XC',
					'XC-W300 *FRONT*': '300 XC-W',
					'XC-W300 TPI *FRONT*': 'XC-W300 TPI',
					'XC-W300 TPI SIX DAYS *FRONT*': 'XC-W300 TPI SIX DAYS',
					'XC TP300I *FRONT*': 'XC TP300I',
					'XC-F350 *FRONT*': '350 XC-F',
					'XC400 *FRONT*': 'XC400',
					'XC-W400 *FRONT*': '400 XC-W',
					'XC450 *FRONT*': 'XC450',
					'XC-F450 *FRONT*': '450 XC-F',
					'XC-W450 *FRONT*': '450 XC-W',
					"SMR 450 *FRONT*": "SMR 450",
					'XC525 *FRONT*': 'XC525',
					'XC-W525 *FRONT*': 'XC-W525',
					'XC530 *FRONT*': 'XC530',
					'XC-W530 *FRONT*': 'XC-W530',
					'SX105 *FRONT*': 'SX105',
					'SX125 *FRONT*': '125 SX',
					'SX144 *FRONT*': '144 SX',
					'SX150 *FRONT*': '150 SX',
					'SX200 *FRONT*': '200 SX',
					'SX250 *FRONT*': '250 SX',
					'SXF250 *FRONT*': 'SXF250',
					'SXF350 *FRONT*': '350 SX-F',
					'SX380 *FRONT*': 'SX380',
					'SX400 *FRONT*': 'SX400',
					'SXC400 *FRONT*': 'SXC400',
					'SX-RFS450 *FRONT*': 'SX-RFS450',
					'SX-F450 *FRONT*': '450 SX-F',
					'SX-F450 FACTORY EDITION *FRONT*': 'SX-F450 FACTORY EDITION',
					'SX-F505 *FRONT*': 'SX-F505',
					'SX520 *FRONT*': 'SX520',
					'SX525 *FRONT*': 'SX525',
					'SXC625 *FRONT*': 'SXC625',
					'690 Enduro *FRONT*': '690 Enduro',
					'690 Enduro ABS *FRONT*': '690 Enduro ABS',

					'EXC125 *REAR*': '125 EXC',
					'EXC200 *REAR*': '200 EXC',
					'EXC-F250 *REAR*': 'EXC-F250',
					'EXC300 *REAR*': '300 EXC',
					'EXC-F350 *REAR*': '350 EXC-F',
					'EXC380 *REAR*': 'EXC380',
					'EXC400 *REAR*': '400 EXC',
					'EXC450 *REAR*': '450 EXC',
					'EXC-F450 SIX DAYS *REAR*': 'EXC-F450  SIX DAYS',
					'EXC-F500 *REAR*': 'EXC-F500',
					'EXC525 *REAR*': 'EXC525',
					'EXC530 *REAR*': 'EXC530',
					'EXC-R530 *REAR*': 'EXC-R530',
					'XC105 *REAR*': 'XC105',
					'XC150 *REAR*': '150 XC',
					'XC-W150 *REAR*': '150 XC-W',
					'XC200 *REAR*': '200 XC',
					'XC-W200 *REAR*': '200 XC-W',
					'XC250 *REAR*': '250 XC',
					'XC-W250 *REAR*': '250 XC-W',
					'XC-W250 TPI *REAR*': 'XC-W250 TPI',
					'XC-F250 *REAR*': '250 XC-F',
					'XC TP250I *REAR*': 'XC TP250I',
					'XC300 *REAR*': '300 XC',
					'XC-W300 *REAR*': '300 XC-W',
					'XC-W300 TPI *REAR*': 'XC-W300 TPI',
					'XC-W300 TPI SIX DAYS *REAR*': 'XC-W300 TPI SIX DAYS',
					'XC TP300I *REAR*': 'XC TP300I',
					'XC-F350 *REAR*': '350 XC-F',
					'XC400 *REAR*': 'XC400',
					'XC-W400 *REAR*': '400 XC-W',
					'XC450 *REAR*': 'XC450',
					'XC-F450 *REAR*': '450 XC-F',
					'XC-W450 *REAR*': '450 XC-W',
					"SMR 450 *REAR*": "SMR 450",
					'XC525 *REAR*': 'XC525',
					'XC-W525 *REAR*': 'XC-W525',
					'XC530 *REAR*': 'XC530',
					'XC-W530 *REAR*': 'XC-W530',
					'SX105 *REAR*': 'SX105',
					'SX125 *REAR*': '125 SX',
					'SX144 *REAR*': '144 SX',
					'SX150 *REAR*': '150 SX',
					'SX200 *REAR*': '200 SX',
					'SX250 *REAR*': '250 SX',
					'SXF250 *REAR*': 'SXF250',
					'SXF350 *REAR*': '350 SX-F',
					'SX380 *REAR*': 'SX380',
					'SX400 *REAR*': 'SX400',
					'SXC400 *REAR*': 'SXC400',
					'SX-RFS450 *REAR*': 'SX-RFS450',
					'SX-F450 *REAR*': '450 SX-F',
					'SX-F450 FACTORY EDITION *REAR*': 'SX-F450 FACTORY EDITION',
					'SX-F505 *REAR*': 'SX-F505',
					'SX520 *REAR*': 'SX520',
					'SX525 *REAR*': 'SX525',
					'SXC625 *REAR*': 'SXC625',
					'690 Enduro *REAR*': '690 Enduro',
					'690 Enduro ABS *REAR*': '690 Enduro ABS',


				};
				hub_colors = {
					'Silver': 'Silver',
					'Black': 'Black',
					'Red': 'Red',
					'Blue': 'Blue',
					'Gold': 'Gold',
					'Orange': 'Orange',
					'Purple': 'Purple',
					'Magnesium': 'Magnesium'
				};
				rim_colors = {
					'Silver': 'Silver',
					'Black': 'Black',
					'Matte-Black': 'Matte Black',
					'Red': 'Red',
					'Blue': 'Blue',
					'Gold': 'Gold',
					'Orange': 'Orange',
					'Purple': 'Purple',
					'Magnesium': 'Magnesium'
				};
				spoke_colors = {
					'Silver': 'Silver',
					'Black': 'Black',
					'Blue': 'Blue',

					'Green': 'Green',
					'Orange': 'Orange',
					'Red': 'Red',
					'White': 'White',
					'Yellow': 'Yellow'
				};
				nipple_colors = {
					'Silver': 'Silver',
					'Black': 'Black',
					'Red': 'Red',
					'Blue': 'Blue',
					'Orange': 'Orange',
					'Green': 'Green',
					'Gold': 'Gold'
				};
				rim_size = {
					'FRONT 17x3.50': '17x3.50',
					//'FRONT 16.5x3.50' : '16.5x3.50',
				};
				brake_rotor = {
					'fixed': '320mm Fixed',
					'320MM_FLOATING': '320mm Floating'
				};
				rotor_bolts = {
					'Standard': 'Standard',
					'Titanium': 'Titanium'
				};
				break;
			case 'Stark': //Stark
				models = {
					'Varg *FRONT*': 'Varg',


					'Varg *REAR*': 'Varg',



				};
				hub_colors = {
					'Silver': 'Silver',
					'Black': 'Black',
					'Red': 'Red',
					'Blue': 'Blue',
					'Gold': 'Gold',
					'Orange': 'Orange',
					'Purple': 'Purple',
					'Magnesium': 'Magnesium'
				};
				rim_colors = {
					'Silver': 'Silver',
					'Black': 'Black',
					'Matte-Black': 'Matte Black',
					'Red': 'Red',
					'Blue': 'Blue',
					'Gold': 'Gold',
					'Orange': 'Orange',
					'Purple': 'Purple',
					'Magnesium': 'Magnesium'
				};
				spoke_colors = {
					'Silver': 'Silver',
					'Black': 'Black',
					'Blue': 'Blue',

					'Green': 'Green',
					'Orange': 'Orange',
					'Red': 'Red',
					'White': 'White',
					'Yellow': 'Yellow'
				};
				nipple_colors = {
					'Silver': 'Silver',
					'Black': 'Black',
					'Red': 'Red',
					'Blue': 'Blue',
					'Orange': 'Orange',
					'Green': 'Green',
					'Gold': 'Gold'
				};
				rim_size = {
					'FRONT 17x3.50': '17x3.50',
					//'FRONT 16.5x3.50' : '16.5x3.50',
				};
				brake_rotor = {
					'fixed': '320mm Fixed',
					'320MM_FLOATING': '320mm Floating'
				};
				rotor_bolts = {
					'Standard': 'Standard',
					'Titanium': 'Titanium'
				};
				break;
			case 'Suzuki': // SUZUKI
				models = {

					'2000 - 17 DRZ400 SE *FRONT*': 'DRZ400 SE',
					'2000 - 17 DRZ400 E *FRONT*': 'DRZ400 E',
					'DRZ400SM *FRONT*': 'DRZ400 SM',
					'1996 - 17 DR650 *FRONT*': 'DR650',



					'2000 - 17 DRZ400 SE *REAR*': 'DRZ400 SE',
					'2000 - 17 DRZ400 E *REAR*': 'DRZ400 E',
					'DRZ400SM *REAR*': 'DRZ400 SM',
					'1996 - 17 DR650 *REAR*': 'DR650',

				};
				hub_colors = {
					'Silver': 'Silver',
					'Black': 'Black',
					'Red': 'Red',
					'Blue': 'Blue',
					'Gold': 'Gold',
					'Orange': 'Orange',
					'Purple': 'Purple',
					'Magnesium': 'Magnesium'
				};
				rim_colors = {
					'Silver': 'Silver',
					'Black': 'Black',
					'Matte-Black': 'Matte Black',
					'Red': 'Red',
					'Blue': 'Blue',
					'Gold': 'Gold',
					'Orange': 'Orange',
					'Purple': 'Purple',
					'Magnesium': 'Magnesium'
				};
				spoke_colors = {
					'Silver': 'Silver',
					'Black': 'Black',
					'Blue': 'Blue',

					'Green': 'Green',
					'Orange': 'Orange',
					'Red': 'Red',
					'White': 'White',
					'Yellow': 'Yellow'
				};
				nipple_colors = {
					'Silver': 'Silver',
					'Black': 'Black',
					'Red': 'Red',
					'Blue': 'Blue',
					'Orange': 'Orange',
					'Green': 'Green',
					'Gold': 'Gold'
				};
				rim_size = {
					'FRONT 17x3.50': '17x3.50',
					//'FRONT 16.5x3.50' : '16.5x3.50',
				};
				brake_rotor = {
					'fixed': '320mm Fixed',
					'320MM_FLOATING': '320mm Floating'
				};
				rotor_bolts = {
					'Standard': 'Standard',
					'Titanium': 'Titanium'
				};
				break;
			case 'Beta': //Beta
				models = {
					'RR *FRONT*': 'RR',
					'RS *FRONT*': 'RS',
					'RR *REAR*': 'RR',
					'RS *REAR*': 'RS'
				};
				hub_colors = {
					'Silver': 'Silver',
					'Black': 'Black',
					'Red': 'Red',
					'Blue': 'Blue',
					'Gold': 'Gold',
					'Green': 'Green',
					'Orange': 'Orange',
					'Purple': 'Purple',
					'Magnesium': 'Magnesium'
				};
				rim_colors = {
					'Silver': 'Silver',
					/*'White' : 'White',*/
					'Black': 'Black',
					'Matte-Black': 'Matte Black',
					/*'Red' : 'Red',
                                      'Blue' : 'Blue',
                                      'Orange' : 'Orange',
									  'Green' : 'Green',
									  'Gold' : 'Gold',
									  'Purple' : 'Purple',
									  'Magnesium' : 'Magnesium',
									  'Flo-Yellow': 'Flo Yellow'*/
				};
				spoke_colors = {
					'Silver': 'Silver',
					'Black': 'Black',
					'Blue': 'Blue',

					'Green': 'Green',
					'Orange': 'Orange',
					'Red': 'Red',
					'White': 'White',
					'Yellow': 'Yellow',
					'Flo-Yellow': 'Flo Yellow'
				};
				nipple_colors = {
					'Silver': 'Silver',
					'Black': 'Black',
					'Red': 'Red',
					'Blue': 'Blue',
					'Orange': 'Orange',
					'Green': 'Green',
					'Gold': 'Gold',
					'Purple': 'Purple',
					'Magnesium': 'Magnesium'
				};
				rim_size = {
					'FRONT 17x3.50': '17x3.50',
				};
				brake_rotor = {
					'Wave': 'Wave'
				};
				rotor_bolts = {
					'Standard': 'Standard',
					'Titanium': 'Titanium'
				};
				break;
				/* case 'Husaberg'://Husaberg
                        models = {
                            
                        };
                        hub_colors = {
                                      'Silver' : 'Silver',
                                      'Black' : 'Black',
                                      'Red' : 'Red',
                                      'Blue' : 'Blue',
				  'Gold' : 'Gold',
				  'Orange' : 'Orange'
                                     };
                        rim_colors = {
                                      'Silver' : 'Silver',
                                      'Black' : 'Black',
                                      'Red' : 'Red',
                                      'Blue' : 'Blue',
									  'Gold' : 'Gold',
                                      'Orange' : 'Orange'
                                     };
                        spoke_colors = {
                                        'Silver' : 'Silver',
                                        'Black' : 'Black',
										'Blue' : 'Blue',
										
										'Green' : 'Green',
										'Orange' : 'Orange',
										'Red' : 'Red',
										'White' : 'White',
										'Yellow' : 'Yellow'
                                       };
                        nipple_colors = {
                                         'Silver' : 'Silver',
                                         'Black' : 'Black',
                                         'Red' : 'Red',
                                         'Blue' : 'Blue',
                                         'Orange' : 'Orange',
                                         'Green' : 'Green',
                                         'Gold' : 'Gold'
                                        };
                        rim_size = {
									'FRONT 17x3.50' : '17x3.50',
									'FRONT 16.5x3.50' : '16.5x3.50',
                                   };
                        brake_rotor = {
                                    'fixed' : '320mm Fixed',
									'320MM_FLOATING' : '320mm Floating'
                                   };
                        break;*/


		}

		var model_element = $('#bike_model');
		var rim_size_element = $('#rim_size');
		var brake_rotor_element = $('#brake_rotor');
		var sprocket_size_element = $('#sprocket_size')
		var rotor_bolts_element = $('#rotor_bolts');

		var model_select = model_element.prop('options');
		var rim_size_select = rim_size_element.prop('options');
		var brake_rotor_select = brake_rotor_element.prop('options');
		var sprocket_size_select = sprocket_size_element.prop('options');
		var rotor_bolts_select = rotor_bolts_element.prop('options');

		$('option', model_element).remove();
		$('option', rim_size_element).remove();
		$('option', brake_rotor_element).remove();
		$('option', rotor_bolts_element).remove();

		$.each(models, function (val, text) {
			var new_opt = new Option(text, val);

			model_select[model_select.length] = new_opt;
			if (val.indexOf('*FRONT') != -1 || text.indexOf('*FRONT') != -1)
				new_opt.className = 'front';
			else
				new_opt.className = 'rear';
		});
		if ($('select#wheel_type').val() == 'REAR') {
			$('select#bike_model option.front').appendTo('select#hidden_bike_model');
			/* rim_size = {
                                    'REAR 18x2.15' : 'REAR 18x2.15',
									'REAR 19x2.15' : 'REAR 19x2.15'
                               };*/
		} else

		{
			$('select#bike_model option.rear').appendTo('select#hidden_bike_model');
		}
		// color append function start
		var hubColorsSelect = $("#hub_colors_select"); // Assuming you have a select element with the id 'hub_colors_select'
		var hubColorWrapper = $(".hub_color_wrapper");
		var hiddenInput = $("#hub_color");
		hubColorWrapper.empty();

		$.each(hub_colors, function (index, colorValue) {
			const formattedColor = colorValue.replace(" ", "-").toLowerCase();
			// Create a new color swatch element
			var colorSwatch = $("<div>", {
				class: "color-swatch",
				"data-value": colorValue.replace(" ", "-"),
				style: `background: url(${colorImages}${formattedColor}.svg?v=1717478021);`,
				title: colorValue
			});
			hubColorWrapper.append(colorSwatch);

			colorSwatch.on("click", function () {
				var hiddenInput = $("#hub_color");

				hubColorWrapper.find(".color-swatch").removeClass("active");
				$(this).addClass("active");
				hiddenInput.val(colorValue);
			});
		});

		$(".hub_color_wrapper .color-swatch:first").click();
		var initialColorValue = hiddenInput.val();
		hubColorWrapper
			.find('.color-swatch[data-value="' + initialColorValue + '"]')
			.addClass("active");

		// color append function start
		var rimColorsSelect = $("#rim_colors_select"); // Assuming you have a select element with the id 'rim_colors_select'
		var rimColorWrapper = $(".rim_color_wrapper");
		var hiddenInput = $("#rim_color");
		rimColorWrapper.empty();
		// // console.log(rim_colors);
		$.each(rim_colors, function (index, colorValue) {
			const formattedColor = colorValue.replace(" ", "-").toLowerCase();
			// Create a new color swatch element
			var colorSwatch = $("<div>", {
				class: "color-swatch",
				"data-value": colorValue.replace(" ", "-"),
				style: `background: url(${colorImages}${formattedColor}.svg?v=1717478021);`,
				title: colorValue
			});
			rimColorWrapper.append(colorSwatch);

			colorSwatch.on("click", function () {
				rimColorWrapper.find(".color-swatch").removeClass("active");
				$(this).addClass("active");
				hiddenInput.val(colorValue);
			});
		});

		$(".rim_color_wrapper .color-swatch:first").click();
		var initialColorValue = hiddenInput.val();
		rimColorWrapper
			.find('.color-swatch[data-value="' + initialColorValue + '"]')
			.addClass("active");
		// color append function end



		var brakeRotorSelect = $("select#rotor_bolts");
		$.each(rotor_bolts, function (value, text) {
			// Create a new option element and append it to the select element
			brakeRotorSelect.append(
				$("<option>", {
					value: value,
					text: text,
				})
			);
		});

		var rimSizeSelect = $("select#rim_size");

		$.each(rim_size, function (value, text) {
			// Create a new option element and append it to the select element
			rimSizeSelect.append(
				$("<option>", {
					value: value,
					text: text,
				})
			);
		});

		var select = $('#wheel_type');
		select.empty().append('<option class="category" value="FRONT">Front</option><option class="category" value="REAR">Rear</option>');

		var select = $('#rim_type');
		select.empty().append('<option class="category" value="Stiletto">Stiletto</option><option class="category" value="Switch">Switch</option><option class="category" value="Rogue">Rogue</option>');


		var image_name = images + "" + $('select#rim_type').val() + "-hub-" + $('#hub_color').val() + "-" + $('select#wheel_type').val() + ".png";
		var imageArr1 = [image_name];
		var divArr1 = ["resultAreaID_1_0"];
		$('#resultAreaID_1_0 img').attr('src', image_name);

		var image_name = images + "" + $('select#rim_type').val() + "-rim-" + $('#rim_color').val() + "-" + $('select#wheel_type').val() + ".png";
		var imageArr2 = [image_name];
		var divArr2 = ["resultAreaID_1_1"];
		$('#resultAreaID_1_1 img').attr('src', image_name);

		var image_name = images + "spokes-" + $('#spoke_color').val() + "-" + $('select#wheel_type').val() + ".png";
		var imageArr3 = [image_name];
		var divArr3 = ["resultAreaID_1_2"];
		$('#resultAreaID_1_2 img').attr('src', image_name);

		var image_name = images + "" + $('select#rim_type').val() + "-valvestem-" + $('#stem_color').val() + "-" + $('select#wheel_type').val() + ".png";
		var imageArr4 = [image_name];
		var divArr4 = ["resultAreaID_1_3"];
		$('#resultAreaID_1_4 img').attr('src', image_name);

		var image_name = images + "brake-320MM_FLOATING" + "-" + $('select#wheel_type').val() + ".png";
		var imageArr5 = [image_name];
		var divArr5 = ["resultAreaID_1_6"];
		$('#resultAreaID_1_6 img').attr('src', image_name);
		if ($('select#wheel_type').val() == 'REAR') {
			document.getElementById('resultAreaID_1_6').style.width = '175px';
			document.getElementById('resultAreaID_1_6').style.height = '106px';
		} else {
			document.getElementById('resultAreaID_1_6').style.width = '150px';
			document.getElementById('resultAreaID_1_6').style.height = '124px';
		}
		if ($('select#wheel_type').val() == 1) {
			var select = $('#sprocket_size');
			select.val('no');
			$('#sprocket_size').change();
			$('#sprocket').show();

		} else {
			$('#sprocket').hide();

		}

		if ($('select#rim_size').val() == 'FRONT 16.5x3.50') {
			var select = $('#rim_color');
			select.val('Black');
			var rim_color_wrapper = $('.rim_color_wrapper');
			rim_color_wrapper.empty().append(`<div class="color-swatch active" data-value="Black" style="background: url(${colorImages}black.svg?v=1717478021);">`);
			var image_name = images + "" + $('select#rim_type').val() + "-rim-" + $('#rim_color').val() + "-" + $('select#wheel_type').val() + ".png";
			var imageArr2 = [image_name];
			var divArr2 = ["resultAreaID_1_1"];
			$('#resultAreaID_1_1 img').attr('src', image_name);
		} else {
			var select = $('#rim_color');
			select.empty().append('<option class="category" value="Silver">Silver</option><option class="category" value="Black">Black</option><option class="category" value="Red">Red</option><option class="category" value="Blue">Blue</option><option class="category" value="Gold">Gold</option><option class="category" value="Orange">Orange</option><option class="category" value="Purple">Purple</option><option class="category" value="Magnesium">Magnesium</option>');
		}

		if ($('select#bike_make').val() == 'Kawasaki') {
			if ($('select#bike_model').val() == '1997 - 02 KX125, KX250 *FRONT*') {
				var select = $('#brake_rotor');
				select.empty().append('<option class="category" value="fixed">320mm Fixed</option>');
			} else {
				var select = $('#brake_rotor');
				select.empty().append('<option class="category" value="fixed">320mm Fixed</option><option value="320MM_FLOATING">320mm Floating</option>');
			}
		}
		if ($('select#bike_make').val() == 'Yamaha') {
			if ($('select#bike_model').val() == '1992 - 2008 YZ125 *FRONT*') {
				var select = $('#brake_rotor');
				select.empty().append('<option class="category" value="fixed">320mm Fixed</option>');
			} else {
				var select = $('#brake_rotor');
				select.empty().append('<option class="category" value="fixed">320mm Fixed</option><option value="320MM_FLOATING">320mm Floating</option>');
			}
		}

		if ($('select#wheel_type').val() == 'REAR') {
			var select = $('#rim_size');
			select.empty().append('<option value="REAR 17x4.25">17x4.25</option>');
		}
		/*else {
		var select = $('#rim_size');
		select.empty().append(' <option value="FRONT 17x3.50">17x3.50</option><option value="FRONT 16.5x3.50">16.5x3.50</option>');
		
		}*/



		if ($('select#wheel_type').val() == "FRONT") {
			$('#sprocketbolts').css("display", "none");
			$('.apex').css("display", "none");
		} else {
			$('#sprocketbolts').css("display", "block");
			$('.apex').css("display", "block");
		}
		//Model Year Show		
		if ($('select#bike_make').val() == 'Honda' || $('select#bike_make').val() == 'Husqvarna' || $('select#bike_make').val() == 'Yamaha' || $('select#bike_make').val() == 'KTM' || $('select#bike_make').val() == 'Suzuki' || $('select#bike_make').val() == 'Beta' || $('select#bike_make').val() == 'Kawasaki' || $('select#bike_make').val() == 'GasGas' || $('select#bike_make').val() == 'Stark')

		{
			$('#bikeyear').show();

		} else {
			$('#bikeyear').hide();
		}

		if ($('#speedometer').css('display') != 'none') {
			// $("#sm_magnets").val('NO');
			if ($("select#sm_magnets").val() == "BLACK" || $("select#sm_magnets").val() == "BLUE" || $("select#sm_magnets").val() == "ORANGE") {
				$("#resultAreaID_1_7").addClass("show");
				var image_name = images + "magnet-" + $('select#sm_magnets').val() + '-' + $('select#wheel_type').val() + ".png";
				var imageArr6 = [image_name];
				var divArr6 = ["resultAreaID_1_7"];

				$('#resultAreaID_1_7 img').attr('src', image_name);
				$('#resultAreaID_1_7').addClass("show");
			} else if ($("select#sm_magnets").val() == "NO") {
				$("#resultAreaID_1_7").hide();
			} else {
				var image_name = images + "sprocket.png";
				var imageArr6 = [image_name];
				var divArr6 = ["resultAreaID_1_7"];
				$('#resultAreaID_1_7 img').attr('src', image_name);
				$('#resultAreaID_1_7').addClass("show");
			}
		} else {
			// console.log("in rear");
			if ($('select#wheel_type').val() == 'FRONT') {
				$('#resultAreaID_1_7').removeClass("show");
			} else {
				var image_name = images + "rubbers.png";
				var imageArr7 = [image_name];
				var divArr7 = ["resultAreaID_1_7"];
				$('#resultAreaID_1_7 img').attr('src', image_name);
				// console.log("in rear");
				$('#resultAreaID_1_7').addClass("show");
			}
		}
		$('#rotor_bolts').prop('selectedIndex', 0);
		//Mounted/Balanced Tire Field Code

		$('select#mbtire').val("mbno");
		$('#resultAreaID_1_10').hide();
		if ($('select#rim_size').val() === "FRONT 17x3.50" || $('select#rim_size').val() === "REAR 17x4.25" || $('select#rim_size').val() === "REAR 17x5.00" || $('select#rim_size').val() === "REAR 17x5.00") {
			$('#mbtiretr').show();
			if ($('select#wheel_type').val() === "REAR") {
				$("#resultAreaID_1_10, #resultAreaID_1_0, #resultAreaID_1_1, #resultAreaID_1_2, #resultAreaID_1_3, #resultAreaID_1_4, #resultAreaID_1_5").removeClass("wheel");
				$("#resultAreaID_1_10").removeClass("front-wheel");
				$("#resultAreaID_1_10").addClass("rear-wheel");
				$("#resultAreaID_1_0, #resultAreaID_1_1, #resultAreaID_1_2, #resultAreaID_1_3, #resultAreaID_1_4, #resultAreaID_1_5").addClass("tire-img");
				if ($('select#rim_type').val() === "Switch") {
					$("#resultAreaID_1_10").addClass("switch-img");
					$("#resultAreaID_1_10").removeClass("rear-wheel");
				} else {
					$("#resultAreaID_1_10").addClass("rear-wheel");
					$("#resultAreaID_1_10").removeClass("switch-img");
				}
			} else {
				$("#resultAreaID_1_0, #resultAreaID_1_1, #resultAreaID_1_2, #resultAreaID_1_3, #resultAreaID_1_4, #resultAreaID_1_5").removeClass("tire-img");
				$("#resultAreaID_1_10").removeClass("rear-wheel");
				$("#resultAreaID_1_0, #resultAreaID_1_1, #resultAreaID_1_2, #resultAreaID_1_3, #resultAreaID_1_4, #resultAreaID_1_5").addClass("wheel");
				$("#resultAreaID_1_10").addClass("wheel front-wheel");
				$("#resultAreaID_1_10").removeClass("switch-img");
			}
		} else {
			$('#mbtiretr').hide();
			$('select#mbtire').val("mbno");

		}
		// if (navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i)) {
		// 	mountedtirehelptextmobile();
		// } else {
		// 	mountedtirehelptext();
		// }
	});

	$('select#bike_make').change(function () {
		if ($('select#bike_model').val() === `2004 - 13 CRF250R *REAR*` || $('select#bike_model').val() === `2002 - 12 CRF450R *REAR*` || $('select#bike_model').val() === `CRF450R Works Edition *REAR*` || $('select#bike_model').val() === `CRF450L *REAR*` || $('select#bike_model').val() === `CRF450RL *REAR*` || $('select#bike_model').val() === `2004 - 2017 CRF250X *REAR*` || $('select#bike_model').val() === `2002 - 2017 CRF450X *REAR*` || $('select#bike_model').val() === `2009 - 17 YZ250F *REAR*` || $('select#bike_model').val() === `2015 - 2017 YZ250FX *REAR*` || $('select#bike_model').val() === `2016 - 2017 YZ250X *REAR*` || $('select#bike_model').val() === `2016 - 2017 YZ450FX *REAR*` || $('select#bike_model').val() === `2001 - 17 WR250F *REAR*` || $('select#bike_model').val() === `1999 YZ400F *REAR*` || $('select#bike_model').val() === `1998 YZ400F *REAR*` || $('select#bike_model').val() === `2000 - 08 YZ426F *REAR*` || $('select#bike_model').val() === `2000 - 17 DRZ400 S * REAR *` || $('select#bike_model').val() === `2000 - 17 DRZ400 SE * REAR *` || $('select#bike_model').val() === `2000 - 17 DRZ400 E * REAR *` || $('select#bike_model').val() == `EXC125 *REAR*` || $('select#bike_model').val() == `EXC-F350 *REAR*` || $('select#bike_model').val() == `EXC520 *REAR*` || $('select#bike_model').val() == `XC-W250 TPI *REAR*` || $('select#bike_model').val() == `XCF-W250 *REAR*` || $('select#bike_model').val() == `XC-W300 TPI *REAR*` || $('select#bike_model').val() == `XC-F450 *REAR*` || $('select#bike_model').val() == `XC-W500 *REAR*` || $('select#bike_model').val() == `XC-F505 *REAR*` || $('select#bike_model').val() == `SX450 *REAR*` || $('select#bike_model').val() == `EXC200 *REAR*` || $('select#bike_model').val() == `EXC-F250 *REAR*` || $('select#bike_model').val() == `EXC300 *REAR*` || $('select#bike_model').val() == `EXC380 *REAR*` || $('select#bike_model').val() == `EXC400 *REAR*` || $('select#bike_model').val() == `EXC450 *REAR*` || $('select#bike_model').val() == `EXC350 *REAR*` || $('select#bike_model').val() == `EXC-F500 *REAR*` || $('select#bike_model').val() == `EXC-F450 *REAR*` || $('select#bike_model').val() == `XC250 TPI *REAR*` || $('select#bike_model').val() == `XC300 TPI *REAR*` || $('select#bike_model').val() == `XC-W300 TPI Six Days *REAR*` || $('select#bike_model').val() == `SX-F450 Factory Edition *REAR*` || $('select#bike_model').val() == `TX125 *REAR*` || $('select#bike_model').val() == `TE250I *REAR*` || $('select#bike_model').val() == `TE300I *REAR*` || $('select#bike_model').val() == `TX300 *REAR*` || $('select#bike_model').val() == `FC350 *REAR*` || $('select#bike_model').val() == `FE350 *REAR*` || $('select#bike_model').val() == `FX350 *REAR*` || $('select#bike_model').val() == `FE450 *REAR*` || $('select#bike_model').val() == `FX450 *REAR*` || $('select#bike_model').val() == `EXC525 *REAR*` || $('select#bike_model').val() == `EXC530 *REAR*` || $('select#bike_model').val() == `EXC-R530 *REAR*` || $('select#bike_model').val() == `XC150 *REAR*` || $('select#bike_model').val() == `XC-W150 *REAR*` || $('select#bike_model').val() == `XC200 *REAR*` || $('select#bike_model').val() == `XC-W200 *REAR*` || $('select#bike_model').val() == `XC250 *REAR*` || $('select#bike_model').val() == `XC-W250 *REAR*` || $('select#bike_model').val() == `XC-F250 *REAR*` || $('select#bike_model').val() == `XC-F350 *REAR*` || $('select#bike_model').val() == `XCF-W350 *REAR*` || $('select#bike_model').val() == `XC300 *REAR*` || $('select#bike_model').val() == `XC-W300 *REAR*` || $('select#bike_model').val() == `XC400 *REAR*` || $('select#bike_model').val() == `XC-W400 *REAR*` || $('select#bike_model').val() == `XC450 *REAR*` || $('select#bike_model').val() == `XC-W450 *REAR*` || $('select#bike_model').val() == `XC525 *REAR*` || $('select#bike_model').val() == `XC-W525 *REAR*` || $('select#bike_model').val() == `XC530 *REAR*` || $('select#bike_model').val() == `XC-W530 *REAR*` || $('select#bike_model').val() == `SX125 *REAR*` || $('select#bike_model').val() == `SX144 *REAR*` || $('select#bike_model').val() == `SX150 *REAR*` || $('select#bike_model').val() == `SX200 *REAR*` || $('select#bike_model').val() == `SX250 *REAR*` || $('select#bike_model').val() == `SXF250 *REAR*` || $('select#bike_model').val() == `SXF350 *REAR*` || $('select#bike_model').val() == `SX380 *REAR*` || $('select#bike_model').val() == `SX400 *REAR*` || $('select#bike_model').val() == `SXC400 *REAR*` || $('select#bike_model').val() == `SX-RFS450 *REAR*` || $('select#bike_model').val() == `SX-F450 *REAR*` || $('select#bike_model').val() == `Varg *REAR*` || $('select#bike_model').val() == `SX-F505 *REAR*` || $('select#bike_model').val() == `SX520 *REAR*` || $('select#bike_model').val() == `SX525 *REAR*` || $('select#bike_model').val() == `SXC625 *REAR*` || $('select#bike_model').val() === `2014 - 17 TE300 *REAR*` || $('select#bike_model').val() === `2014 - 17 FC450 *REAR*` || $('select#bike_model').val() === `2014 - 17 FE501 *REAR*` || $('select#bike_model').val() === `TE150 *REAR*` || $('select#bike_model').val() === `TX300i *REAR*` || $('select#bike_model').val() === `FC450 Rockstar Edition *REAR*` || $('select#bike_model').val() === `2003 - 17 WR450F*REAR*` || $('select#bike_model').val() === `2009 - 17 YZ250F *REAR*` || $('select#bike_model').val() === `2002 - 12 CRF450R *REAR*` || $('select#bike_model').val() === `CRF450R Works Edition *REAR*` || $('select#bike_model').val() === `2013 - 2017 CRF450R *REAR*` || $('select#bike_model').val() === `2017+ CRF450RX *REAR*` || $('select#bike_model').val() === `CRF250RX *REAR*` || $('select#bike_model').val() === `2004 - 14 All FE/FC *REAR*` || $('select#bike_model').val() === `FE *REAR*` || $('select#bike_model').val() === `2009 - 11 450X *REAR*` || $('select#bike_model').val() === `2009 - 15 YZ450F *REAR*` || $('select#bike_model').val() === `WR426 *REAR*` || $('select#bike_model').val() === `2000 - 07 KLX400 *REAR*` || $('select#bike_model').val() === `1996 - 04 XR 250 *REAR*` || $('select#bike_model').val() === `1996 - 04 XR 400 *REAR*` || $('select#bike_model').val() === `1993 - 2017 XR650L *REAR*` || $('select#bike_model').val() == `2008 – 2013 KTM 690 ENDURO * REAR *` || $('select#bike_model').val() == `790 Adventure *REAR*` || $('select#bike_model').val() == `790 Adventure R *REAR*` || $('select#bike_model').val() == `890 Adventure *REAR*` || $('select#bike_model').val() == `890 Adventure R *REAR*` || $('select#bike_model').val() == `950 Adventure *REAR*` || $('select#bike_model').val() == `990 Adventure *REAR*` || $('select#bike_model').val() == `1090 Adventure *REAR*` || $('select#bike_model').val() == `1190 Adventure *REAR*` || $('select#bike_model').val() == `1290 Adventure ABS *REAR*` || $('select#bike_model').val() == `1290 Adventure R *REAR*` || $('select#bike_model').val() == `1290 Super Adventure S *REAR*` || $('select#bike_model').val() == `2014 – 2017 KTM 690 ENDURO ABS * REAR *` || $('select#bike_model').val() == `RR *REAR*` || $('select#bike_model').val() == `RS *REAR*`) {
			document.getElementById("cush_drive").disabled = false;
			select = $('#cush_drive');
			select.empty().append('<option class="category" value="unavailable">Standard</option>', '<option class="category" value="Cush Drive">Cush Drive</option>');
			if ($('select#cush_drive').val() != "unavailable") {
				/*document.getElementById('rotor-text').style.margin='120px 0px 0px 0px';
				document.getElementById('rotor-text').style.top='420px';
				document.getElementById('resultAreaID_1_6').style.width='175px';
				document.getElementById('resultAreaID_1_6').style.height='106px';
				document.getElementById('resultAreaID_1_6').style.top='420px';*/
				// $('#resultAreaID_1_4').show();
			} else {
				// document.getElementById('rotor-text').style.margin = '';
				// document.getElementById('rotor-text').style.top = '';
				// document.getElementById('resultAreaID_1_6').style.width = '';
				// document.getElementById('resultAreaID_1_6').style.height = '';
				// document.getElementById('resultAreaID_1_6').style.top = '';
				// $('#resultAreaID_1_4').hide();

			}
		} else {
			document.getElementById("cush_drive").disabled = true;
			select = $('#cush_drive');
			select.empty().append(' <option class="category" value="unavailable" selected="selected">Standard</option>');



		}

		//Fron suspension Logic//
		if ($('select#wheel_type').val() == "FRONT" & $('select#bike_make').val() == 'Sherco') {
			$('#frontsuspension').show();

		} else {
			$('#frontsuspension').hide();
		}


		//Model Year Show		
		if ($('select#bike_make').val() == 'Husqvarna' || $('select#bike_make').val() == 'Honda' || $('select#bike_make').val() == 'KTM' || $('select#bike_make').val() == 'Yamaha' || $('select#bike_make').val() == 'Kawasaki' || $('select#bike_make').val() == 'Suzuki' || $('select#bike_make').val() == 'Husaberg' || $('select#bike_make').val() == 'GasGas' || $('select#bike_make').val() == 'BMW' || $('select#bike_make').val() == 'Beta' || $('select#bike_make').val() == 'TM' || $('select#bike_make').val() == 'Sherco' || $('select#bike_make').val() == 'Stark' || $('select#bike_make').val() == 'Alta Redshift')

		{
			$('#bikeyear').show();
			// $('#frontsuspension').show();


		} else {
			$('#bikeyear').hide();
			//  $('#frontsuspension').hide();

		}
		// Hide Blue rim color
		// rimcolorhideblue();

	});

	var bikeyear = function () {
		//Bike Year Start
		//Declare Selected Bike Model Variable
		var sel_bike_model = $('select#bike_model').val();
		var sel_year = $('#bike_year');
		
		var previous_year = sel_year.val();
		//Option Year Variable
		var y91 = '<option value="1991">1991</option>';
		var y92 = '<option value="1992">1992</option>';
		var y93 = '<option value="1993">1993</option>';
		var y94 = '<option value="1994">1994</option>';
		var y95 = '<option value="1995">1995</option>';
		var y96 = '<option value="1996">1996</option>';
		var y97 = '<option value="1997">1997</option>';
		var y98 = '<option value="1998">1998</option>';
		var y99 = '<option value="1999">1999</option>';
		var y00 = '<option value="2000">2000</option>';
		var y01 = '<option value="2001">2001</option>';
		var y02 = '<option value="2002">2002</option>';
		var y03 = '<option value="2003">2003</option>';
		var y04 = '<option value="2004">2004</option>';
		var y05 = '<option value="2005">2005</option>';
		var y06 = '<option value="2006">2006</option>';
		var y07 = '<option value="2007">2007</option>';
		var y08 = '<option value="2008">2008</option>';
		var y09 = '<option value="2009">2009</option>';
		var y10 = '<option value="2010">2010</option>';
		var y11 = '<option value="2011">2011</option>';
		var y12 = '<option value="2012">2012</option>';
		var y13 = '<option value="2013">2013</option>';
		var y14 = '<option value="2014">2014</option>';
		var y15 = '<option value="2015">2015</option>';
		var y16 = '<option value="2016">2016</option>';
		var y17 = '<option value="2017">2017</option>';
		var y18 = '<option value="2018">2018</option>';
		var y19 = '<option value="2019">2019</option>';
		var y20 = '<option value="2020">2020</option>';
		var y21 = '<option value="2021">2021</option>';
		var y22 = '<option value="2022">2022</option>';
		var y23 = '<option value="2023">2023</option>';
		var y24 = '<option value="2024">2024</option>';
		var y25 = '<option value="2025">2025</option>';
		var y26 = '<option value="2026">2026</option>';
		//Global Usage
		//else if(sel_bike_model === "") {sel_year.empty().append();}
		//y91 + y92 + y93 + y94 + y95 + y96 + y97 + y98 + y99 + y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18
		//Model Honda Front
		if (sel_bike_model === "2004 - 12 CR125 *FRONT*") {
			sel_year.empty().append(y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12);
		} else if (sel_bike_model === "2004 - 12 CR250 *FRONT*") {
			sel_year.empty().append(y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12);
		} else if (sel_bike_model === "2004 - 14 CRF250R *FRONT*" || sel_bike_model === "2004 - 13 CRF250R *REAR*" || sel_bike_model === "2004 - 17 CRF250X *REAR*" || sel_bike_model === "2004 - 17 CRF250X *FRONT*" || sel_bike_model === "2004 - 14 CRF450R *FRONT*" || sel_bike_model === "2002 - 12 CRF450R *REAR*") {
			sel_year.empty().append(y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "2013 - 16  CRF250L *FRONT*") {
			sel_year.empty().append(y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "2013 - 16  CRF250L ABS *FRONT*") {
			sel_year.empty().append(y17 + y18);
		} else if (sel_bike_model === "2013 - 16  CRF250L Rally *FRONT*") {
			sel_year.empty().append(y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "CRF450L *FRONT*" || sel_bike_model === "CRF450L *REAR*") {
			sel_year.empty().append(y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "2004 - 17 CRF450X *FRONT*") {
			sel_year.empty().append(y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "2017+ CRF450RX *FRONT*" || sel_bike_model === "2017+ CRF450RX *REAR*") {
			sel_year.empty().append(y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "1993 - 17  XR650L *FRONT*" || sel_bike_model === "1993 - 17  XR650L *REAR*") {
			sel_year.empty().append(y93 + y94 + y95 + y96 + y97 + y98 + y99 + y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "2000 - 08 XR650R *FRONT*") {
			sel_year.empty().append(y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08);
		}
		//Model Honda Rear
		else if (sel_bike_model === "2004 - 12 CR125 *REAR*") {
			sel_year.empty().append(y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12);
		} else if (sel_bike_model === "2004 - 12 CR250 *REAR*") {
			sel_year.empty().append(y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12);
		} else if (sel_bike_model === "2013 - 16  CRF250L *REAR*") {
			sel_year.empty().append(y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "2013 - 16  CRF250L ABS *REAR*") {
			sel_year.empty().append(y17 + y18);
		} else if (sel_bike_model === "2013 - 16  CRF250L Rally *REAR*") {
			sel_year.empty().append(y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "2002 - 17 CRF450X *REAR*") {
			sel_year.empty().append(y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "2000 - 08 XR650R *REAR*") {
			sel_year.empty().append(y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08);
		} else if (sel_bike_model === "CRF450R WORKS EDITION *REAR*" || sel_bike_model === "CRF450R WORKS EDITION *FRONT*" || sel_bike_model === "CRF250RX *REAR*" || sel_bike_model === "CRF250RX *FRONT*") {
			sel_year.empty().append(y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "CRF450R WORKS EDITION *REAR*" || sel_bike_model === "CRF450R WORKS EDITION *FRONT*" || sel_bike_model === "CRF250RX *REAR*" || sel_bike_model === "CRF250RX *FRONT*") {
			sel_year.empty().append(y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "CRF300L *REAR*" || sel_bike_model === "CRF300L ABS *REAR*" || sel_bike_model === "CRF300L Rally *REAR*" || sel_bike_model === "CRF300L Rally ABS *REAR*" || sel_bike_model === "CRF300L *FRONT*" || sel_bike_model === "CRF300L ABS *FRONT*" || sel_bike_model === "CRF300L Rally *FRONT*" || sel_bike_model === "CRF300L Rally ABS *FRONT*") {
			sel_year.empty().append(y21);
		}

		//Model Husqvarna Front
		else if (sel_bike_model === "TE125 *FRONT*" || sel_bike_model === "TE125 *REAR*" || sel_bike_model === "TE250 *FRONT*" || sel_bike_model === "TE300 *FRONT*" || sel_bike_model === "TE250 *REAR*" || sel_bike_model === "TE300 *REAR*") {
			sel_year.empty().append(y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "FE250 *FRONT*" || sel_bike_model === "FE350 *FRONT*" || sel_bike_model === "FE450 *FRONT*" || sel_bike_model === "FE501 *FRONT*" || sel_bike_model === "TC125 *FRONT*" || sel_bike_model === "TC250 *FRONT*" || sel_bike_model === "FC250 *FRONT*" || sel_bike_model === "FC350 *FRONT*" || sel_bike_model === "FC450 *FRONT*" || sel_bike_model === "FE250 *REAR*" || sel_bike_model === "FE350 *REAR*" || sel_bike_model === "FE450 *REAR*" || sel_bike_model === "FE501 *REAR*" || sel_bike_model === "TC125 *REAR*" || sel_bike_model === "TC250 *REAR*" || sel_bike_model === "FC250 *REAR*" || sel_bike_model === "FC350 *REAR*" || sel_bike_model === "FC450 *REAR*") {
			sel_year.empty().append(y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "701 Enduro ABS *FRONT*" || sel_bike_model === "701 Enduro ABS *REAR*") {
			sel_year.empty().append(y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "TE300I *FRONT*" || sel_bike_model === "TE300I *REAR*") {
			sel_year.empty().append(y18 + y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "TX125 *FRONT*" || sel_bike_model === "TX125 *REAR*" || sel_bike_model === "TX300 *REAR*" || sel_bike_model === "TX300 *FRONT*") {
			sel_year.empty().append(y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "TE250I *REAR*" || sel_bike_model === "TE250I *FRONT*" || sel_bike_model === "TX300i *REAR*" || sel_bike_model === "TX300i *FRONT*") {
			sel_year.empty().append(y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "FX350 *REAR*" || sel_bike_model === "FX350 *FRONT*" || sel_bike_model === "FX450 *REAR*" || sel_bike_model === "FX450 *FRONT*") {
			sel_year.empty().append(y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "TE150 *REAR*" || sel_bike_model === "TE150 *FRONT*") {
			sel_year.empty().append(y18 + y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "FC 450 ROCKSTAR EDITION *REAR*" || sel_bike_model === "FC 450 ROCKSTAR EDITION *FRONT*") {
			sel_year.empty().append(y19 + y20 + y21 + y22 + y23 + y24);
		}

		//Model Yamaha Front
		else if (sel_bike_model === "2001 - 15  WR250F *FRONT*" || sel_bike_model === "2001 - 08  WR250F *REAR*") {
			sel_year.empty().append(y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "2008 - 17  WR250R *FRONT*" || sel_bike_model === "2008 - 17  WR250R *REAR*") {
			sel_year.empty().append(y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "1998   YZ400F *FRONT*") {
			sel_year.empty().append(y98);
		} else if (sel_bike_model === "1999 - 2001  WR400 *FRONT*") {
			sel_year.empty().append(y99 + y00 + y01);
		} else if (sel_bike_model === "2000 - 01  YZ426F *FRONT*") {
			sel_year.empty().append(y00 + y01);
		} else if (sel_bike_model === "2001 - 02   WR426F *FRONT*") {
			sel_year.empty().append(y01 + y02);
		} else if (sel_bike_model === "2002 - 07  YZ450F *FRONT*" || sel_bike_model === "2016-17  WR450F *FRONT*" || sel_bike_model === "2000 - 08  YZ450F *REAR*" || sel_bike_model === "2002 - 14  WR450F *REAR*") {
			sel_year.empty().append(y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "YZ250 *FRONT*" || sel_bike_model === "YZ125 *FRONT*" || sel_bike_model === "YZ250 *REAR*" || sel_bike_model === "YZ125 *REAR*") {
			sel_year.empty().append(y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "YZ450FX *FRONT*" || sel_bike_model === "YZ450FX *REAR*") {
			sel_year.empty().append(y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		}


		// Model Yamaha REAR
		else if (sel_bike_model === "1999 - 08  YZ125 *REAR*" || sel_bike_model === "1999 - 08  YZ250 *REAR*") {
			sel_year.empty().append(y99 + y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08);
		} else if (sel_bike_model === "2001 - 08  YZ250F *REAR*" || sel_bike_model === "2001 - 07  YZ250F *FRONT*") {
			sel_year.empty().append(y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "1999  YZ400F *REAR*") {
			sel_year.empty().append(y99);
		} else if (sel_bike_model === "1999 - 01  WR400 *REAR*") {
			sel_year.empty().append(y99 + y00 + y01);
		} else if (sel_bike_model === "2000 - 08  YZ426F *REAR*") {
			sel_year.empty().append(y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08);
		} else if (sel_bike_model === "YZ250X (2 Stroke) *REAR*" || sel_bike_model === "YZ250X (2 Stroke) *FRONT*") {
			sel_year.empty().append(y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "WR426 *FRONT*" || sel_bike_model === "WR426 *REAR*") {
			sel_year.empty().append(y01 + y02);
		} else if (sel_bike_model === "YZ250FX *FRONT*" || sel_bike_model === "YZ250FX *REAR*") {
			sel_year.empty().append(y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		}

		// Model Kawasaki Front and REAR
		else if (sel_bike_model === "2004 - 15 KX250F *FRONT*" || sel_bike_model === "2004 - 15 KX250F *REAR*") {
			sel_year.empty().append(y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16);
		} else if (sel_bike_model === "2006 - 15 KX450F *FRONT*" || sel_bike_model === "2006 - 15 KX450F *REAR*") {
			sel_year.empty().append(y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18);
		}


		
		// Model KTM Front and REAR
		else if (sel_bike_model === "EXC125 *FRONT*" || sel_bike_model === "EXC125 *REAR*") {
			sel_year.empty().append(y98 + y99 + y00 + y01 + y02 + y03 + y04 + y05 + y06);
		} else if (sel_bike_model === "EXC200 *FRONT*" || sel_bike_model === "EXC200 *REAR*") {
			sel_year.empty().append(y98 + y99 + y00 + y01 + y02 + y03 + y04 + y05);
		} else if (sel_bike_model === "EXC-F250 *FRONT*" || sel_bike_model === "EXC-F250 *REAR*") {
			sel_year.empty().append(y98 + y99 + y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "EXC300 *FRONT*" || sel_bike_model === "EXC300 *REAR*") {
			sel_year.empty().append(y98 + y99 + y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "EXC380 *FRONT*" || sel_bike_model === "EXC380 *REAR*") {
			sel_year.empty().append(y98 + y99 + y00 + y01 + y02 + y03);
		} else if (sel_bike_model === "EXC400 *FRONT*" || sel_bike_model === "EXC400 *REAR*" || sel_bike_model === "SX400 *FRONT*" || sel_bike_model === "SX400 *REAR*") {
			sel_year.empty().append(y00 + y01 + y02);
		} else if (sel_bike_model === "EXC450 *FRONT*" || sel_bike_model === "EXC450 *REAR*" || sel_bike_model === "XC450 *FRONT*" || sel_bike_model === "XC450 *REAR*" || sel_bike_model === "XC-W450 *FRONT*" || sel_bike_model === "XC-W450 *REAR*") {
			sel_year.empty().append(y03 + y04 + y05 + y06 + y07 + y08 + y09);
		} else if (sel_bike_model === "EXC-F500 *FRONT*" || sel_bike_model === "EXC-F500 *REAR*" || sel_bike_model === "SX125 *FRONT*" || sel_bike_model === "SX125 *REAR*" || sel_bike_model === "SX250 *FRONT*" || sel_bike_model === "SX250 *REAR*") {
			sel_year.empty().append(y98 + y99 + y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "EXC525 *FRONT*" || sel_bike_model === "EXC525 *REAR*" || sel_bike_model === "SX525 *FRONT*" || sel_bike_model === "SX525 *REAR*") {
			sel_year.empty().append(y03 + y04 + y05 + y06 + y07);
		} else if (sel_bike_model === "EXC530 *FRONT*" || sel_bike_model === "EXC530 *REAR*" || sel_bike_model === "EXC-R530 *FRONT*" || sel_bike_model === "EXC-R530 *REAR*" || sel_bike_model === "XC105 *FRONT*" || sel_bike_model === "XC105 *REAR*" || sel_bike_model === "SX-F505 *FRONT*" || sel_bike_model === "SX-F505 *REAR*") {
			sel_year.empty().append(y08 + y09);
		} else if (sel_bike_model === "XC150 *FRONT*" || sel_bike_model === "XC150 *REAR*") {
			sel_year.empty().append(y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "XC-W150 *FRONT*" || sel_bike_model === "XC-W150 *REAR*") {
			sel_year.empty().append(y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "XC200 *FRONT*" || sel_bike_model === "XC200 *REAR*" || sel_bike_model === "XC-W200 *FRONT*" || sel_bike_model === "XC-W200 *REAR*") {
			sel_year.empty().append(y06 + y07 + y08 + y09);
		} else if (sel_bike_model === "XC250 *FRONT*" || sel_bike_model === "XC250 *REAR*" || sel_bike_model === "XC-W300 *FRONT*" || sel_bike_model === "XC-W300 *REAR*" || sel_bike_model === "XC300 *FRONT*" || sel_bike_model === "XC300 *REAR*" || sel_bike_model === "XC-W250 *FRONT*" || sel_bike_model === "XC-W250 *REAR*") {
			sel_year.empty().append(y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "XC400 *FRONT*" || sel_bike_model === "XC400 *REAR*" || sel_bike_model === "XC-W400 *FRONT*" || sel_bike_model === "XC-W400 *REAR*" || sel_bike_model === "XC530 *FRONT*" || sel_bike_model === "XC530 *REAR*" || sel_bike_model === "XC-W530 *FRONT*" || sel_bike_model === "XC-W530 *REAR*") {
			sel_year.empty().append(y08 + y09 + y10 + y11 + y12);
		} else if (sel_bike_model === "XC525 *FRONT*" || sel_bike_model === "XC525 *REAR*" || sel_bike_model === "XC-W525 *FRONT*" || sel_bike_model === "XC-W525 *REAR*") {
			sel_year.empty().append(y06 + y07);
		} else if (sel_bike_model === "SX105 *FRONT*" || sel_bike_model === "SX105 *REAR*") {
			sel_year.empty().append(y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11);
		} else if (sel_bike_model === "XC-F250 *FRONT*" || sel_bike_model === "XC-F250 *REAR*") {
			sel_year.empty().append(y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "SX144 *FRONT*" || sel_bike_model === "SX144 *REAR*") {
			sel_year.empty().append(y07 + y08);
		} else if (sel_bike_model === "SX150 *FRONT*" || sel_bike_model === "SX150 *REAR*") {
			sel_year.empty().append(y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "SX200 *FRONT*" || sel_bike_model === "SX200 *REAR*") {
			sel_year.empty().append(y03 + y04);
		} else if (sel_bike_model === "SXF250 *FRONT*" || sel_bike_model === "SXF250 *REAR*" || sel_bike_model === "SXF350 *FRONT*" || sel_bike_model === "SXF350 *REAR*") {
			sel_year.empty().append(y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "SX380 *FRONT*" || sel_bike_model === "SX380 *REAR*") {
			sel_year.empty().append(y98 + y99 + y00 + y01 + y02);
		} else if (sel_bike_model === "SXC400 *FRONT*" || sel_bike_model === "SXC400 *REAR*") {
			sel_year.empty().append(y98 + y99 + y00 + y01);
		} else if (sel_bike_model === "SX-RFS450 *FRONT*" || sel_bike_model === "SX-RFS450 *REAR*") {
			sel_year.empty().append(y03 + y04 + y05 + y06);
		} else if (sel_bike_model === "SX-F450 *FRONT*" || sel_bike_model === "SX-F450 *REAR*") {
			sel_year.empty().append(y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "Varg *FRONT*" || sel_bike_model === "Varg *REAR*") {
			sel_year.empty().append(y23 + y24);
		} else if (sel_bike_model === "SX520 *FRONT*" || sel_bike_model === "SX520 *REAR*") {
			sel_year.empty().append(y00 + y01 + y02);
		} else if (sel_bike_model === "SXC625 *FRONT*" || sel_bike_model === "SXC625 *REAR*") {
			sel_year.empty().append(y03 + y04 + y05);
		} else if (sel_bike_model === "690 Enduro ABS *FRONT*" || sel_bike_model === "690 Enduro ABS *REAR*") {
			sel_year.empty().append(y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "EXC-F350 *FRONT*" || sel_bike_model === "EXC-F350 *REAR*" || sel_bike_model === "XC-F350 *FRONT*" || sel_bike_model === "XC-F350 *REAR*" || sel_bike_model === "SX-F450 FACTORY EDITION *FRONT*" || sel_bike_model === "SX-F450 FACTORY EDITION *REAR*") {
			sel_year.empty().append(y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "EXC-F450 SIX DAYS *FRONT*" || sel_bike_model === "EXC-F450 SIX DAYS *REAR*" || sel_bike_model === "XC-W300 TPI SIX DAYS *FRONT*" || sel_bike_model === "XC-W300 TPI SIX DAYS *REAR*") {
			sel_year.empty().append(y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "XC TP250I *FRONT*" || sel_bike_model === "XC TP250I *REAR*" || sel_bike_model === "XC TP300I *FRONT*" || sel_bike_model === "XC TP300I *REAR*" || sel_bike_model === "XC-W300 TPI *FRONT*" || sel_bike_model === "XC-W300 TPI *REAR*") {
			sel_year.empty().append(y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "XC-W250 TPI *FRONT*" || sel_bike_model === "XC-W250 TPI *REAR*") {
			sel_year.empty().append(y18 + y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "XC-F450 *FRONT*" || sel_bike_model === "XC-F450 *REAR*") {
			sel_year.empty().append(y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "690 Enduro *FRONT*" || sel_bike_model === "690 Enduro *REAR*") {
			sel_year.empty().append(y08 + y09 + y10 + y11 + y12 + y13);
		} else if (sel_bike_model === "ES700 *FRONT*" || sel_bike_model === "ES700 *REAR*") {
			sel_year.empty().append(y23 + y24);
		} else if (sel_bike_model === "SMR 450 *FRONT*" || sel_bike_model === "SMR 450 *REAR*") {
			sel_year.empty().append(y23 + y24 + y25 + y26);
		} else if (sel_bike_model === "SM700 *FRONT*" || sel_bike_model === "SM700 *REAR*") {
			sel_year.empty().append(y23 + y24 + y25 + y26);
		} else if (sel_bike_model === "FS 450 *FRONT*" || sel_bike_model === "FS 450 *REAR*") {
			sel_year.empty().append(y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25 + y26);
		}


		// Model Suzuki Front
		else if (sel_bike_model === "2000 - 17 DRZ400 SE *FRONT*" || sel_bike_model === "2000 - 17 DRZ400 E *FRONT*") {
			sel_year.empty().append(y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "2014 - 2017  125 - 450 SXF *FRONT*") {
			sel_year.empty().append(y96 + y97 + y98 + y99 + y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18);
		} else if (sel_bike_model === "1996 - 17 DR650 *FRONT*" || sel_bike_model === "1996 - 17 DR650 *REAR*") {
			sel_year.empty().append(y96 + y97 + y98 + y99 + y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		}

		//Model Beta Front and REAR
		else if (sel_bike_model === "RR *FRONT*" || sel_bike_model === "RS *FRONT*" || sel_bike_model === "RR *REAR*" || sel_bike_model === "RS *REAR*") {
			sel_year.empty().append(y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		}

		// Model Suzuki Rear
		else if (sel_bike_model === "2000 - 17 DRZ400 SE *REAR*" || sel_bike_model === "2000 - 17 DRZ400 E *REAR*") {
			sel_year.empty().append(y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "2014 - 2017  125 - 450 SXF *REAR*") {
			sel_year.empty().append(y96 + y97 + y98 + y99 + y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18);
		} else if (sel_bike_model === "DRZ400SM *REAR*" || sel_bike_model === "DRZ400SM *FRONT*") {
			sel_year.empty().append(y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		} else {}


		// new logic for KTM 
			// NEW year as per AJ
		if(sel_bike_model.includes('EXC125')){
            sel_year.empty().append(y03 + y04 + y05);
        }else if(sel_bike_model.includes('SX125')){
            sel_year.empty().append(y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25);
        }else if(sel_bike_model.includes('SX144')){
            sel_year.empty().append(y07 + y08);
        }else if(sel_bike_model.includes('SX150')){
            sel_year.empty().append(y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25);
        }else if(sel_bike_model.includes('XC150')){
            sel_year.empty().append(y10 + y11 + y12 + y13 + y14);
        }else if(sel_bike_model.includes('XC-W150')){
            sel_year.empty().append(y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25);
        }else if(sel_bike_model.includes('200 EXC')){
            sel_year.empty().append(y03 + y04 + y05);
        }else if(sel_bike_model.includes('SX200')){
            sel_year.empty().append(y03 + y04);
        }else if(sel_bike_model.includes('XC200')){
            sel_year.empty().append(y06 + y07 + y08 + y09);
        }else if(sel_bike_model.includes('XC-W200')){
            sel_year.empty().append(y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17);
        }else if(sel_bike_model.includes('XC-W200')){
            sel_year.empty().append(y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17);
        }else if(sel_bike_model.includes('250SX')){
            sel_year.empty().append(y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25);
        }else if(sel_bike_model.includes('250XC')){
            sel_year.empty().append(y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14);
        }else if(sel_bike_model.includes('XC-F250')){
            sel_year.empty().append(y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25);
        }else if(sel_bike_model.includes('XC-W250')){
            sel_year.empty().append(y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25);
        }else if(sel_bike_model.includes('XCF-W250')){
            sel_year.empty().append(y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25);
        }else if(sel_bike_model.includes('EXC300')){
            sel_year.empty().append(y03 + y04 + y05);
        }else if(sel_bike_model.includes('XC300')){
            sel_year.empty().append(y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25);
        }else if(sel_bike_model.includes('XC-W300')){
            sel_year.empty().append(y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25);
        }else if(sel_bike_model.includes('EXC-F350')){
            sel_year.empty().append(y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25);
        }else if(sel_bike_model.includes('XC-F350')){
            sel_year.empty().append(y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25);
        }else if(sel_bike_model.includes('XCF-W350')){
            sel_year.empty().append(y12 + y13 + y14 + y15 + y16);
        }else if(sel_bike_model.includes('EXC400')){
            sel_year.empty().append(y03 + y04 + y05);          
        }else if(sel_bike_model.includes('XC-W450')){
            sel_year.empty().append(y07 + y08 + y09 + y10);        
        }else if(sel_bike_model.includes('EXC450')){
            sel_year.empty().append(y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11);          
        }else if(sel_bike_model.includes('SX450')){
            sel_year.empty().append(y03 + y04 + y05 + y06);        
        }else if(sel_bike_model.includes('SX-F450')){
            sel_year.empty().append(y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25);          
        }else if(sel_bike_model.includes('SX-F450 Factory Edition')){
            sel_year.empty().append(y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25);          
        }else if(sel_bike_model.includes('XC-F450')){
            sel_year.empty().append(y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25);          
        }else if(sel_bike_model.includes('XC-W450')){
            sel_year.empty().append(y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14);        
        }else if(sel_bike_model.includes('690 Enduro')){
            sel_year.empty().append(y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25);        
        }else if(sel_bike_model.includes('790 Adventure')){
            sel_year.empty().append(y18 + y19 + y20 + y21 + y22 + y23 + y24);          
        }else if(sel_bike_model.includes('890 Adventure')){
            sel_year.empty().append(y21 + y22 + y23 + y24 + y25);          
        }else if(sel_bike_model.includes('950 Adventure')){
            sel_year.empty().append(y06);          
        }else if(sel_bike_model.includes('990 Adventure')){
            sel_year.empty().append(y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13);        
        }else if(sel_bike_model.includes('1190 Adventure')){
            sel_year.empty().append(y13 + y14 + y15 + y16);        
        }else if(sel_bike_model.includes('1290 Adventure ABS')){
            sel_year.empty().append(y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25);        
        } else if (sel_bike_model === "701 Supermoto *FRONT*" || sel_bike_model === "701 Supermoto *REAR*") {
			sel_year.empty().append(y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25 + y26);
		}


		if(sel_bike_model == "ES500 *FRONT*" || sel_bike_model== "ES500 *REAR*"){
            sel_year.empty().append(y23 + y24 + y25);
		}
		// end of new logic for KTM 
		
		if (sel_year.find(`option[value="${previous_year}"]`).length > 0) {
			sel_year.val(previous_year); // Set the previous year as selected
		} else {
			sel_year.find('option:first').prop('selected', true); // Default to the first year
		}
	}

	var speedometer = function () {
		var wheel = $('select#wheel_type').val();
		var make = $('select#bike_make').val();
		var model = $('select#bike_model').val();

		const bikeMake = document.querySelector('#bike_make').value;
		const bikeYear = parseInt(document.querySelector('#bike_year').value, 10);
		// console.log({
		// 	bikeMake,bikeYear
		// });

		if (wheel == "FRONT") {

			if (1==2 && (make == "Husaberg" || model == "TC125 *FRONT*" || model == "FC 250 *FRONT*" || model == "TC 250 *FRONT*" || model == "FE 250 *FRONT*" || model == "TE 250 *FRONT*" || model == "2014 - 17 TE300 *FRONT*" || model == "2014 - 17 FC450 *FRONT*" || model == "2014 - 17 FE501 *FRONT*" || model == "TE150 *FRONT*" || model == "TX300i *FRONT*" || model == "FC450 Rockstar Edition *FRONT*" || model == "SM 125 *FRONT*" || model == "TC125 *FRONT*" || model == "TE 125 *FRONT*" || model == "TXC 125 *FRONT*" || model == "WR 125 *FRONT*" || model == "CR 125 *FRONT*" || model == "SM 250 *FRONT*" || model == "TC 250 *FRONT*" || model == "TE 250 *FRONT*" || model == "TXC 250 *FRONT*" || model == "WR 250 *FRONT*" || model == "CR 250 *FRONT*" || model == "SM 449 *FRONT*" || model == "TC 449 *FRONT*" || model == "TE 449 *FRONT*" || model == "TXC 449 *FRONT*" || model == "WR 449 *FRONT*" || model == "CR 449 *FRONT*" || model == "SM 450 *FRONT*" || model == "TC 450 *FRONT*" || model == "TE 450 *FRONT*" || model == "TXC 450 *FRONT*" || model == "WR 450 *FRONT*" || model == "CR 450 *FRONT*" || model == "SM 510 *FRONT*" || model == "TC 510 *FRONT*" || model == "TE 510 *FRONT*" || model == "TXC 510 *FRONT*" || model == "WR 510 *FRONT*" || model == "CR 510 *FRONT*" || model == "EXC125 *FRONT*" || model == "EXC-F350 *FRONT*" || model == "EXC520 *FRONT*" || model == "XC-W250 TPI *FRONT*" || model == "XCF-W250 *FRONT*" || model == "XC-W300 TPI *FRONT*" || model == "XC-F450 *FRONT*" || model == "XC-W500 *FRONT*" || model == "XC-F505 *FRONT*" || model == "SX450 *FRONT*" || model == "EXC200 *FRONT*" || model == "EXC-F250 *FRONT*" || model == "EXC300 *FRONT*" || model == "EXC380 *FRONT*" || model == "EXC400 *FRONT*" || model == "EXC450 *FRONT*" || model == "EXC350 *FRONT*" || model == "EXC-F500 *FRONT*" || model == "EXC-F450 *FRONT*" || model == "XC250 TPI *FRONT*" || model == "XC300 TPI *FRONT*" || model == "XC-W300 TPI Six Days *FRONT*" || model == "SX-F450 Factory Edition *FRONT*" || $('select#bike_model').val() == "TX125 *FRONT*" || $('select#bike_model').val() == "TE250I *FRONT*" || $('select#bike_model').val() == "TE300I *FRONT*" || $('select#bike_model').val() == "TX300 *FRONT*" || $('select#bike_model').val() == "FC350 *FRONT*" || $('select#bike_model').val() == "FE350 *FRONT*" || $('select#bike_model').val() == "FX350 *FRONT*" || $('select#bike_model').val() == "FE450 *FRONT*" || $('select#bike_model').val() == "FX450 *FRONT*" || model == "EXC525 *FRONT*" || model == "EXC530 *FRONT*" || model == "EXC-R530 *FRONT*" || model == "XC150 *FRONT*" || model == "XC-W150 *FRONT*" || model == "XC200 *FRONT*" || model == "XC-W200 *FRONT*" || model == "XC250 *FRONT*" || model == "XC-W250 *FRONT*" || model == "XC-F250 *FRONT*" || model == "XC300 *FRONT*" || model == "XC-W300 *FRONT*" || model == "XC-F350 *FRONT*" || model == "XCF-W350 *FRONT*" || model == "XC400 *FRONT*" || model == "XC-W400 *FRONT*" || model == "XC450 *FRONT*" || model == "XC-W450 *FRONT*" || model == "XC525 *FRONT*" || model == "XC-W525 *FRONT*" || model == "XC530 *FRONT*" || model == "XC-W530 *FRONT*" || model == "SX125 *FRONT*" || model == "SX144 *FRONT*" || model == "SX150 *FRONT*" || model == "SX200 *FRONT*" || model == "SX250 *FRONT*" || model == "SXF250 *FRONT*" || model == "SXF350 *FRONT*" || model == "SX380 *FRONT*" || model == "SX400 *FRONT*" || model == "SXC400 *FRONT*" || model == "SX-RFS450 *FRONT*" || model == "SX-F450 *FRONT*" || model == "Varg *FRONT*" || model == "SX-F505 *FRONT*" || model == "SX520 *FRONT*" || model == "SX525 *FRONT*")) {
				//Show Speedometer Magnets
				$("#speedometer").show();
				//Change Speedometer Options
				$('#sm_magnets').change(magnet_change);
				//Magnet Price Increase

			} else if((['KTM', 'Beta'].includes(bikeMake) || 
				(bikeMake === 'Husqvarna' && bikeYear >= 2014 && bikeYear <= 2025) || 
				(bikeMake === 'GasGas' && bikeYear >= 2020 && bikeYear <= 2025))){
					$("#speedometer").show();
					$('#sm_magnets').val($('#sm_magnets option:first').val());
					$('#sm_magnets').change(magnet_change);
			} else {
				//Hide Speedometer Magnets
				$("#sm_magnets").val('NO');
				$("#speedometer").hide();
			}

		} else { //Hide Speedometer Magnets
			$("#sm_magnets").val('NO');
			$("#speedometer").hide();
		}
	}

	let debounceTimer;
	let tire_image = {
		"GPR 300 150/60ZR17": "https://www.warp9racing.com/smwheel/sm_images/SM-REAR-tire650.png",
		"MICHELIN 2CT 150/60R17": "https://www.warp9racing.com/smwheel/sm_images/SM-REAR-tire650.png"
	}

	let debounceTimerPrice;
	document.addEventListener('wb_price_updated', function (e) {
		var data = e.detail;
		clearTimeout(debounceTimerPrice);
		debounceTimerPrice = setTimeout(function () {
			// console.log('Price Updated');
			console.log(data);
		}, 500);
	});

	var tprice = function () {
		// //Change Tire image
		// clearTimeout(debounceTimer);
		// debounceTimer = setTimeout(function() {
		// 	console.log("This code runs only once after a delay!");
		// 	var selected_tire = $('#mbtire').val();
		// 	// if( selected_tire == "GPR 300 150/60ZR17"){
		// 	// 	$('div#resultAreaID_1_10 img').attr('src', "https://www.warp9racing.com/smwheel/sm_images/SM-REAR-tire650.png");
		// 	// 	$('div#resultAreaID_1_10').show();
		// 	// }else{
		// 	// 	$('div#resultAreaID_1_10 img').attr('src', "");
		// 	// 	$('div#resultAreaID_1_10').hide();
		// 	// }

		// 	if( selected_tire != "mbno"){
		// 		$('div#resultAreaID_1_10 img').attr('src', "https://cdn.shopify.com/s/files/1/0676/2096/2552/files/SM-REAR-tire650_6d4c409a-011a-4913-a00a-2d296f7dca68.png?v=1729666392");
		// 		$('div#resultAreaID_1_10').show();
		// 	}else{
		// 		$('div#resultAreaID_1_10 img').attr('src', "");
		// 		$('div#resultAreaID_1_10').hide();
		// 	}
			
		// }, 500);
		if (role == "true") {
			var base_price = 630;
			var spoke_price = 0;
			var nipple_price = 0;
			var brake_price = 0;
			var wheel_size_price = 0;
			var sprocket_bolts = 39;
			var rotor_bolts = 12;
			var magnet_price = 0;
			var rim_color = 0;
			var hub_color = 0;
			var mbtire_price = 0;

			const brakeRotor = $('select#brake_rotor').val();
            const wheelType = $('#wheel_type').val();

            
           const brakePrices = {
                "320MM_FLOATING": {
                    "FRONT": 44,
                    "REAR": 47
                },
                "320MM_FIXED": {
                    "FRONT": 65,
                    "REAR": 20
            }
            };

            brake_price = brakePrices[brakeRotor]?.[wheelType] ?? 0;

			if ($('select#wheel_type').val() === "FRONT")
				base_price = 630;

			if ($('select#wheel_type').val() === "FRONT" || $('select#wheel_type').val() === "REAR") {
				if ($('#rim_color').val() === "Red" || $('#rim_color').val() === "Blue" || $('#rim_color').val() === "Gold" || $('#rim_color').val() === "Orange" || $('#rim_color').val() === "Purple" || $('#rim_color').val() === "Magnesium" || $('#rim_color').val() === "Green")
					rim_color = 0;
			}

			// RIM PRICE 0 IF ANOTIZED SILVER, BLACK, MATTE BLACK
			var rim_type = $('.rim-type-wrap.active').data('category');			
			var rim_color_value = $('#rim_color').val();
			if (rim_type === 'anodized') {
				if (rim_color_value == "Black" || rim_color_value == "Silver" || rim_color_value == "Matte-Black") {
					rim_color = 0;
				}
			}
			// RIM PRICE 0 IF ANOTIZED SILVER, BLACK, MATTE BLACK

			if ($('select#wheel_type').val() === "REAR") {
                base_price = 630;
				if ($('select#rim_size').val() === "REAR 17x5.00" || $('select#rim_size').val() === "REAR 17x5.00") {
					wheel_size_price = 150;
					brake_price = 0;
				}
			}


			if ($('select#wheel_type').val() === "REAR") {
                base_price = 630;
				if ($('select#rim_size').val() === "REAR 17x4.25" || $('select#rim_size').val() === "REAR 17x4.25") {
                    wheel_size_price = 100;
					brake_price = 0;
				}
			}

			if ($('#spoke_color').val() === "Silver")
				spoke_price = 0;

			if ($('#nipple_color').val() === "Silver")
				nipple_price = 0;

			if ($('#nipple_color').val() === "Black" || $('#nipple_color').val() === "Red" || $('#nipple_color').val() === "Blue" || $('#nipple_color').val() === "Orange" || $('#nipple_color').val() === "Magnesium" || $('#nipple_color').val() === "Green" || $('#nipple_color').val() === "Purple" || $('#nipple_color').val() === "Gold") {
				nipple_price = 25;
			}

			if ($('select#brake_rotor').val() === "fixed")
				brake_price = 0;

			if ($('select#bike_make').val() === "GasGas")
				brake_price = 0;
			if ($('select#brake_rotor').val() === "320MM_FLOATING") {
				brake_price = 95;
			}
			if ($('select#sprocket_bolts').val() === "Standard") {
				sprocket_bolts = 0;
			}
			if ($('select#rotor_bolts').val() === "Standard") {
				rotor_bolts = 0;
			}
			if ($('select#sm_magnets').val() == "NO") {
				magnet_price = 0;
			} else {
				magnet_price = 7;
			}
			//Mounted/Balanced Tire Price
			if ($('select#mbtire').val() === "mbyes") {
				if ($('select#rim_size').val() === "FRONT 17x3.50") {
					mbtire_price = 197;
				}
				if ($('select#rim_size').val() === "REAR 17x4.25") {
					mbtire_price = 217;
				}
				if ($('select#rim_size').val() === "REAR 17x5.00" || $('select#rim_size').val() === "REAR 17x5.00") {
					mbtire_price = 213;
				}
			} else if ($('select#mbtire').val() === "DG300") {
				if ($('select#rim_size').val() === "FRONT 17x3.50") {
					mbtire_price = 147;
				}
				if ($('select#rim_size').val() === "REAR 17x4.25") {
					mbtire_price = 167;
				}
				if ($('select#rim_size').val() === "REAR 17x5.00" || $('select#rim_size').val() === "REAR 17x5.00") {
					mbtire_price = 167;
				}
			}
			//No SPROCKET
			if ($('select#sprocket_size').val() == "no" && $('#wheel_type').val() == "REAR") {
                sprocket_price = 0;
			} 
		     else if ($('#wheel_type').val() == "FRONT"){
			sprocket_price = 0;
		    }		 
            else {
				sprocket_price = 29;
			}

			var mbtire = $('#mbtire').val();
			var tirePrices = {
                "Bridgestone Battlax Hypersport S22 110/70-17": 232.15,
                "Bridgestone Battlax Hypersport S22 120/70-17": 270.11,
                "Bridgestone Battlax Hypersport S22 150/60-17": 280.63,
                "Bridgestone Battlax Hypersport S22 160/60-17": 319.62,
                "Continental ContiAttack SM2 110/70-17": 273.95,
                "Continental ContiAttack SM2 120/70-17": 305.95,
                "Continental ContiAttack SM2 150/60-17": 367.95,
                "Continental ContiAttack SM2 160/60-17": 381.95,
                "Dunlop Sportmax Q5A 110/70-17": 190, // Q5S
                "Dunlop Sportmax Q5A 120/70-17": 209, // Q5S
                "Dunlop Sportmax Q5A 150/60-17": 225, // Q5S
                //"Dunlop Sportmax Q5S 160/60-17": 325.95, // Q5S
                "Dunlop Sportmax GPR-300 110/70ZR17": 145.95,
                "Dunlop Sportmax GPR-300 120/70ZR17": 151.95,
                "Dunlop Sportmax GPR-300 150/60ZR17":231.95,
                "Michelin Pilot Power 2CT 110/70ZR17": 218.95,
                "Michelin Pilot Power 2CT 120/70R17": 225.95,
                "Michelin Pilot Power 2CT 150/60R17":261.95,
                "Michelin Pilot Power 2CT 160/60R17":248.95,
                "Michelin Power 5 120/70R17": 269.95,
                "Michelin Power 5 160/60ZR17":286.95
			};
			var selectedPrice = tirePrices[mbtire];
			if (selectedPrice !== undefined) {
				mbtire_price = selectedPrice;
			} else {
				mbtire_price = mbtire_price
			}
			if ($('select#rotor_bolts').val() === "Standard") {
				rotor_bolts = 0;
			}else{
				rotor_bolts = 21;				
			}
			// console.log("Tire Pricesss: $" + mbtire_price);

			//       console.log(base_price , spoke_price , nipple_price , brake_price , wheel_size_price , rim_color , sprocket_bolts , rotor_bolts , magnet_price , mbtire_price , tubeless_wheel);

			// var price = base_price + spoke_price + nipple_price + brake_price + wheel_size_price + rim_color + sprocket_bolts + rotor_bolts + magnet_price + mbtire_price + tubeless_wheel;

			var price = base_price + spoke_price + nipple_price + brake_price + wheel_size_price + sprocket_bolts + rim_color + rotor_bolts + magnet_price + hub_color + mbtire_price + sprocket_price;

			new_base_price = price;
			const wb_price_updated = new CustomEvent('wb_price_updated', {
				detail: {
					base_price,
					spoke_price,
					nipple_price,
					brake_price,
					wheel_size_price,
					rim_color,
					sprocket_bolts,
					rotor_bolts,
					magnet_price,
					hub_color,
					mbtire_price,
					price
				}
			});
			document.dispatchEvent(wb_price_updated);
			$('#price').text('$' + price);
			$('#amount').val(price);
			$('#dlr_price').val(price);
			$('#description1').val($('select#bike_make').val());
			$('#description2').val($('select#bike_model').val());
			$('#description3').val(" rim_size:" + $('select#rim_size').val());
			$('#description4').val(" hub_color:" + $('#hub_color').val());
			$('#description5').val(" rim_color:" + $('#rim_color').val());
			$('#description6').val(" spoke_color:" + $('#spoke_color').val());
			$('#description7').val(" nipple_color:" + $('#nipple_color').val());
			$('#description8').val(" brake_rotor:" + $('select#brake_rotor').val());
			$('#description9').val(" sprocket_teeth:" + $('select#sprocket_size').val());
			var retail_price = retailPrice();
			$('#retail-price').text('$' + retail_price);
			// console.log('Retail price: ', retail_price);
		} else {
			var base_price = 858;
			var spoke_price = 0;
			var nipple_price = 0;
			var brake_price = 0;
			var wheel_size_price = 0;
			var rim_color = 0;
			var sprocket_bolts = 59;
			var rotor_bolts = 19;
			var magnet_price = 0;
			var mbtire_price = 0;
			// console.log("On price");

			const brakeRotor = $('select#brake_rotor').val();
            const wheelType = $('#wheel_type').val();

           const brakePrices = {
                "320MM_FLOATING": {
                    "FRONT": 58,
                    "REAR": 62
                },
                "320MM_FIXED": {
                    "FRONT": 81,
                    "REAR": 27
            }
            };

            brake_price = brakePrices[brakeRotor]?.[wheelType] ?? 0;
			
			if ($('select#wheel_type').val() === "FRONT")
				base_price = 858;

			if ($('select#wheel_type').val() === "FRONT" || $('select#wheel_type').val() === "REAR") {
				if ($('#rim_color').val() === "Red" || $('#rim_color').val() === "Blue" || $('#rim_color').val() === "Gold" || $('#rim_color').val() === "Orange" || $('#rim_color').val() === "Purple" || $('#rim_color').val() === "Magnesium")
					rim_color = 0;
			}
			// RIM PRICE 0 IF ANOTIZED SILVER, BLACK, MATTE BLACK
			var rim_type = $('.rim-type-wrap.active').data('category');			
			var rim_color_value = $('#rim_color').val();
			if (rim_type === 'anodized') {
				if (rim_color_value == "Black" || rim_color_value == "Silver" || rim_color_value == "Matte-Black") {
					rim_color = 0;
				}
			}
			// RIM PRICE 0 IF ANOTIZED SILVER, BLACK, MATTE BLACK
			if ($('select#wheel_type').val() === "REAR") {
                base_price = 876;
				if ($('select#rim_size').val() === "REAR 17x5.00" || $('select#rim_size').val() === "REAR 17x5.00") {
					wheel_size_price = 174;
					brake_price = 0;
				}
			}


			if ($('select#wheel_type').val() === "REAR") {
                base_price = 876;
				if ($('select#rim_size').val() === "REAR 17x4.25" || $('select#rim_size').val() === "REAR 17x4.25") {
					brake_price = 0;
                    wheel_size_price = 110;
				}
			}

			if ($('#spoke_color').val() === "Silver")
				spoke_price = 0;

			if ($('#nipple_color').val() === "Silver")
				nipple_price = 0;

			if ($('select#brake_rotor').val() === "fixed")
				brake_price = 0;

			if ($('select#bike_make').val() === "GasGas")
				brake_price = 0;
			if ($('select#brake_rotor').val() === "320MM_FLOATING") {
				brake_price = 95;
			}
			if ($('select#sprocket_bolts').val() === "Standard") {
				sprocket_bolts = 0;
			}
			if ($('select#rotor_bolts').val() === "Standard") {
				rotor_bolts = 0;
			}
			if ($('select#sm_magnets').val() == "NO") {
				magnet_price = 0;
			} else {
				magnet_price = 11;
			}
			//Mounted/Balanced Tire Price
			if ($('select#mbtire').val() === "mbyes") {
				if ($('select#rim_size').val() === "FRONT 17x3.50") {
					mbtire_price = 197;
				}
				if ($('select#rim_size').val() === "REAR 17x4.25") {
					mbtire_price = 217;
				}
				if ($('select#rim_size').val() === "REAR 17x5.00" || $('select#rim_size').val() === "REAR 17x5.00") {
					mbtire_price = 213;
				}
			} else if ($('select#mbtire').val() === "DG300") {
				if ($('select#rim_size').val() === "FRONT 17x3.50") {
					mbtire_price = 147;
				}
				if ($('select#rim_size').val() === "REAR 17x4.25") {
					mbtire_price = 167;
				}
				if ($('select#rim_size').val() === "REAR 17x5.00" || $('select#rim_size').val() === "REAR 17x5.00") {
					mbtire_price = 167;
				}
			}
			//No SPROCKET
			if ($('select#sprocket_size').val() == "no" && $('#wheel_type').val() == "REAR") {
                sprocket_price = 0;
			} 
		     else if ($('#wheel_type').val() == "FRONT"){
			sprocket_price = 0;
		    }		 
            else {
				sprocket_price = 38;
			}

			var mbtire = $('#mbtire').val();
			var tirePrices = {
                "Bridgestone Battlax Hypersport S22 110/70-17": 232.15,
                "Bridgestone Battlax Hypersport S22 120/70-17": 270.11,
                "Bridgestone Battlax Hypersport S22 150/60-17": 280.63,
                "Bridgestone Battlax Hypersport S22 160/60-17": 319.62,
                "Continental ContiAttack SM2 110/70-17": 273.95,
                "Continental ContiAttack SM2 120/70-17": 305.95,
                "Continental ContiAttack SM2 150/60-17": 367.95,
                "Continental ContiAttack SM2 160/60-17": 381.95,
                "Dunlop Sportmax Q5A 110/70-17": 190, // Q5S
                "Dunlop Sportmax Q5A 120/70-17": 209, // Q5S
                "Dunlop Sportmax Q5A 150/60-17": 225, // Q5S
                //"Dunlop Sportmax Q5S 160/60-17": 325.95, // Q5S
                "Dunlop Sportmax GPR-300 110/70ZR17": 145.95,
                "Dunlop Sportmax GPR-300 120/70ZR17": 151.95,
                "Dunlop Sportmax GPR-300 150/60ZR17":231.95,
                "Michelin Pilot Power 2CT 110/70ZR17": 218.95,
                "Michelin Pilot Power 2CT 120/70R17": 225.95,
                "Michelin Pilot Power 2CT 150/60R17":261.95,
                "Michelin Pilot Power 2CT 160/60R17":248.95,
                "Michelin Power 5 120/70R17": 269.95,
                "Michelin Power 5 160/60ZR17":286.95
			};
			var selectedPrice = tirePrices[mbtire];
			if (selectedPrice !== undefined) {
				mbtire_price = selectedPrice;
			} else {
				mbtire_price = mbtire_price
			}
			// console.log("Tire Pricesss: $" + mbtire_price);

			if ($('select#rotor_bolts').val() === "Standard") {
				rotor_bolts = 0;
			}else{
				rotor_bolts = 31;				
			}
			var price = base_price + spoke_price + nipple_price + brake_price + wheel_size_price + sprocket_bolts + rim_color + rotor_bolts + magnet_price + mbtire_price + sprocket_price;
			new_base_price = price;
			const wb_price_updated = new CustomEvent('wb_price_updated', {
				detail: {
					base_price,
					spoke_price,
					nipple_price,
					brake_price,
					wheel_size_price,
					rim_color,
					sprocket_bolts,
					rotor_bolts,
					sprocket_price,
					magnet_price,
					mbtire_price,
					price
				}
			});
			document.dispatchEvent(wb_price_updated);
			$('#price').text('$' + price);
			$('#amount').val(price);
			$('#rgr_price').val(price);
			$('#description1').val($('select#bike_make').val());
			$('#description2').val($('select#bike_model').val());
			$('#description3').val(" rim_size:" + $('select#rim_size').val());
			$('#description4').val(" hub_color:" + $('#hub_color').val());
			$('#description5').val(" rim_color:" + $('#rim_color').val());
			$('#description6').val(" spoke_color:" + $('#spoke_color').val());
			$('#description7').val(" nipple_color:" + $('#nipple_color').val());
			$('#description8').val(" brake_rotor:" + $('select#brake_rotor').val());
			$('#description9').val(" sprocket_teeth:" + $('select#sprocket_size').val());
		}
	}
	var retailPrice = function () {
			var base_price = 858;
			var spoke_price = 0;
			var nipple_price = 0;
			var brake_price = 0;
			var wheel_size_price = 0;
			var rim_color = 0;
			var sprocket_bolts = 59;
			var rotor_bolts = 19;
			var magnet_price = 0;
			var mbtire_price = 0;

			const brakeRotor = $('select#brake_rotor').val();
            const wheelType = $('#wheel_type').val();

             const brakePrices = {
                "320MM_FLOATING": {
                    "FRONT": 58,
                    "REAR": 62
                },
                "320MM_FIXED": {
                    "FRONT": 81,
                    "REAR": 27
            }
            };

            brake_price = brakePrices[brakeRotor]?.[wheelType] ?? 0;

			// console.log("On price");
			if ($('select#wheel_type').val() === "FRONT")
				base_price = 858;

			if ($('select#wheel_type').val() === "FRONT" || $('select#wheel_type').val() === "REAR") {
				if ($('#rim_color').val() === "Red" || $('#rim_color').val() === "Blue" || $('#rim_color').val() === "Gold" || $('#rim_color').val() === "Orange" || $('#rim_color').val() === "Purple" || $('#rim_color').val() === "Magnesium")
					rim_color = 0;
			}
			// RIM PRICE 0 IF ANOTIZED SILVER, BLACK, MATTE BLACK
			var rim_type = $('.rim-type-wrap.active').data('category');			
			var rim_color_value = $('#rim_color').val();
			if (rim_type === 'anodized') {
				if (rim_color_value == "Black" || rim_color_value == "Silver" || rim_color_value == "Matte-Black") {
					rim_color = 0;
				}
			}
			// RIM PRICE 0 IF ANOTIZED SILVER, BLACK, MATTE BLACK
			if ($('select#wheel_type').val() === "REAR") {
                base_price = 876;
				if ($('select#rim_size').val() === "REAR 17x5.00" || $('select#rim_size').val() === "REAR 17x5.00") {
					wheel_size_price = 174;
					brake_price = 0;
				}
			}


			if ($('select#wheel_type').val() === "REAR") {
                base_price = 876;
				if ($('select#rim_size').val() === "REAR 17x4.25") {
					brake_price = 0;
                    wheel_size_price = 110;
				}
			}

			if ($('#spoke_color').val() === "Silver")
				spoke_price = 0;

			if ($('#nipple_color').val() === "Silver")
				nipple_price = 0;

			if ($('select#brake_rotor').val() === "fixed")
				brake_price = 0;

			if ($('select#bike_make').val() === "GasGas")
				brake_price = 0;
			if ($('select#brake_rotor').val() === "320MM_FLOATING") {
				brake_price = 95;
			}
			if ($('select#sprocket_bolts').val() === "Standard") {
				sprocket_bolts = 0;
			}
			if ($('select#rotor_bolts').val() === "Standard") {
				rotor_bolts = 0;
			}
			if ($('select#sm_magnets').val() == "NO") {
				magnet_price = 0;
			} else {
				magnet_price = 11;
			}
			//Mounted/Balanced Tire Price
			if ($('select#mbtire').val() === "mbyes") {
				if ($('select#rim_size').val() === "FRONT 17x3.50") {
					mbtire_price = 197;
				}
				if ($('select#rim_size').val() === "REAR 17x4.25") {
					mbtire_price = 217;
				}
				if ($('select#rim_size').val() === "REAR 17x5.00" || $('select#rim_size').val() === "REAR 17x5.00") {
					mbtire_price = 213;
				}
			} else if ($('select#mbtire').val() === "DG300") {
				if ($('select#rim_size').val() === "FRONT 17x3.50") {
					mbtire_price = 147;
				}
				if ($('select#rim_size').val() === "REAR 17x4.25") {
					mbtire_price = 167;
				}
				if ($('select#rim_size').val() === "REAR 17x5.00" || $('select#rim_size').val() === "REAR 17x5.00") {
					mbtire_price = 167;
				}
			}
			//No SPROCKET
			if ($('select#sprocket_size').val() == "no" && $('#wheel_type').val() == "REAR") {
                sprocket_price = 0;
			} 
		     else if ($('#wheel_type').val() == "FRONT"){
			sprocket_price = 0;
		    }		 
            else {
				sprocket_price = 38;
			}

			var mbtire = $('#mbtire').val();
			var tirePrices = {
                "Bridgestone Battlax Hypersport S22 110/70-17": 232.15,
                "Bridgestone Battlax Hypersport S22 120/70-17": 270.11,
                "Bridgestone Battlax Hypersport S22 150/60-17": 280.63,
                "Bridgestone Battlax Hypersport S22 160/60-17": 319.62,
                "Continental ContiAttack SM2 110/70-17": 273.95,
                "Continental ContiAttack SM2 120/70-17": 305.95,
                "Continental ContiAttack SM2 150/60-17": 367.95,
                "Continental ContiAttack SM2 160/60-17": 381.95,
                "Dunlop Sportmax Q5A 110/70-17": 190, // Q5S
                "Dunlop Sportmax Q5A 120/70-17": 209, // Q5S
                "Dunlop Sportmax Q5A 150/60-17": 225, // Q5S
                //"Dunlop Sportmax Q5S 160/60-17": 325.95, // Q5S
                "Dunlop Sportmax GPR-300 110/70ZR17": 145.95,
                "Dunlop Sportmax GPR-300 120/70ZR17": 151.95,
                "Dunlop Sportmax GPR-300 150/60ZR17":231.95,
                "Michelin Pilot Power 2CT 110/70ZR17": 218.95,
                "Michelin Pilot Power 2CT 120/70R17": 225.95,
                "Michelin Pilot Power 2CT 150/60R17":261.95,
                "Michelin Pilot Power 2CT 160/60R17":248.95,
                "Michelin Power 5 120/70R17": 269.95,
                "Michelin Power 5 160/60ZR17":286.95
			};
			var selectedPrice = tirePrices[mbtire];
			if (selectedPrice !== undefined) {
				mbtire_price = selectedPrice;
			} else {
				mbtire_price = mbtire_price
			}
			// console.log("Tire Pricesss: $" + mbtire_price);

			if ($('select#rotor_bolts').val() === "Standard") {
				rotor_bolts = 0;
			}else{
				rotor_bolts = 31;				
			}
			var price = base_price + spoke_price + nipple_price + brake_price + wheel_size_price + sprocket_bolts + rim_color + rotor_bolts + magnet_price + mbtire_price + sprocket_price;
			return price;
		
	}
	$('select#bike_model').change(speedometer);
	$('select#bike_make').change(bikeyear);
	$('select#bike_model').change(spoketitanium);
	$('select#bike_make').change(speedometer);
	$('select#wheel_type').change(speedometer);
	$('select#bike_year').change(speedometer);

	$('select#bike_year').change(spoketitanium);
	$('select#rim_size').change(spoketitanium);
	$('select#wheel_type').change(spoketitanium);

	$('select#bike_make').change(tprice);
	$('select#bike_model').change(tprice);
	$('select#carrier_id').change(tprice);


	$('select#rim_size').change(tprice);
	$('select#brake_rotor').change(tprice);
	$('select#sprocket_size').change(tprice);
	$('select#wheel_type').change(tprice);
	$('select#rim_type').change(tprice);
	$('select#cush_drive').change(tprice);
	$('select#sprocket_bolts').change(tprice);
	$('select#rotor_bolts').change(tprice);
	$('select#sm_magnets').change(tprice);




	$('select#wheel_type').change(function () {
		var bikeModelSelect = document.getElementById("bike_model");
		const selectedText = bikeModelSelect.options[bikeModelSelect.selectedIndex].text;
		
		var select_model = $('select#bike_model');
		$("option:selected", select_model).removeAttr("selected");
		$('select#hidden_bike_model option').appendTo('select#bike_model');
		switch (this.value) {
			default:
			case 'FRONT':
				$('select#bike_model option.rear').appendTo('select#hidden_bike_model');

				break;
			case 'REAR':
				$('select#bike_model option.front').appendTo('select#hidden_bike_model');
				break;
		}
		select_model.val(select_model.find('option').first().val()).change();

		var bikeModelSelect = document.getElementById("bike_model");
		var options = bikeModelSelect.options;

		for (let i = 0; i < options.length; i++) {
			if (options[i].text === selectedText) {
				bikeModelSelect.selectedIndex = i;
				break;
			}
		}

		select_model.change();

		if ($('select#rim_size').val() == 'FRONT 16.5x3.50') {
			var select = $('#rim_color');
			select.empty().append('<option class="category" value="Black">Black</option>');
			var image_name = images + $('select#rim_type').val() + "-rim-" + $('#rim_color').val() + "-" + $('select#wheel_type').val() + ".png";
			var imageArr2 = [image_name];
			var divArr2 = ["resultAreaID_1_1"];
			$('#resultAreaID_1_1 img').attr('src', image_name);
		} else {
			var select = $('#rim_color');
			select.empty().append('<option class="category" value="Silver">Silver</option><option class="category" value="Black">Black</option><option class="category" value="Red">Red</option><option class="category" value="Blue">Blue</option><option class="category" value="Gold">Gold</option><option class="category" value="Orange">Orange</option><option class="category" value="Purple">Purple</option><option class="category" value="Magnesium">Magnesium</option>');

		}
		$('#rotor_bolts').prop('selectedIndex', 0);
		//Mounted/Balanced Tire Help Text
		$('select#mbtire').val("mbno");
		$('#resultAreaID_1_10').hide();


		if (navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i)) {
			mountedtirehelptextmobile();
		} else {
			mountedtirehelptext();
		}
		if ($('select#wheel_type').val() === "REAR") {
			$("#resultAreaID_1_10, #resultAreaID_1_0, #resultAreaID_1_1, #resultAreaID_1_2, #resultAreaID_1_3, #resultAreaID_1_4, #resultAreaID_1_5").removeClass("wheel");
			$("#resultAreaID_1_10").removeClass("front-wheel");
			$("#resultAreaID_1_10").addClass("rear-wheel");
			$("#resultAreaID_1_0, #resultAreaID_1_1, #resultAreaID_1_2, #resultAreaID_1_3, #resultAreaID_1_4, #resultAreaID_1_5").addClass("tire-img");
			if ($('select#rim_type').val() === "Switch") {
				$("#resultAreaID_1_10").addClass("switch-img");
				$("#resultAreaID_1_10").removeClass("rear-wheel");
			} else {
				$("#resultAreaID_1_10").addClass("rear-wheel");
				$("#resultAreaID_1_10").removeClass("switch-img");
			}
		} else {
			$("#resultAreaID_1_0, #resultAreaID_1_1, #resultAreaID_1_2, #resultAreaID_1_3, #resultAreaID_1_4, #resultAreaID_1_5").removeClass("tire-img");
			$("#resultAreaID_1_10").removeClass("rear-wheel");
			$("#resultAreaID_1_0, #resultAreaID_1_1, #resultAreaID_1_2, #resultAreaID_1_3, #resultAreaID_1_4, #resultAreaID_1_5").addClass("wheel");
			$("#resultAreaID_1_10").addClass("wheel front-wheel");
			$("#resultAreaID_1_10").removeClass("switch-img");
		}

	});

	$('select#wheel_type').change(function () {
				switch (this.value) {
			default:
			case 'FRONT':
				var rim_size = {
					'FRONT 17x3.50': 'FRONT 17x3.50'
				};

				break;
			case 'REAR':

				var rim_size = {
					'REAR 17x4.25': 'REAR 17x4.25',
					'REAR 17x5.00': 'REAR 17x5.00'
				};

				break;
		}
		var rimSizeSelect = $('select#rim_size');
		// console.log({
		// 	rim_size
		// });
		rimSizeSelect.empty();
		$.each(rim_size, function (value, text) {
			// Create a new option element and append it to the select element
			rimSizeSelect.append($('<option>', {
				value: value,
				text: text
			}));
		});
		$('#stem_color').prop('selectedIndex', 0);
		var select = $('#rim_type');
		select.empty().append('<option class="category" value="Stiletto">Stiletto</option><option class="category" value="Switch">Switch</option><option class="category" value="Rogue">Rogue</option>');
		if ($('select#wheel_type').val() == "FRONT") {
			//BRAKE TYPE
			var image_name = images + "brake-320MM_FLOATING" + "-" + $('select#wheel_type').val() + ".png";
			var imageArr5 = [image_name];
			var divArr5 = ["resultAreaID_1_6"];
			$('#resultAreaID_1_6 img').attr('src', image_name);
			$('.apex').css("display", "none");
		} else {
			//BRAKE TYPE
			var image_name = images + $('#hub_color').val() + "-sprocket-and-carrier.png";
			var imageArr5 = [image_name];
			var divArr5 = ["resultAreaID_1_6"];
			$('#resultAreaID_1_6 img').attr('src', image_name);
			$('.apex').css("display", "block");
		}
		//HUB COLOR
		var image_name = images + $('select#rim_type').val() + "-hub-" + $('#hub_color').val() + "-" + $('select#wheel_type').val() + ".png";
		var imageArr1 = [image_name];
		var divArr1 = ["resultAreaID_1_0"];
		$('#resultAreaID_1_0 img').attr('src', image_name);
		//RIM COLOR
		var image_name = images + $('select#rim_type').val() + "-rim-" + $('#rim_color').val() + "-" + $('select#wheel_type').val() + ".png";

		var imageArr2 = [image_name];
		var divArr2 = ["resultAreaID_1_1"];
		$('#resultAreaID_1_1 img').attr('src', image_name);

		//SPOKE COLOR
		var image_name = images + "spokes-" + $('#spoke_color').val() + "-" + $('select#wheel_type').val() + ".png";
		var imageArr3 = [image_name];
		var divArr3 = ["resultAreaID_1_2"];
		$('#resultAreaID_1_2 img').attr('src', image_name);
		//NIPPLE COLOR
		var image_name = images + $('select#rim_type').val() + "-valvestem-" + $('select#stem_color').val() + "-" + $('select#wheel_type').val() + ".png";
		var imageArr4 = [image_name];
		var divArr4 = ["resultAreaID_1_3"];
		$('#resultAreaID_1_3 img').attr('src', image_name);
		// $("#resultAreaID_1_3").find("img").unwrap();
		//SPROCKET SIZE
		var image_name = images + "rubbers.png";
		var imageArr6 = [image_name];
		var divArr6 = ["resultAreaID_1_7"];
		$('#resultAreaID_1_7 img').attr('src', image_name);

		if ($('select#bike_make').val() == 'KTM' && $('select#wheel_type').val() == 'REAR') {

			var select = $('#sprocket_size');
			
			select.empty().append('<option value="no">No Sprocket</option><option class="category" value="38 Teeth">38 Teeth</option><option class="category" value="39 Teeth">39 Teeth</option><option class="category" value="40 Teeth">40 Teeth</option><option class="category" value="41 Teeth">41 Teeth</option><option class="category" value="42 Teeth">42 Teeth</option><option class="category" value="43 Teeth">43 Teeth</option><option class="category" value="44 Teeth">44 Teeth</option><option class="category" value="45 Teeth">45 Teeth</option><option class="category" value="46 Teeth">46 Teeth</option><option class="category" value="47 Teeth">47 Teeth</option><option class="category" value="48 Teeth">48 Teeth</option><option class="category" value="49 Teeth">49 Teeth</option><option class="category" value="50 Teeth">50 Teeth</option><option class="category" value="51 Teeth">51 Teeth</option><option class="category" value="52 Teeth">52 Teeth</option><option class="category" value="53 Teeth">53 Teeth</option>');
		} else {
			var select = $('#sprocket_size');
			select.empty().append('<option value="no">No Sprocket</option><option class="category" value="40 Teeth">40 Teeth</option><option class="category" value="41 Teeth">41 Teeth</option><option class="category" value="42 Teeth">42 Teeth</option><option class="category" value="43 Teeth">43 Teeth</option><option class="category" value="44 Teeth">44 Teeth</option><option class="category" value="45 Teeth">45 Teeth</option><option class="category" value="46 Teeth">46 Teeth</option><option class="category" value="47 Teeth">47 Teeth</option><option class="category" value="48 Teeth">48 Teeth</option><option class="category" value="49 Teeth">49 Teeth</option><option class="category" value="50 Teeth">50 Teeth</option><option class="category" value="51 Teeth">51 Teeth</option><option class="category" value="52 Teeth">52 Teeth</option>');
		}

		if ($('select#wheel_type').val() == 'FRONT') {
			$('#sprocket').hide();
			// $('#resultAreaID_1_7').removeClass("show");
		} else {
			var select = $('#sprocket_size');
			select.val('no');
			$('#sprocket_size').change();
			$('#sprocket').show();
			

			$('#resultAreaID_1_7').show();
		}
		if ($('select#wheel_type').val() == 'REAR' && $('select#bike_make').val() == 'Honda') {
			var select = $('#rim_size');
			select.empty().append('<option value="REAR 17x4.25">17x4.25</option><option value="REAR 17x5.00">17x5.00</option>');
		}
		if ($('select#wheel_type').val() === "REAR") {
			//Display Cush Hub
			var image_name = images + $('select#rim_type').val() + "-hub-" + $('#hub_color').val() + '-' + $('select#wheel_type').val() + ".png";
			var imageArr5 = [image_name];
			var divArr5 = ["resultAreaID_1_0"];
			$('#resultAreaID_1_0 img').attr('src', image_name);
			//sprocket, carrier, and rubbers for Cush 
			var image_name = images + $('#hub_color').val() + "-sprocket-and-carrier.png";
			var imageArr5 = [image_name];
			var divArr5 = ["resultAreaID_1_6"];
			$('#resultAreaID_1_6 img').attr('src', image_name);

			//sprocket, carrier, and rubbers for Cush 
			var image_name = images + "rubbers.png";
			var imageArr7 = [image_name];
			var divArr7 = ["resultAreaID_1_7"];
			$('#resultAreaID_1_7 img').attr('src', image_name);
			$('#resultAreaID_1_7').css("display", "block");

			//Apex Image 
			var image_name = images + "Apex-rear-rotor.png";
			var imageArr8 = [image_name];
			var divArr8 = ["resultAreaID_1_8"];
			$('#resultAreaID_1_8 img').attr('src', image_name);
			$('#resultAreaID_1_8').css("display", "block");

			document.getElementById('resultAreaID_1_6').style.width = '175px';
			document.getElementById('resultAreaID_1_6').style.height = '106px';
			$('#resultAreaID_1_4').show();
		} else {
			var image_name = images + $('select#rim_type').val() + "-hub-" + $('#hub_color').val() + "-" + $('select#wheel_type').val() + ".png";
			var imageArr1 = [image_name];
			var divArr1 = ["resultAreaID_1_0"];
			$('#resultAreaID_1_0 img').attr('src', image_name);
			var image_name = images + "brake-320MM_FLOATING" + "-" + $('select#wheel_type').val() + ".png";
			var imageArr5 = [image_name];
			var divArr5 = ["resultAreaID_1_6"];
			$('#resultAreaID_1_6 img').attr('src', image_name);
			// document.getElementById('rotor-text').style.margin = '';
			// document.getElementById('rotor-text').style.top = '';
			document.getElementById('resultAreaID_1_6').style.width = '';
			document.getElementById('resultAreaID_1_6').style.height = '';
			document.getElementById('resultAreaID_1_6').style.top = '';
			$('#resultAreaID_1_7').css("display", "none");
			if ($('#speedometer').css('display') != 'none') {
				// $("#sm_magnets").val('NO');
				if ($("select#sm_magnets").val() == "BLACK" || $("select#sm_magnets").val() == "BLUE" || $("select#sm_magnets").val() == "ORANGE") {
					$("#resultAreaID_1_7").show();
					var image_name = images + "magnet-" + $('select#sm_magnets').val() + '-' + $('select#wheel_type').val() + ".png";
					var imageArr6 = [image_name];
					var divArr6 = ["resultAreaID_1_7"];
					$('#resultAreaID_1_7 img').attr('src', image_name);
				} else if ($("select#sm_magnets").val() == "NO") {
					$("#resultAreaID_1_7").hide();
				} else {
					var image_name = images + "sprocket.png";
					var imageArr6 = [image_name];
					var divArr6 = ["resultAreaID_1_7"];
					$('#resultAreaID_1_7 img').attr('src', image_name);
				}
			} else {
				var image_name = images + "rubbers.png";
				var imageArr7 = [image_name];
				var divArr7 = ["resultAreaID_1_7"];
				$('#resultAreaID_1_7 img').attr('src', image_name);
			}
		}
		if ($('select#wheel_type').val() == "FRONT") {

			var select = $('#sprocket_bolts');
			select.empty().append('<option class="category" value="Standard">Standard</option><option class="category" value="Titanium">Titanium</option>');
			$('#sprocketbolts').css("display", "none");
			$('#resultAreaID_1_7').css("display", "none");
			document.getElementById('resultAreaID_1_7').style.height = '150px';
		} else {
			$('#sprocketbolts').css("display", "block");
			document.getElementById('resultAreaID_1_7').style.height = '124px';
		}


		var select = $('#rim_type');
		select.empty().append('<option class="category" value="Stiletto">Stiletto</option><option class="category" value="Switch">Switch</option><option class="category" value="Rogue">Rogue</option>');
		if ($('#rim_type') == "Stiletto") {
			// var select = $('#rim_color');
			// select.empty().append('<option class="category" value="Silver">Silver</option><option class="category" value="Black">Black</option><option class="category" value="Red">Red</option><option class="category" value="Blue">Blue</option><option class="category" value="Gold">Gold</option><option class="category" value="Orange">Orange</option><option class="category" value="Purple">Purple</option><option class="category" value="Magnesium">Magnesium</option>');

			var rim_color_wrapper = $('.rim_color_wrapper');
			rim_color_wrapper.empty().append(`<div class="color-swatch active" data-value="Silver" style="background: url(${colorImages}silver.svg?v=1717478021);"><div class="color-swatch" data-value="Matte-Black" style="background: url(${colorImages}matte-black.svg?v=1717478021);"><div class="color-swatch" data-value="Black" style="background: url(${colorImages}black.svg?v=1717478021);"><div class="color-swatch" data-value="Red" style="background: url(${colorImages}red.svg?v=1717478021);"><div class="color-swatch" data-value="Blue" style="background: url(${colorImages}blue.svg?v=1717478021);"><div class="color-swatch" data-value="Gold" style="background: url(${colorImages}gold.svg?v=1717478021);"><div class="color-swatch" data-value="Orange" style="background: url(${colorImages}orange.svg?v=1717478021);"><div class="color-swatch" data-value="Purple" style="background: url(${colorImages}purple.svg?v=1717478021);"><div class="color-swatch" data-value="Magnesium" style="background: url(${colorImages}magnesium.svg?v=1717478021);">`);

			var image_name = images + $('select#rim_type').val() + "-rim-" + $('#rim_color').val() + "-" + $('select#wheel_type').val() + ".png";
			var imageArr2 = [image_name];
			var divArr2 = ["resultAreaID_1_1"];
			$('#resultAreaID_1_1 img').attr('src', image_name);

			var image_name = images + $('select#rim_type').val() + "-hub-" + $('#hub_color').val() + '-' + $('select#wheel_type').val() + ".png";
			var imageArr5 = [image_name];
			var divArr5 = ["resultAreaID_1_0"];
			imageObj5 = new BL_ImageLoader(divArr5, imageArr5);

			var image_name = images + $('select#rim_type').val() + "-valvestem-" + $('select#stem_color').val() + "-" + $('select#wheel_type').val() + ".png";
			var imageArr4 = [image_name];
			var divArr4 = ["resultAreaID_1_3"];
			$('#resultAreaID_1_3 img').attr('src', image_name);
			// $("#resultAreaID_1_3").find("img").unwrap();
		}


		var select = $('#hub_color');
		select.empty().append(' <option class="category" value="Silver">Silver</option><option class="category" value="Matte-Black">Matte Black</option><option class="category" value="Black">Black</option><option class="category" value="Red">Red</option><option class="category" value="Blue">Blue</option><option class="category" value="Gold">Gold</option><option class="category" value="Orange">Orange</option><option class="category" value="Purple">Purple</option><option class="category" value="Magnesium">Magnesium</option>');
		nosprocket();
	});

	$('select#wheel_type').change(function () {

		var bikeModelSelect = document.getElementById("bike_model");
		const selectedText = bikeModelSelect.options[bikeModelSelect.selectedIndex].text;
		// console.log('here');
		var select_model = $('select#bike_model');

		$("option:selected", select_model).removeAttr("selected");
		$('select#hidden_bike_model option').appendTo('select#bike_model');
		switch (this.value) {
			default:
			case 'FRONT':
				$('select#bike_model option.rear').appendTo('select#hidden_bike_model');
				break;
			case 'REAR':
				$('select#bike_model option.front').appendTo('select#hidden_bike_model');
				break;
		}
		select_model.val(select_model.find('option').first().val()).change();

		var bikeModelSelect = document.getElementById("bike_model");
		var options = bikeModelSelect.options;

		for (let i = 0; i < options.length; i++) {
			if (options[i].text === selectedText) {
				bikeModelSelect.selectedIndex = i;
				break;
			}
		}

		select_model.change();
		
		$('#rotor_bolts').prop('selectedIndex', 0);

		switch (this.value) {
			default:
			case 'FRONT':
				var rim_size = {
					'FRONT 17x3.50': 'FRONT 17x3.50'
				};

				break;
			case 'REAR':

				var rim_size = {
					'REAR 17x4.25': 'REAR 17x4.25',
					'REAR 17x5.00': 'REAR 17x5.00'
				};

				break;
		}
		var rimSizeSelect = $('select#rim_size');
		// console.log({
		// 	rim_size
		// });
		rimSizeSelect.empty();
		$.each(rim_size, function (value, text) {
			// Create a new option element and append it to the select element
			rimSizeSelect.append($('<option>', {
				value: value,
				text: text
			}));
		});

			var select = $('#sprocket_size');
			select.val('no');
			select.change();
	});

	$(document).on("change", "#rim_color", function () {
		var image_name = "https://cdn.shopify.com/s/files/1/0676/2096/2552/files/tw-rim-" + $('#rim_color').val() + "-" + $('select#wheel_type').val() + ".png";
		var imageArr2 = [image_name];
		var divArr2 = ["resultAreaID_1_1"];
		// $('#resultAreaID_1_1 img').attr('src', image_name );
		$('#resultAreaID_1_1 img').attr('src', image_name);
	});

	var rimcolorSwatches = $('.rim_color_wrapper .color-swatch');
	var rimHiddenInput = $('#rim_color');

	$(document).on("click", '.rim_color_wrapper .color-swatch', function () {
		var colorValue = $(this).data('value');
		rimcolorSwatches.removeClass('active');
		$(this).addClass('active');
		rimHiddenInput.val(colorValue);
		// // console.log(colorValue);
		var image_name = "https://cdn.shopify.com/s/files/1/0676/2096/2552/files/tw-rim-" + $('#rim_color').val() + "-" + $('select#wheel_type').val() + ".png";
		$('#resultAreaID_1_1 img').attr('src', image_name);
		tprice();
	});

	// Hub Color
	var hubcolorSwatches = $('.hub_color_wrapper .color-swatch');
	var hubHiddenInput = $('#hub_color');

	$(document).on("click", '.hub_color_wrapper .color-swatch', function () {
		// console.log("vad andavbjda cons");
		var colorValue = $(this).data('value');
		hubcolorSwatches.removeClass('active');
		$(this).addClass('active');
		hubHiddenInput.val(colorValue);
		if ($('select#wheel_type').val() === "REAR") {
			//Display Cush Hub
			var image_name = images + $('select#rim_type').val() + "-hub-" + $('#hub_color').val() + '-' + $('select#wheel_type').val() + ".png";
			var imageArr5 = [image_name];
			var divArr5 = ["resultAreaID_1_0"];
			$('#resultAreaID_1_0 img').attr('src', image_name);
			//sprocket, carrier, and rubbers for Cush 
			var image_name = images + $('#hub_color').val() + "-sprocket-and-carrier.png";
			var imageArr5 = [image_name];
			var divArr5 = ["resultAreaID_1_6"];
			$('#resultAreaID_1_6 img').attr('src', image_name);

			//sprocket, carrier, and rubbers for Cush 
			if ($('#speedometer').css('display') != 'none') {
				// $("#sm_magnets").val('NO');
				if ($("select#sm_magnets").val() == "BLACK" || $("select#sm_magnets").val() == "BLUE" || $("select#sm_magnets").val() == "ORANGE") {
					$("#resultAreaID_1_7").show();
					var image_name = images + "magnet-" + $('select#sm_magnets').val() + '-' + $('select#wheel_type').val() + ".png";
					var imageArr6 = [image_name];
					var divArr6 = ["resultAreaID_1_7"];
					$('#resultAreaID_1_7 img').attr('src', image_name);
				} else if ($("select#sm_magnets").val() == "NO") {
					$("#resultAreaID_1_7").hide();
				} else {
					var image_name = images + "sprocket.png";
					var imageArr6 = [image_name];
					var divArr6 = ["resultAreaID_1_7"];
					$('#resultAreaID_1_7 img').attr('src', image_name);
				}
			} else {
				if ($('select#wheel_type').val() == 'FRONT') {
					$('#resultAreaID_1_7').removeClass("show");
				} else {
					var image_name = images + "rubbers.png";
					var imageArr7 = [image_name];
					var divArr7 = ["resultAreaID_1_7"];
					$('#resultAreaID_1_7 img').attr('src', image_name);
				}
			}


			document.getElementById('resultAreaID_1_6').style.width = '175px';
			document.getElementById('resultAreaID_1_6').style.height = '106px';

			$('#resultAreaID_1_4').show();
		} else {
			var image_name = images + $('select#rim_type').val() + "-hub-" + $('#hub_color').val() + "-" + $('select#wheel_type').val() + ".png";
			var imageArr1 = [image_name];
			var divArr1 = ["resultAreaID_1_0"];
			$('#resultAreaID_1_0 img').attr('src', image_name);

			document.getElementById('resultAreaID_1_6').style.width = '';
			document.getElementById('resultAreaID_1_6').style.height = '';
			document.getElementById('resultAreaID_1_6').style.top = '';

			if ($('#speedometer').css('display') != 'none') {
				// $("#sm_magnets").val('NO');
				if ($("select#sm_magnets").val() == "BLACK" || $("select#sm_magnets").val() == "BLUE" || $("select#sm_magnets").val() == "ORANGE") {
					$("#resultAreaID_1_7").show();
					var image_name = images + "magnet-" + $('select#sm_magnets').val() + '-' + $('select#wheel_type').val() + ".png";
					var imageArr6 = [image_name];
					var divArr6 = ["resultAreaID_1_7"];
					$('#resultAreaID_1_7 img').attr('src', image_name);
				} else if ($("select#sm_magnets").val() == "NO") {
					$("#resultAreaID_1_7").hide();
				} else {
					var image_name = images + "sprocket.png";
					var imageArr6 = [image_name];
					var divArr6 = ["resultAreaID_1_7"];
					$('#resultAreaID_1_7 img').attr('src', image_name);
				}
			} else {
				if ($('select#wheel_type').val() == 'FRONT') {
					$('#resultAreaID_1_7').removeClass("show");
				} else {
					var image_name = images + "rubbers.png";
					var imageArr7 = [image_name];
					var divArr7 = ["resultAreaID_1_7"];
					$('#resultAreaID_1_7 img').attr('src', image_name);
				}
			}
		}
		var colorTitle = $(this).attr('title');
		$('#selected_hub_color').html(colorTitle);

	});

	var nipplecolorSwatches = $('.nipple_color_wrapper .color-swatch');
	var nippleHiddenInput = $('#nipple_color');
	$(document).on("click", '.nipple_color_wrapper .color-swatch', function () {
		var colorValue = $(this).data('value');
		nipplecolorSwatches.removeClass('active');
		$(this).addClass('active');
		nippleHiddenInput.val(colorValue);
		var image_name = images + "nipple-" + $('#nipple_color').val() + "-" + $('select#wheel_type').val() + ".png";
		$('#resultAreaID_1_3 img').attr('src', image_name);
		tprice();
	});

	// Spoke Color
	var spokecolorSwatches = $('.spoke_color_wrapper .color-swatch');
	var spokeHiddenInput = $('#spoke_color');

	$(document).on("click", '.spoke_color_wrapper .color-swatch', function () {
		var colorValue = $(this).data('value');
		spokecolorSwatches.removeClass('active');
		$(this).addClass('active');
		// // console.log(colorValue)
		spokeHiddenInput.val(colorValue);
		if ($('select#cush_drive').val() != "unavailable") {
			//Display Cush Spokes
			var image_name = images + "cush-spokes-" + $('#spoke_color').val() + "-" + $('select#wheel_type').val() + ".png";
			$('#resultAreaID_1_2 img').attr('src', image_name);
		} else {
			//SPOKE COLOR
			var image_name = images + "spokes-" + $('#spoke_color').val() + "-" + $('select#wheel_type').val() + ".png";
			$('#resultAreaID_1_2 img').attr('src', image_name);
		}
		tprice();
	});

	$('select#mtl').change(function () {
		tubelesswheel();
		if ($('select#mtl').val() != "No") {
			$('#mbtire').prop('selectedIndex', 0);
			$('#mbtire option').eq(2).remove();
			$('#resultAreaID_1_10').show();
			var image_name = "https://cdn.shopify.com/s/files/1/0676/2096/2552/files/SM-" + $("select#wheel_type").val() + "-tire650.png";
			var imageArr9 = [image_name];
			var divArr9 = ["resultAreaID_1_10"];
			$('#resultAreaID_1_10 img').attr("src", image_name);
		} else {
			// $('#resultAreaID_1_10').hide();
			if (!$('#mbtire option').filter('[value="mbno"]').length) {
				$('#mbtire').append($('<option>').val('mbno').text('No'));
			}
		}
	});

	$('select#mbtire').change(function () {
		if ($('select#mbtire').val() === "mbyes" || $('select#mbtire').val() === "DG300") {
			$("#resultAreaID_1_10").show();
			var image_name = "https://cdn.shopify.com/s/files/1/0676/2096/2552/files/SM-" + $("select#wheel_type").val() + "-tire650.png";
			var imageArr9 = [image_name];
			var divArr9 = ["resultAreaID_1_10"];
			$('#resultAreaID_1_10 img').attr("src", image_name);
		} else {
			$("#resultAreaID_1_10").hide();
		}
	});

	$('select#brake_rotor').change(function () {

		cushsel = $('#cush_drive');
		if (cushsel.val() == "available") {

		}
		if ($('select#bike_model').val() === "1996 - 2016 DR650 *REAR*" || $('select#bike_model').val() == "790 Adventure *REAR*" || $('select#bike_model').val() == "890 Adventure *REAR*" || $('select#bike_model').val() == "890 Adventure R *REAR*" || $('select#bike_model').val() == "790 Adventure R *REAR*" || $('select#bike_model').val() == "2008 – 2013 KTM 690 ENDURO * REAR *" || $('select#bike_model').val() == "2014 – 2016 KTM 690 ENDURO ABS * REAR *" || $('select#bike_model').val() == "1997-2007 KLR650 *REAR*" || $('select#bike_model').val() == "2008 - Current KLR650 *REAR* " || $('select#bike_model').val() == "2016 - Current 701 Enduro *REAR*") {
			$("#resultAreaID_1_6").attr('style', 'width:150px;height:95px;');
		} else {
			if ($('select#brake_rotor').val() === "320MM_FLOATING") {
				$("#resultAreaID_1_6").attr('style', 'width:185px;height:185px;');
				$(".text").attr('style', 'margin-top: 209px;');
			} else {
				$("#resultAreaID_1_6").attr('style', 'width:185px;height:185px;');
				$(".text").attr('style', 'margin-top: 209px;');
			}
		}
		if ($('select#bike_model').val() == '790 Adventure *FRONT*' || $('select#bike_model').val() == '790 Adventure R *FRONT*' || $('select#bike_model').val() == '890 Adventure *FRONT*' || $('select#bike_model').val() == '890 Adventure R *FRONT*') {
			var image_name = images + "dual-rotor-" + $('select#wheel_type').val() + ".png";
			var imageArr5 = [image_name];
			$('#resultAreaID_1_6 img').attr("src", image_name);
		} else {
			var image_name = images + "brake-" + $('select#brake_rotor').val() + "-" + $('select#wheel_type').val() + ".png";
			var imageArr5 = [image_name];
			$('#resultAreaID_1_6 img').attr("src", image_name);
		}
	});

	var rimcolorSwatches = $('.rim_color_wrapper .color-swatch');
	var rimHiddenInput = $('#rim_color');
	$(document).on("click", '.rim_color_wrapper .color-swatch', function () {
		var colorValue = $(this).data('value');
		rimcolorSwatches.removeClass('active');
		$(this).addClass('active');
		rimHiddenInput.val(colorValue);
		// // console.log(colorValue);
		var image_name = images + $('select#rim_type').val() + "-rim-" + $('#rim_color').val() + "-" + $('select#wheel_type').val() + ".png";
		$('#resultAreaID_1_1 img').attr('src', image_name);
		tprice();
		var colorTitle = $(this).attr('title');
		$('#selected_rim_color').html(colorTitle.replaceAll('-', " "));
	});

	$('select#stem_color').change(function () {
		cushsel = $('#cush_drive');
		if (cushsel.val() == "available") {

		}

		var image_name = images + $('select#rim_type').val() + "-valvestem-" + $('#stem_color').val() + "-" + $('select#wheel_type').val() + ".png";
		var imageArr4 = [image_name];
		var divArr4 = ["resultAreaID_1_3"];
		$('#resultAreaID_1_3 img').attr('src', image_name);

	});

	$('select#rim_type').change(function () {
		cushsel = $('#cush_drive');
		if (cushsel.val() == "available") {

		}
		if ($('select#rim_type').val() == "Switch") {
			var image_name = images + $('select#rim_type').val() + "-rim-" + $('#rim_color').val() + "-" + $('select#wheel_type').val() + ".png";
			var imageArr2 = [image_name];
			var divArr2 = ["resultAreaID_1_1"];
			$('#resultAreaID_1_1 img').attr('src', image_name);

			var image_name = images + $('select#rim_type').val() + "-hub-" + $('#hub_color').val() + '-' + $('select#wheel_type').val() + ".png";
			var imageArr5 = [image_name];
			var divArr5 = ["resultAreaID_1_0"];
			$('#resultAreaID_1_0 img').attr('src', image_name);
		} else {
			var select = $('#rim_color');
			select.empty().append('<option class="category" value="Silver">Silver</option><option class="category" value="Black">Black</option><option class="category" value="Red">Red</option><option class="category" value="Blue">Blue</option><option class="category" value="Gold">Gold</option><option class="category" value="Orange">Orange</option><option class="category" value="Purple">Purple</option><option class="category" value="Magnesium">Magnesium</option>');

			var image_name = images + $('select#rim_type').val() + "-rim-" + $('#rim_color').val() + "-" + $('select#wheel_type').val() + ".png";
			var imageArr2 = [image_name];
			var divArr2 = ["resultAreaID_1_1"];
			$('#resultAreaID_1_1 img').attr('src', image_name);

			var image_name = images + $('select#rim_type').val() + "-hub-" + $('#hub_color').val() + '-' + $('select#wheel_type').val() + ".png";
			var imageArr5 = [image_name];
			var divArr5 = ["resultAreaID_1_0"];
			$('#resultAreaID_1_0 img').attr('src', image_name);
		}
		var image_name = images + $('select#rim_type').val() + "-valvestem-" + $('#stem_color').val() + "-" + $('select#wheel_type').val() + ".png";
		var imageArr4 = [image_name];
		var divArr4 = ["resultAreaID_1_3"];
		$('#resultAreaID_1_3 img').attr('src', image_name);
		//Mounted Tire
		if ($('select#wheel_type').val() === "REAR") {
			if ($('select#rim_type').val() === "Switch") {
				$("#resultAreaID_1_10").addClass("switch-img");
				$("#resultAreaID_1_10").removeClass("rear-wheel");
			} else {
				$("#resultAreaID_1_10").addClass("rear-wheel");
				$("#resultAreaID_1_10").removeClass("switch-img");
			}
		}
		//Mounted Tire End

	});

	//Mounted/Balanced Tire Field Code
	$('select#mbtire').change(function () {
		if ($('select#mbtire').val() === "mbyes" || $('select#mbtire').val() === "DG300") {


			var image_name = images + "Tubeless-" + $("select#wheel_type").val() + "-tire650.png";
			var imageArr9 = [image_name];
			var divArr9 = ["resultAreaID_1_10"];
			$('#resultAreaID_1_10 img').attr('src', image_name);
			$("#resultAreaID_1_10").show();
			$('#resultAreaID_1_10 a').click(function () {
				return false
			});
			if ($('select#wheel_type').val() === "REAR") {
				$("#resultAreaID_1_10, #resultAreaID_1_0, #resultAreaID_1_1, #resultAreaID_1_2, #resultAreaID_1_3, #resultAreaID_1_4, #resultAreaID_1_5").addClass("tire-img");
				$("#resultAreaID_1_10, #resultAreaID_1_0, #resultAreaID_1_1, #resultAreaID_1_2, #resultAreaID_1_3, #resultAreaID_1_4, #resultAreaID_1_5").removeClass("wheel");
			} else {
				$("#resultAreaID_1_10, #resultAreaID_1_0, #resultAreaID_1_1, #resultAreaID_1_2, #resultAreaID_1_3, #resultAreaID_1_4, #resultAreaID_1_5").removeClass("tire-img");
				$("#resultAreaID_1_10, #resultAreaID_1_0, #resultAreaID_1_1, #resultAreaID_1_2, #resultAreaID_1_3, #resultAreaID_1_4, #resultAreaID_1_5").addClass("wheel");
			}
		} else {
			$("#resultAreaID_1_10").hide();
		}
	});

	$('select#bike_model').change(bikeyear);
	$('select#bike_make').change(bikeyear);
	$('select#bike_model').change(speedometer);
	$('select#bike_make').change(speedometer);
	$('select#wheel_type').change(speedometer);

	//Total Price
	$('select#bike_make').change(tprice);
	$('select#bike_model').change(tprice);
	$('select#carrier_id').change(tprice);
	$('select#rim_size').change(tprice);
	$('select#brake_rotor').change(tprice);
	$('select#sprocket_size').change(tprice);
	$('select#wheel_type').change(tprice);
	$('select#rim_type').change(tprice);
	$('select#cush_drive').change(tprice);
	$('select#sprocket_bolts').change(tprice);
	$('select#rotor_bolts').change(tprice);
	$('select#sm_magnets').change(tprice);
	$('select#mbtire').change(tprice);
	$(document).on('change', 'select, input', function () {
		tprice();
	});
	// change year on wheel type
	$('select#wheel_type').change(bikeyear);

	// Function to transform the fieldName
	function transformFieldName(name) {
		return name.replace(/_/g, ' ')
			.replace(/\w\S*/g, function (txt) {
				return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
			});
	}

	// Function to transform the fieldValue
	function transformFieldValue(value) {
		return value ? value.charAt(0).toUpperCase() + value.substr(1).toLowerCase() : value;
	}

	function collectFormData() {
		var formDataArray = [];
		$('#custom-wheel-form select, #custom-wheel-form input[type="text"], #custom-wheel-form input[type="hidden"]').each(function () {
			var fieldName = $(this).attr('name');
			var fieldValue = $(this).val();
			if (fieldName) {
				var fieldData = {
					name: transformFieldName(fieldName),
					value: transformFieldValue(fieldValue)
				};
				formDataArray.push(fieldData);
			}
		});
		return formDataArray;
	}

	$('.act-btn-custom').on('click', function () {
		var selectedvariant = $('#custom-wheel-form').attr("data-variantid");
		var totalpersonalizeitem = parseInt(new_base_price - base_price) / 0.01;
		var title = $('.product-info-heading ').text();
		// // console.log(base_price, new_base_price, totalpersonalizeitem);

		var withtire = 45197126762744;
		var withouttire = 45197126795512;
		var tirevalue = $('select#mbtire').val();
		selectedvariant = withouttire;

		var rim_size = document.querySelector('#rim_size').value;
		var wheel_type = document.querySelector('#wheel_type').value;
		var has_tire = document.querySelector('#mbtire').value;
		
		if(wheel_type == "FRONT"){
			if(has_tire!="mbno"){ // HAS TIRE
				if(rim_size.includes('17')){
					selectedvariant = 45907889684728;
				}
			}else{ // NO TIRE
				if(rim_size.includes('17')){
					selectedvariant = 45907888767224;
				}
			}
		}else{
			if(has_tire!="mbno"){ // HAS TIRE
				if(rim_size.includes('17')){
					selectedvariant = 45907889979640;
				}
			}else{ // NO TIRE
				if(rim_size.includes('17')){
					selectedvariant = 45907889324280;
				}
			}
		}

		var formData = collectFormData();
		if($('#wheel_type').val() == "FRONT"){
			formData = formData.filter(function(item) {
				return item.name !== "Sprocket Bolts" && item.name !== "Sprocket Size";
			}); 
		}
		var properties = {};
		formData.forEach(function (field) {
			properties[field.name] = field.value;
		});
		properties['__extraPricing'] = totalpersonalizeitem;
		let newObject = {
			product: title,
			__parentVariant: selectedvariant
		};

		let wbproperties = {
			...newObject,
			...properties
		};
		properties['__price'] = new_base_price;

		// var requestData = {
		//     items: [
		//         {
		//             quantity: totalpersonalizeitem, // Adjust the quantity as needed
		//             id: 44252901507320, // Use your actual product ID\
		//             properties: wbproperties
		//         },
		//         {
		//             quantity: 1, // Adjust the quantity as needed
		//             id: selectedvariant, // Use your actual product ID
		//             properties: properties
		//         }                
		//     ]
		// };
		var requestData = {
			items: [{
				quantity: 1, // Adjust the quantity as needed
				id: selectedvariant, // Use your actual product ID
				properties: properties
			}]
		};


		const bikeModelSelect = document.getElementById("bike_model");
		const selectedModelText = bikeModelSelect.options[bikeModelSelect.selectedIndex].text;

		requestData.items[0].properties["Bike Model"] = selectedModelText;

		$.ajax({
			url: "/cart/add.js",
			type: "POST",
			data: JSON.stringify(requestData),
			contentType: "application/json",
			dataType: 'json',
			success: function (response) {
				// // console.log("Item added to the cart successfully.", response);
				window.location.href = "/cart";
			},
			error: function (xhr, status, error) {
				// console.log("Error adding item to the cart.", status, error);
			}
		});
	});


	$('.product.product-page').addClass('init');

});